export const excisting_types = [
  "-",
  "-",
  "- 12/03/2012-24/02/2032 EUR - GR0A33010577",
  "- 24.02.2012-15.10.2042",
  "- 24.02.2012-24.02.2036",
  "- EXEMPT STEP CPN 12/03/2012-24/02/2040",
  "- ΞΕΝΟΔΟΧΕΙΑΚΩΝ, ΤΟΥΡΙΣΤΙΚΩΝ ΚΑΙ ΝΑΥΤΙΛΙΑΚΩΝ ΕΠΙΧΕΙΡΗΣΕΩΝ",
  "ALICA-Άλλες περιπτώσεις | 2002",
  "ALPHA BANK WARRANTS",
  "Inform Λοκος",
  "INVEST PLUS 3",
  "KOIN. ONM. MET. - METOXH",
  "Mερίδια αμοιβαίων κεφαλαίων (Templeton global Income)",
  "Mετοχές ημεδαπών εισηγμένων εταιριών (Alpha Bank)",
  "Mετοχές ημεδαπών εισηγμένων εταιριών (Motor oil)",
  "Mετοχές ημεδαπών εισηγμένων εταιριών (Εθνική Warrant)",
  "Mετοχές ημεδαπών εισηγμένων εταιριών (Εθνική Τράπεζα)",
  "Mετοχές ημεδαπών εισηγμένων εταιριών (Μυτιληναίος ΑΕ)",
  "Mετοχές ημεδαπών εισηγμένων εταιριών (ΟΤΕ ΑΕ)",
  "Oμόλογα (Australian Gov.4,75)",
  "WARRANTS (Eurobank)",
  "Αγροτική Τράπεζα (Κοιν. Ονομ. μετοχής)",
  "Άλλες περιπτώσεις",
  "Άλλες περιπτώσεις - ALPHA BANK (WARRANTS TXΣ)",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ - DUAL FORMULA",
  "Άλλες περιπτώσεις - EUROPLAN GLEXI",
  "Άλλες περιπτώσεις - FLEXI PLUS",
  "Άλλες περιπτώσεις - MS GLOBAL",
  "Άλλες περιπτώσεις - PROTON BANK",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ - REPOS",
  "Άλλες περιπτώσεις - ΑΤΕ",
  "Άλλες περιπτώσεις - Αχαϊκή Τράπεζα",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ - ΔΕΝ ΕΙΝΑΙ ΚΑΤΑΝΟΗΤΟ ΑΠΟ ΤΟΝ ΒΟΥΛΕΥΤΗ",
  "Άλλες περιπτώσεις - ΕΘΝΙΚΗ",
  "Άλλες περιπτώσεις - ΕΘΝΙΚΗ ΑΣΦΑΛΙΣΤΙΚΗ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΑΕ (ΚΟ)",
  "Άλλες περιπτώσεις - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ (WARRANTS ΤΧΣ)",
  "Άλλες περιπτώσεις - ΠΑΓΚΡΗΤΙΑ ΤΡΑΠΕΖΑ",
  "Άλλες περιπτώσεις - Πειραιώς Μετοχικό",
  "Άλλες περιπτώσεις - Συνεταιρικές Μερίδες Παγκράτιας Συν/κης Τράπεζας",
  "Άλλες περιπτώσεις - Συνεταιριστικές Μερίδες Παγκρήτιας Συν/κης Τράπεζας",
  "Άλλες περιπτώσεις - Συνεταιριστική Τράπεζα Έβρου",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ - ΣΥΝΤΑΞ. INVEST",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ - ΣΥΝΤΑΞΗ INVEST",
  "Άλλες περιπτώσεις - ΤΡΑΠΕΖΟΑΣΦΑΛΙΣΤΙΚΟ GREEK TOP 20",
  "Άλλες περιπτώσεις ( Συν/κη Τράπεζα Δυτικής Μακεδονίας)",
  "Άλλες περιπτώσεις (COUTTS & CO)",
  "Άλλες περιπτώσεις (ETE WARRANTS)",
  "Άλλες περιπτώσεις (Euro)",
  "Άλλες περιπτώσεις (Eurobank Flexi)",
  "Άλλες περιπτώσεις (EUROCORP SECURE)",
  "Άλλες περιπτώσεις (Flexi Plus)",
  "Άλλες περιπτώσεις (GBP)",
  "Άλλες περιπτώσεις (GREEK TOP 20 BONUS)",
  "Άλλες περιπτώσεις (INVEST 2)",
  "Άλλες περιπτώσεις (PROTON BANK AE)",
  "Άλλες περιπτώσεις (Repos)",
  "Άλλες περιπτώσεις (VALUE)",
  "Άλλες περιπτώσεις (WARRANTS)",
  "Άλλες περιπτώσεις (Αποταμιευτικό επιβίωσης 15 ετών)",
  "Άλλες περιπτώσεις (αποταμιευτικό προγραμμα) - ΑΣΠΙΣ ΠΡΟΝΟΙΑ",
  "Άλλες περιπτώσεις (ασφαλιστήρια ζωής) - Eurolife ERB (Flexi Plus)",
  "Άλλες περιπτώσεις (ασφαλιστικό συμβόλαιο) - ΔΕΚΑΕΤΕΣ ΑΣΦΑΛ. ΖΩΗΣ - ΕΠΕΝΔ.",
  "Άλλες περιπτώσεις (ΔΙΚ ΑΛΦΑ ΤΡΑΠΕΖΑ)",
  "Άλλες περιπτώσεις (ΔΙΚ. ΑΛΦΑ ΤΡΑΠΕΖΑ)",
  "Άλλες περιπτώσεις (Εθν. Ασφαλιστική)",
  "Άλλες περιπτώσεις (Εθνική Ασφαλιστική)",
  "Άλλες περιπτώσεις (Εθνική Σύνταξη)",
  "Άλλες περιπτώσεις (Εθνική Σύνταξη)",
  "Άλλες περιπτώσεις (Εθνική Τράπεζα)",
  "Άλλες περιπτώσεις (ΕΥΔΑΠ)",
  "Άλλες περιπτώσεις (με σύζυγο) - Φροντίζω Μιν.",
  "Άλλες περιπτώσεις (Παγκρήτια συν. τράπεζα)",
  "Άλλες περιπτώσεις (ΠΑΓΚΡΗΤΙΑ ΣΥΝ/ΚΗ ΤΡΑΠΕΖΑ",
  "Άλλες περιπτώσεις (Παγκρήτια Τράπεζα)",
  "Άλλες περιπτώσεις (Συν. Τράπ. Δωδ/σου)",
  "Άλλες περιπτώσεις (Συν/κες μερίδες Παγκρήτιας Συν/κης Τράπεζας)",
  "Άλλες περιπτώσεις (Συν/κες μερίδες Παγκρήτιας Τράπεζας)",
  "Άλλες περιπτώσεις (Συν/κη Τράπεζα Καρδίτσας)",
  "Άλλες περιπτώσεις (Συνεταιριστική μερίδα)",
  "Άλλες περιπτώσεις (Τράπεζα Ηπείρου)",
  "Άλλες περιπτώσεις (Φροντιζ. Μιν.)",
  "Άλλες περιπτώσεις (χρυσές λίρες Αγγλίας)",
  "Άλλες περιπτώσεις ΕΘΝΙΚΗ ΣΥΝΤΑΞΗ",
  "Άλλες περιπτώσεις Εθνική τράπεζα ΟΕΔ",
  "Άλλες περιπτώσεις Εθνική τράπεζα Τίτλοι Α.Ε.Π.",
  "Άλλες περιπτώσεις-ΣΥΝΕΤ. ΤΡΑΠ. ΔΩΔ/ΣΟΥ",
  "ΑΛΛΗ - 144928 ΣΥΜΒΟΛΑΙΟ",
  "ΑΛΛΗ - Franklin Templeton lnv.SICAV Latin",
  "ΑΛΛΗ - NUVEEN ASST INC&",
  "ΑΛΛΗ - PARVEST -",
  "Άλλη περίπτωησε από κοινού με σύζυγο bnp insticash fund - usd",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - 'NN(L)-JAPAN EQUITY 'P'-C.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - 0072018672- EUR CASH ACCOUNT",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - 144927 ΣΥΜΒΟΛΑΙΟ ΑΤΟΜΙΚΟ ΖΩΗΣ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - 144928 ΣΥΜΒΟΛΑΙΟ ΑΤΟΜΙΚΟ ΖΩΗΣ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - 144929 ΣΥΜΒΟΛΑΙΟ ΑΤΟΜΙΚΟ ΖΩΗΣ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - 3Y USD 95PP LINKED TO ISTOXX GLOBAL 0419 C",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - 3Y USD PP NOTE LINKED TO GE AND SIEMENS 0318 SG",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - 4Y EUR 100 PP FB, APPLE, BAYER, SANTANDER, VOD 0815 EEA SG",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - BGF WLD GOLD SHS- A2-CAPITALISATION",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - BLACK ROCK GLOBAL ALLOCATION FUND 'A2'-C.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - BLACKROCK BSF FIXED INCOME STRATEGIES FUND",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - BLACKROCK GF EUROPEAN EQ.INC. 'A'-C.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - BlackRock Glob.Euro.Eq.lncameFd .Shs A2 -Cap.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - BlackRock Glob.SICAV Allocation Fd.Shs A2-",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - BlackRock Glob.SICAV World Gold Fd.Shs A2RF-Cap.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - BLACKROCK RECOURCES & COMMOD",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - BLACKROCK-GLOBAL DYNAMIC EQ.'A2'-C",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - BLACKROCK-WORLD HEALTHSCIENCE'A2'- C",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - BNP INSTICASH EUR",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - BNP PARIBAS INSTICASH EUR",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - CASH",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - CASH ACCOUNT",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - DEUTSCHE BANK ZINS & DIVIDENDE INH. ANT. O.N",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - DICRETIONARY ASSET MANAGEMENT (ΜΕΣΑΙΟΥ ΚΙΝΔΥΝΟΥ)",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - DISCRETIONARY ACCOUNT",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - DISCRETIONARY ASSET MANAGEMENT ( ΜΕΣΑΙΟΥ ΚΙΝΔΥΝΟΥ)",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - DISCRETIONARY ASSET MANAGEMENT (ΧΑΜΗΛΟΥ ΚΙΝΔΥΝΟΥ)",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - DWS STRATEGIC DEFENSIVE INH. ANTEILE LD ON.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - DWS STRATEGIC DEFENSIVE INH. ATNTEILE LD O.N",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - EMPORIKI ΕΙΣΟΔΗΜΑ(****5863)",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ETE WARRENT",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ETFS AGRICULTURE DJ UBSCI",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - EURO",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - EUROBANK FLEXI",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - F. TEMPETON- EUROLAND FUND 'A'- C",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - F.TEMPLETON-ASIAN GROWTH FUND'A'-C",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - FDIC INSURED DEPOSIT CITIBANK",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - FIDELITY GOVERNMENT MMK",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - FIDELITY GOVERNMENT MMT",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - FRAGLIN TEMPLETON TECHNOLOGY 'A'-C.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - FRANKLIN ALTERNATIVE STRATEGIES FUND(I)",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - Franklin Templeton Eur. S-M Gr 'A (ACC)'C",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - Franklin Templeton Inv.Euro.Small-Mid Cap Growth Fd.ShsA",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - Franklin Templeton INVEST. INDIA 'A-C'",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - Franklin Templeton Latin America 'A'-C.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - Franklin Templeton lnv.SICAV India Fd.ShsA Cap.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - Franklin Templeton lnv.SICAV Tech.Fd.ShsA Cap.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - Franklin Templeton lnv.SICAV U.S.Opp.Fd.ShsA Cap.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - Franklin Templeton lnv.SICAV World Perspectives Fd.Shs A Cap.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - FRANKLIN TEMPLETON TECHNOLOGY 'A'-C.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - Franklin Templeton U.S. OPPORTUNITIES 'A'- C",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - Franklin Tl World Perspect. 'A (ACC)'-C.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - GAMCO GLOBAL GOLD NATURE",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - GBP",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - GREEK GOVT HELLENIC REPUBLIC SECURITIES",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - GREEK TOP 20 BONUS",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - GRUNDBESITZ EUROPA INHABER - ANTEILE RC",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - HELLENIC REPUBLIC 24.02.2012-15.10.2042",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - INDIVIDUAL RETIREMENT ACCOUNT (IRA) ΣΥΝΤΑΞΙΟΔΟΤΙΚΟ ΠΡΟΓΡΑΜΜΑ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ING (B) Collect Portfolio Core Fd.Bolonced Shs Cap. (55 % equities)",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ING CORE FUND BALANCED -C",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - INVEST 2",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ISHARES EUROPEAN PROPERTY YIELD",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - J P MORGAN CHASE BANK TERM CASH",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - JP MORGAN CHASE BANK SHORT TERM CASH",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - JP MORGAN CHASE BANK TERM CASH",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - JPMORGAN GLOBAL INCOME FUND(C-DIS",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - JPMORGAN GLOBAL MACRO FUND (I-HDG)",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - KEF + LILLIUM XXXVIN EUR",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - LGT MULTI-ASSETS SICAV",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - LMP REAL ESTATE INCOME FUND",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN (L) Banking & Insurance 'P'-C.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN (L) Banking & Insurance Shs P (hedged ii)-Cap.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN (L) Consumer Goods 'P'-C.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN (L) Consumer Goods Shs P-Cap.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN (L) Em.Eur.Eq.Shs P-Cap.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN (L) Energy 'P'-C.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN (L) Energy Shs P- Cap.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN (L) Food & Beverages 'P'-C.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN (L) Food & Beverages Shs P-Cap.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN (L) Gl Eq lmOp Shs P- CAPITALISATION.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN (L) INDUSTRIALS 'P'-C.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN (L) lnd.Shs P-Cap.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN (L) SICAV Glob.Eq.lmpact Opp.Shs P- Cap.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN (L) US Enhanced Core Concentrated Eq.Shs P-Cap.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN (L) US High Dividend 'P'-C.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN (L) US High DividendShs P-Cap.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN(L)-EMERGING EUROPE EQ. 'P'-C.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN(L)-EUROPEAN HIGH DIVIDEND 'P'-C",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN(L)-FOOD & BEVERAGES 'P' - HEDGE-C",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN(L)-HEALTH CARE 'P'-C",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN(L)-INFORMATION TECH. 'P'-EUR-C",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN(L)-JAP. EQ.SHS P- CAP",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NN(L)-US ENH. CORE CONC. 'P'-K.",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - NUVEEN REAL ASSET INCOME",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - PICTET-ABSOLUTE RETURN FIXED INCOME(HDG)",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - RAIFFEISEN 9,35 RC ON ALLERGAN,BAYER,NO VARTIS 27/02/20",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - SAFE BULKERS INC",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - SMILE ΣΥΝΤΑΞΗ GOLD(****0654)",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - SPDR GOLD TRUST",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - SPOT ΜΕΤΡΗΤΑ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - TRITON ΔΙΑΧ ΔΙΑΘΕΣΙΜΩΝ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - USD",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - VALUE",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΑΠΟΤΑΜΙΕΥΤΙΚΟ ΕΠΙΒΙΩΣΗΣ 15 ΕΤΩΝ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΑΣΦΑΛΕΙΑ ΖΩΗΣ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΑΣΦΑΛΙΣΤΙΚΟ ΠΡΟΓΡΑΜΜΑ ΥΓΕΙΑΣ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΔΗΛΟΣ BLUE CHIPS",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΔΗΛΟΣ BLUE CHIPS ΜΕΤΟΧΙΚΟ ΕΞΩΤΕΡΙΚΟΥ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΔΗΛΟΣ SMALL CAP",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΔΗΛΟΣ SMALL CAP ΜΕΤΟΧΙΚΟ ΕΞΩΤΕΡΙΚΟΥ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ Α.Ε. (ΤΠΔ) - WARRANTS",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΕΝΚΛΩ ΕΝΩΜ.ΚΛΩΣΤ.ΑΕ ΣΕ ΑΝΑΣΤΟΛΗ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΕΝΤΟΚΟ ΓΡΑΜΜΑΤΙΟ ΕΛΛΗΝΙΚΟΥ ΔΗΜΟΣΙΟΥ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΖΩΗΣ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΖΩΗΣ ΣΥΝΔΕΔΕΜΕΝΟ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΚΕΦ+3Υ OPTIMUM XXVI IN EUR",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΚΕΦΑΛΑΙΟ PLUS ABSOLUTE + IN ARREARS VII",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΜΕΡΙΔΑ ΣΥΝΕΤΑΙΡΙΣΤΙΚΗΣ ΤΡΑΠΕΖΑΣ ΔΩΔΕΚΑΝΗΣΟΥ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΜΕΡΙΔΕΣ ΣΥΝΕΤΑΙΡΙΣΤΙΚΗΣ ΤΡΑΠΕΖΑΣ ΔΩΔΕΚΑΝΗΣΟΥ ΥΠΟ ΕΚΚΑΘΑΡΙΣΗ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΜΕΡΙΔΙΑ ΠΑΓΚΡΗΤΙΑΣ ΤΡΑΠΕΖΑΣ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΜΕΡΙΔΙΑ ΣΥΝΕΤΕΡ.ΤΡΑΠΕΖΑΣ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΜΕΡΙΣΜΑΤΑ ΜΕΤΟΧΩΝ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΠΙΣΤΩΤΙΚΟ ΥΠΟΛΟΙΠΟ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΠΡΟΘΕΣΜΙΑΚΗ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΠΡΟΘΕΣΜΙΑΚΗ ΚΑΤΑΘΕΣΗ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΡΕΥΣΤΟΤΗΤΑ ΜΕΤΡΗΤΑ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΣΥΝΕΤΑΙΡΙΣΤΙΚΕΣ ΜΕΡΙΔΕΣ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΣΥΝΕΤΑΙΡΙΣΤΙΚΕΣ ΤΡΑΠΕΖΙΚΕΣ ΜΕΡΙΔΕΣ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΣΥΝΕΤΑΙΡΙΣΤΙΚΕΣ ΤΡΑΠΕΖΙΚΕΣ ΜΕΡΙΔΕΣ-ΤΡΑΠΕΖΑ ΗΠΕΙΡΟΥ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΣΥΝΕΤΑΙΡΙΣΤΙΚΕΣ ΤΡΑΠΕΖΙΚΕΣ ΜΕΡΙΔΣ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΜΕΡΙΔΑ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΛΕΣΒΟΥ ΛΗΜΝΟΥ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΣΥΝΤΑΞΙΟΔΟΤΙΚΟ ΠΡΟΓΡΑΜΜΑ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΤΡΑΠΕΖΟΑΣΦΑΛΙΣΤΙΚ Ο ΠΡΟΙΟΝ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΦΡΟΝΤΙΖΩ ΜΗΝΙΑΙΟ",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΦΡΟΝΤΙΖΩ ΣΥΔΙΠΕΛ (******6707",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ - ΧΡΗΜΑΤΙΣΤΗΡΙΑΚΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "Αμοιβαία Κεφάλαια (Interamerican)",
  "Αμοιβαία κεφάλαια (Interamerican) - Συνδικαιούχος με συγγενή",
  "Αμοιβαία κεφάλαια Πειραιώς (Πειραιώς μετοχικό εσωτερικό)",
  "Αμοιβαία Κεφάλαια Πίστεως (Alpha Bank)",
  "Αμοιβαίο - Πειραιώς",
  "Αμοιβαίο καφάλαιο / INTERAMERICAN",
  "Αμοιβαίο κεφάλαιο (ING Μετοχικό Εσωτερικού)",
  "ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ -",
  "ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - CAP",
  "ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EURO",
  "ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EUROPEAN STR EQ FA",
  "ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - FUND(DIS-HDG-I)",
  "ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - GOLD A2 EUR",
  "ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - INCOME FUND USD A- H ACC",
  "ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - RESERVE",
  "ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - TURKEY",
  "ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΔΥΝΑΜΙΚΩΝ ΕΠΙΧΕΙΡΗΣΕΩΝ",
  "ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΕΣΩΤΕΡΙΚΟΥ",
  "ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΕΣΩΤΕΡΙΚΟΥ- GRF000113008",
  "ΑΠΟΚΤΗΣΗ ΣΕ ΠΡΟΗΓΟΥΜΕΝΗ ΧΡΗΣΗ - ΜΕΤΟΧΕΣ",
  "ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - CASH VALUE",
  "ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΣΥΜΒΟΛΑΙΟ SMILE ΣΥΝΤΑΞΗ",
  "Ασφαλιστικό Πρόγραμμα ΝΝ (196923 Συμβόλαιο)",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2023",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2024",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2025",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2026",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2027",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2028",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2029",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2030",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2031",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2032",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2033",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2034",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2035",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2036",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2037",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2038",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2039",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2040",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2041",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΕΔ 2012-2042",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΜΟΛΟΓΟ BN BNP - SY",
  "Ατομική επιχείρηση από κοινού με σύζυγο ΟΜΟΛΟΓΟ EFSF",
  "Αχαϊκή Τράπεζα",
  "Δε συμπληρώθηκε από το βουλευτή",
  "Δε συμπληρώθηκε απο το βουλευτή (Μόνο μεταβολές)",
  "Δε συμπληρώθηκε από τον βουλευτή",
  "Δεν έχει συμπληρωθεί",
  "Δεν έχει συμπληρωθεί - Συν/κη Τράπεζα Θεσ/κης",
  "Δεν έχει συμπληρωθεί - Συνεταιριστική Τράπεζα Καρδίτσας",
  "Δεν έχει συμπληρωθεί από τον βουλευτή",
  "Δεν σημειώθηκε από τον βουλευτή",
  "Δεν συμπληρώθηκε",
  "Δεν συμπληρώθηκε (Πιστωτικός συνεταιρισμός Τρικάλων)",
  "Δεν συμπληρώθηκε από την βουλευτίνα",
  "Δεν συμπληρώθηκε από τον βουλευτή",
  "Ε.Τ.Ε.",
  "Εθνική Ασφαλιστική",
  "ΕΛΑΚΤΩΡ (Μετοχές εισηγμένων εταιριών) Αγορά:1999",
  "ΕΠΕΝΔΥΤΙΚΑ - ANNUITY LIFE INS",
  "ΕΠΕΝΔΥΤΙΚΑ - ΑΣΦΑΛΙΣΤΗΡΙΟ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - 1000361159",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - 1000411334",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - 1000567062",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - 7244282",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - 7245044",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - 9444031",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - 9444032",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ACCELERATOR PLUS",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ACCELERATOR PLUS 2",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ACCELERATOR PLUS 2.00",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ALPHA ΠΡΟΟΠΤΙΚΗ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ALPHA ΠΡΟΟΠΤΙΚΗ ΑΡ ΣΥΜΒΟΛΑΙΟΥ 139194",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ALPHA ΣΧΕΔΙΟ ΖΩΗΣ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ANNUITY LIFE INS CASH VALUE",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - CNP ΖΩΗΣ Α.Α.Ε",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - DAF",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - EUROLIFE ERB",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - FLEXI PLUS",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - FLEXI PLUS ΑΡ: 1000688857",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - FLEXI PLUS ΑΡ:1000688857",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ING",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - INS CASH VALUE",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - INSURANCE CASH VALUE",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - KEF+ 3Y OPTIMUM XI IN EUR",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - KEF+ LILLIUM ELITE XIV IN EUR",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - KEF+3Y OPTIMUM XI IN EUR",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - METLIFE ALICO PENSION PLUS ΜΕ ΑΡΙΘΜΟ 3001024339",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - METLIFE ALICO PENSION PLUS ΜΕ ΑΡΙΘΜΟ 3001024340",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - METLIFE ALICO PENSION PLUS ΜΕ ΑΡΙΘΜΟ 3001024341",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - METLIFE ALICO QUALITY PLUS ΜΕ ΑΡΙΘΜΟ 3300000558",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - METLIFE ALICO QUALITY PLUS ΜΕ ΑΡΙΘΜΟ 3300000560",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - METLIFE ALICO QUALITY PLUS ΜΕ ΑΡΙΘΜΟ 3300000561",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - NN ULTIMA",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - NN ΒΙΒΛΙΑΡΙΟ ΣΠΟΥΔΩΝ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - PRIVATE PENSION",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - PRIVATE PENSION PLAN",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - SMART PLAN",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - SMART PLAN 08301590",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - TRIPLE LINK III",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ULTRA PLAN NN",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - UNIT LINKED",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - XL20IV",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΑΣΠΙΣ ΠΡΟΝΟΙΑ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΑΣΦΑΛΕΙΑ ΖΩΗΣ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΑΣΦΑΛΗΣΤΗΡΙΟ Ν 244834",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΑΣΦΑΛΙΣΤΗΡΙΟ 08252768",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΑΣΦΑΛΙΣΤΗΡΙΟ 1000871757",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΑΣΦΑΛΙΣΤΗΡΙΟ ING ΠΕΙΡΑΙΩΣ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΑΣΦΑΛΙΣΤΗΡΙΟ ΖΩΗ ΣΥΝΔΕΔΕΜΕΝΟ ΜΕ ΕΠΕΝΔΥΣΕΙΣ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΑΣΦΑΛΙΣΤΗΡΙΟ ΖΩΗΣ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΑΣΦΑΛΙΣΤΗΡΙΟ ΖΩΗΣ 1000855377",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΑΣΦΑΛΙΣΤΗΡΙΟ ΖΩΗΣ ΣΥΝΤΑΞΙΟΔΟΤΗΣΗΣ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΑΣΦΑΛΙΣΤΗΡΙΟ ΖΩΗΣ ΤΥΠΟΥ UNIT LINK",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΑΣΦΑΛΙΣΤΗΡΙΟ ΣΥΜΒΟΛΑΙΟ 02000333",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΑΣΦΑΛΙΣΤΗΡΙΟ ΣΥΜΒΟΛΑΙΟ SMILE ΣΥΝΤΑΞΗ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΑΣΦΑΛΙΣΤΗΡΙΟ ΣΥΜΒΟΛΑΙΟ ΙΣΟΒΙΑΣ ΒΑΣΙΚΗΣ ΑΣΦΑΛΙΣΗΣ ΖΩΗΣ ΓΙΑ ΕΓΓΥΗΜΕΝΟ ΚΕΦΑΛΑΙΟ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΑΣΦΑΛΙΣΤΗΡΙΟ ΣΥΜΒΟΛΑΙΟ ΜΕ ΑΡΙΘΜΟ 08376572",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΑΣΦΑΛΙΣΤΗΡΙΟ ΣΥΜΒΟΛΑΙΟ ΜΕ ΑΡΙΘΜΟ 08376578",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΑΣΦΑΛΙΣΤΗΡΙΟ ΣΥΜΒΟΛΑΙΟ: SMILE ΣΥΝΤΑΞΗ EXPRESS",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΑΣΦΑΛΙΣΤΙΚΟ ΕΠΕΝΔΥΤΙΚΟ ΑΠΟΤΑΜΙΕΥΤΙΚΟ ΠΡΟΓΡΑΜΜΑ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΑΣΦΛΙΣΤΗΡΙΟ ΣΥΜΒΟΛΑΙΟ ΜΕ ΑΡΙΘΜΟ 08376563",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΔΗΜΙΟΥΡΓΙΑ ΚΕΦΑΛΑΙΟΥ EASY",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΔΗΜΙΟΥΡΓΙΑ ΚΕΦΑΛΑΙΟΥ EASY LIFE",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΔΗΜΙΟΥΡΓΙΑ ΚΕΦΑΛΑΙΟΥ EASY PLUS",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΔΗΜΙΟΥΡΓΙΑ ΚΕΦΑΛΑΙΟΥ ΜΙΚΤΗ ΑΣΦΑΛΙΣΗ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΕΓΓΥΗΜΕΝΟ ΚΕΦΑΛΑΙΟ FLEXI PLUS ΑΣΦΑΛΙΣΤΗΡΙΟ ΖΩΗΣ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΕΘΝΙΚΗ ΑΣΦΑΛΙΣΤΙΚΗ ΚΛΑΔΟΣ ΑΤΟΜΙΚΩΝ ΑΣΦΑΛΕΙΩΝ ΖΩΗΣ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΕΠΕΝΔΥΤΙΚΟ/ΑΣΦΑΛΙ ΣΤΙΚΟ/ΑΠΟΤΑΜΙΕΥΤΙΚ Ο ΠΡΟΓΡΑΜΜΑ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΕΠΕΝΔΥΤΙΚΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΕΦΑΠΑΞ ΕΘΝΙΚΗΣ +",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΕΦΑΠΑΞ ΕΘΝΙΚΗΣ + S44E 2096365",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΕΦΑΠΑΞ ΕΘΝΙΚΗΣ 10",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΕΦΑΠΑΞ ΕΘΝΙΚΗΣ 10, 18Η ΕΚΔΟΣΗ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΕΦΑΠΑΞ ΕΘΝΙΚΗΣ 15",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΕΦΑΠΑΞ ΕΘΝΙΚΗΣ ΑΣΦΑΛΙΣΤΙΚΗΣ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΚΕΦΑΛΑΙΟ PLUS ABSOLUTE+IN ARREARS XI",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΛΟΓΑΡΙΑΣΜΟΣ ΑΠΟΤΑΜΙΕΥΣΗΣ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΝΝ ORANGE GENIUS",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΝΝ ΑΕΕΑ ΖΩΗΣ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΝΝ ΕΑΑΕ ΖΩΗΣ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΝΝ ΠΕΙΡΑΙΩΣ ΠΑΙΔΙ ΚΑΙ ΜΕΛΛΟΝ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΠΡΟΓΡΑΜΜΑ XL20V, EUROLIFE ERB,ΑΡ.ΣΥΜ.10007061 94",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΠΡΟΣΘΕΤΩ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΣΥΝΤΑΞΗ INVEST",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΣΥΝΤΑΞΙΟΔΟΤΙΚΟ ΑΣΦΑΛΙΣΤΗΡΙΟ ΖΩΗΣ",
  "ΕΠΕΝΔΥΤΙΚΑ ΑΣΦΑΛΙΣΤΙΚΑ ΣΥΜΒΟΛΑΙΑ - ΦΡΟΝΤΙΖΩ ΜΗΝΙΑΙΑΣ ΚΑΤΑΒΟΛΗΣ",
  "Εταίρος ΕΠΕ στην Εθνική ΑΕ",
  "ΕΤΕ WARRANTS",
  "Κατεστραμμένο αρχείο pdf, δεν εμφανίστηκαν τα στοιχεία",
  "ΚΕΦΑΛΑΙΩΝ -",
  "ΚΕΦΑΛΑΙΩΝ - USD000109708",
  "ΚΟΙΝΟΤ. ΜΕΤ. - ΕΛΛ. ΠΕΤΡΕΛΑΙΑ",
  "Κορ φιλ ΑΕΒΕ",
  "Μερίδα αμοιβαίων κεφαλαίων",
  "Μερίδα Αμοιβαίων Κεφαλαίων - ΑΤΕ Μετοχικό Εσωτερικού",
  "Μερίδα αμοιβαίων κεφαλαίων (Eurobank Global Equities)",
  "Μερίδα αμοιβαίων κεφαλαίων (Eurobank plus dollar)",
  "Μερίδα αμοιβαίων κεφαλαίων (Eurobank plus pollar)",
  "Μερίδα αμοιβαίων κεφαλαίων (Πίστεως)",
  "Μεριδές στη Παγκρήτια Τράπεζα",
  "ΜΕΡΙΔΙΑ - BLACKROCK WORLD",
  "ΜΕΡΙΔΙΑ - BRGF GBL BD USD A2",
  "ΜΕΡΙΔΙΑ - CASH EURO",
  "ΜΕΡΙΔΙΑ - INVESCO PAN",
  "ΜΕΡΙΔΙΑ - LF MM FUND",
  "ΜΕΡΙΔΙΑ - M&G OPTIMAL",
  "ΜΕΡΙΔΙΑ - PARVEST BOND",
  "ΜΕΡΙΔΙΑ - PARVEST EQUITY",
  "ΜΕΡΙΔΙΑ - PIMC INC E INC EURH",
  "ΜΕΡΙΔΙΑ - PIMCO INCOME",
  "ΜΕΡΙΔΙΑ - ΔΗΛΟΣ B.CHIPS",
  "ΜΕΡΙΔΙΑ - ΔΗΛΟΣ ΜΙΚΤΟ",
  "ΜΕΡΙΔΙΑ - ΠΕΙΡΑΙΩΣ Α/Κ",
  "ΜΕΡΙΔΙΑ - ΠΕΙΡΑΙΩΣ-ΜΕΤΟΧΙΚΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ABSOLUTE ZETUEN",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ - BLACKROCK",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ - BMO EUROPE HIGH DIV COV",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ - HSBC US GOV MNY MKT CL D",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ - LORD ABBETT SHORT TERM DUR INCOME",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ - WSMF WORLD SELECTION 2 AC USD",
  "Μερίδια αμοιβαίων καφαλαίων (Εθνική Δήλος ΜΙΚΤΟ Εσωτερικού)",
  "Μερίδια αμοιβαίων καφαλαίων (Πειραιώς)",
  "Μερίδια αμοιβαίων κεφαλαίων",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - 3K METOXIKO EΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - 3K ΜΕΤΟΧΙΚΟ ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - 3Κ ΜΕΤΟΧΙΚΟ ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - 480 AMUNDI FUNDS CASH EUR",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - A/K LF MM FUND RESERVE",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - A/K ΕΙΣΟΔΗΜΑΤΟΣ ΟΜΟΛΟΓΩΝ ΕΥΡΩ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ABSOLUT REVERSE",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ABSOLUTE ZETUEN",
  "Μερίδια αμοιβαίων κεφαλαίων - Alco Μετ. Εσ.",
  "Μερίδια αμοιβαίων κεφαλαίων - ALICO FUND ΜΙΚΤΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALICO METOΧ ΕΣΩΤ.",
  "Μερίδια αμοιβαίων κεφαλαίων - ALICO ΕΥΡΩΠ. ΔΙΑΘΕΣ.",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALICO ΕΧΡΩΠ. ΔΙΑΘ.",
  "Μερίδια αμοιβαίων κεφαλαίων - ALICO ΚΡΑΤ. ΟΜΟΛ. ΕΞΩΤ.",
  "Μερίδια αμοιβαίων κεφαλαίων - ALICO ΜΕΣΑΙΑΣ ΜΙΚΤΟ",
  "Μερίδια αμοιβαίων κεφαλαίων - ALICO Μετοχ. Εσωτ. Μεσαίας και Μικρής Κεφαλαιοποίησης",
  "Μερίδια αμοιβαίων κεφαλαίων - ALICO ΜΕΤΟΧ. ΕΣΩΤΕΡ.",
  "Μερίδια αμοιβαίων κεφαλαίων - ALICO Μετοχικό Δείκτη Υψηλής Κεφαλαιοποίησης",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALICO ΜΙΚΤΟ ΕΞΩΤΕΡ.",
  "Μερίδια αμοιβαίων κεφαλαίων - ALICO ΜΙΚΤΟ ΕΞΩΤΕΡΙΚ.",
  "Μερίδια αμοιβαίων κεφαλαίων - ALLCO",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALLIANZ",
  "Μερίδια Αμοιβαίων Κεφαλαίων - ALLIANZ A.E.",
  "Μερίδια αμοιβαίων κεφαλαίων - ALLIANZ AAE",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALLIANZ ASIA PACIFIC CLASS A EYR",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALLIANZ EUROPEAN EQUITY DIVEDEND CLASS AT EYR",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALLIANZ EURYPEAN EQUITY DIVIDEND CLASS AT EYR",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALLIANZ GLOBAL AGRICUL TURAL TRENDS CLASSA EYR",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALLIANZ Α/Κ ΕΠΙΘΕΤΙΚΗΣ ΣΤΡΑΤΗΓΙΚΗΣ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALLIANZ Α/Κ ΕΠΙΘΕΤΙΚΗΣ ΣΤΡΑΤΗΓΙΚΗΣ (ΜΤΧ. ΕΣΩΤ.)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALLIANZ Α/Κ ΜΕΤΟΧΩΝ ΑΝΑΠΤΥΣΣΟΜΕΝΩΝ ΑΓΟΡΩΝ ΕΜΕΑ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALLIANZ Α/Κ ΜΙΚΤΟ ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALLIANZ Α/Κ ΟΜΟΛΟΓΙΩΝ ΕΥΡΩ ΠΕΡΙΦΕΡΕΙΑΣ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALLIANZ Α/Κ ΟΜΟΛΟΓΙΩΝ ΜΙΚΡΗΣ ΚΑΙ ΜΕΣΑΙΑΣ ΔΙΑΡΚΕΙΑΣ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALLIANZ ΑΕΔΑΚ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALLIANZ ΑΜΟΙΒΑΙΟ ΚΕΦΑΛΑΙΟ ΜΕΤΟΧΩΝ ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALLIANZ ΑΜΟΙΒΑΙΟ ΚΕΦΑΛΑΙΟ ΜΙΚΤΟ ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA BLUE CHIP",
  "Μερίδια αμοιβαίων κεφαλαίων - ALPHA BLUE CHIPS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA BLUE CHIPS CLASSIC",
  "Μερίδια αμοιβαίων κεφαλαίων - ALPHA BLUE CHIPS ΕΛ ΜΕΤΟΧΙΚΑ",
  "Μερίδια αμοιβαίων κεφαλαίων - ALPHA BLUE CHIPS ΕΛΛΗΝΙΚΟ ΜΕΤΟΧΙΚΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA BLUE CHIPS ΕΛΛΗΝΙΚΟ ΜΕΤΟΧΙΚΟ CLASSIC",
  "Μερίδια αμοιβαίων κεφαλαίων - ALPHA BLUE CHIPS ΜΕΤΟΧΙΚΟ ΕΣΩΤΕΡΙΚΟΥ",
  "Μερίδια αμοιβαίων κεφαλαίων - ALPHA BRIC",
  "Μερίδια Αμοιβαίων Κεφαλαίων - ALPHA FUND BRIC",
  "Μερίδια αμοιβαίων κεφαλαίων - ALPHA FUND OF FUNDS COSMOS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA FUND OF FUNDS COSMOS STARS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA FUND OF FUNDS COSMOS STARS BRIC ΜΕΤΟΧΙΚΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA FUND OF FUNDS COSMOS STARS EUROPE ΜΕΤΟΧΙΚΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA FUND OF FUNDS COSMOS STARS SILK ROUTE ASIA EQUITE FUND OF FOUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA FUND OF FUNDS COSMOS STARSEUROPE ΜΕΤΟΧΙΚΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA FUND OF FUNDS COSMOS ΜΕΤΟΧΙΚΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA FUND OG FUNDS COSMOS STARS SILK ROUTE ASIA ΜΕΤΟΧΙΚΟ CLASSIC",
  "Μερίδια αμοιβαίων κεφαλαίων - ALPHA FUND ΜΕΤΟΧΙΚΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA FUNF OF FUNDS COSMOS STARS EUROPE",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA GLOBAL ALLOCATION - ΜΙΚΤΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA GLOBAL ALLOCATION BALANCED",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA GLOBAL ALLOCATION ΜΙΚΤΟ CLASSIC",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA GREEK BALANCED FUND CLASSIC",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA INCOME PLUS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA INCOME PLUS ΟΜΟΛΟΓΙΑΚΟ CLASIC",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA INCOME PLUS ΟΜΟΛΟΓΙΑΚΟ CLASSIC",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA TRUST HELLENIC EQUITY FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA TRUST HELLENIC EQUITY FUND-R",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA TRUST NEW STRATEGY ΜΕΤ. ΕΣΩΤ.",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA TRUST NEW STRATEGY ΜΕΤ.ΕΣΩΤ.",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA TRUST NEW STRATEGY ΜΕΤ.ΕΣΩΤΡ.",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA ΔΙΑΧΕΙΡΙΣΕΩΣ ΔΙΑΘΕΣΙΜΩΝ PLUS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA ΕΛΛΗΝΙΚΟ MIKTO",
  "Μερίδια αμοιβαίων κεφαλαίων - ALPHA ΕΛΛΗΝΙΚΟ ΜΕΤΟΧΙΚΟ",
  "Μερίδια αμοιβαίων κεφαλαίων - ALPHA ΕΛΛΗΝΙΚΟ ΜΙΚΤΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA ΕΛΛΗΝΙΚΟ ΜΙΚΤΟ CLASSIC",
  "Μερίδια αμοιβαίων κεφαλαίων - ALPHA ΕΛΛΗΝΙΚΟ ΟΜΟΛ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA ΕΛΛΗΝΙΚΟ ΟΜΟΛΟΓΙΑΚΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA ΕΛΛΗΝΙΚΩΝ ΕΤΑΙΡΕΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA ΕΠΙΘΕΤΙΚΗΣ ΕΛΛΗΝΙΚΟ ΜΕΤΟΧΙΚΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA ΕΠΙΘΕΤΙΚΗΣ ΣΤΡΑΤΗΓΙΚΗΣ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA ΜΕΤΟΧΕΣ ΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA ΜΕΤΟΧΙΚΟ FUND ΕΞΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA ΜΙΚΤΟ ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ALPHA ΟΜΟΛΟΓΙΑΚΟ ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - AMOIBAΙΟ ΚΕΦΑΛΑΙΟ ΙΝΤERAMERICAN",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - AMUNDI",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - AMUNDI - FIRST EAGLE INTERNATIONAL FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - AMUNDI FD BD GLOBAL AGGREGATE LU 4",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - AMUNDI FD BD GLOBAL AGGREGATE LU 4193",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - AMUNDI FD MONEY MARKET EURO LU 0560",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - AMUNDI FUNDS CASH EUR-AE",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - AMUNDI FUNDS II - EUROPEAN EQUITY TARGET INCOME -A - DS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - AMUNDI FUNDS II - GLOBAL MULTI - ASSET TARGET INCOME - AE - DQ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - AMUNDI-CASH USD AU ACC USD",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - AMUNDI-FIRST EAGLE AMUNDI INTERNATIONAL FUND-AHE-QD MORGAN STANLEY- GLOBAL BALANCE INCOME FUND0A0DQ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - AMUNDI-FIRST EAGLE INTERNATIONAL FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - AMUNDI-GLOBAL AGGREGATE BOND FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - AΛΦΑ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - B.CHIPS ΕΠΙΛ.ΑΞ.ΜΕΤ.ΕΣΩΤΕΡ ΙΚΟΥ",
  "Μερίδια Αμοιβαίων Κεφαλαίων - BALANCED XL ACC ING PETRIMONIAL",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BALCKROCK WORLD TECHNOLOGY A2 EUR",
  "Μερίδια αμοιβαίων κεφαλαίων - BFG A/K GLOBAL ALLOCATION (HSBC)",
  "Μερίδια αμοιβαίων κεφαλαίων - BFG UK GBP",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BGF - WORLD BOND FUND A2 ACC AUR(H) LU033917880",
  "Μερίδια Αμοιβαίων Κεφαλαίων - BGF EURO SHORT DURATION",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BGF EUROP EQT INC EU",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BGF EUROP INC A5G EU",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BGF EUROPEAN EQUITY INCOME FUND D5RF EUR",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BGF FIXED INCOME CLOB OPPORT (DIS- HDG-I)",
  "Μερίδια αμοιβαίων κεφαλαίων - BGF GL Eq INHEDG",
  "Μερίδια αμοιβαίων κεφαλαίων - bgf GL Eq INHEDG EUR)",
  "Μερίδια αμοιβαίων κεφαλαίων - BGF Global Allocation",
  "Μερίδια Αμοιβαίων Κεφαλαίων - BGF GLOBAL COVERN",
  "Μερίδια αμοιβαίων κεφαλαίων - BGF Latin America",
  "Μερίδια αμοιβαίων κεφαλαίων - BGF UK",
  "Μερίδια αμοιβαίων κεφαλαίων - BGF UK Equity",
  "Μερίδια Αμοιβαίων Κεφαλαίων - BGF US DOLLAR HIGH YIELD",
  "Μερίδια Αμοιβαίων Κεφαλαίων - BGF US DOLLAR SHORT",
  "Μερίδια αμοιβαίων κεφαλαίων - BGF World Gold",
  "Μερίδια αμοιβαίων κεφαλαίων - BGF World Gold)",
  "Μερίδια αμοιβαίων κεφαλαίων - BGF World Health",
  "Μερίδια αμοιβαίων κεφαλαίων - BGF World Tech",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BGF- GLOBAL EQIUITITY INCOME FUND A2 ACC EUR(H) LU0625451603",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BGF-GLOBAL EQUITY INCOME",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BLACKROCK",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BLACKROCK CREDIT ALLOCATION",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BLACKROCK ENH CAP AND INC",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BLACKROCK ENHANCED EQUITY",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BLACKROCK EURO MARKETS FUND A4- DY",
  "Μερίδια αμοιβαίων κεφαλαίων - BLACKROCK GLOBAL A2",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BLACKROCK GLOBAL ALLOCAT. A2 HEDGED EUR",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BLACKROCK GLOBAL ALLOCATION A2",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BLACKROCK GLOBAL MULTI - ASSET INCOME FUND - A8 - H - DM",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BLACKROCK GLOBAL OPP EQTY TR",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BLACKROCK INTERNATIONAL GROW",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BLACKROCK UNITED KINGDOM FUND A2 GBP",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BLACKROCK US DOLLAR HIGH YIELD BOND (I)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BLACKROCK WORLD FINANCIALS A2 EUR",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BLACKROCK WORLD GOLD A2 EUR",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BLACKROCK WORLD GOLD FUND(I)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BLACKROCK WORLD TECHNOLOGY A2 EUR",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BLACKROCK-EURO COMPORATE BOND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BLACKROCK-GLOBAL COVERNMENT",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BLACKROCKHEALTHS CIENCE (Ι)",
  "Μερίδια αμοιβαίων κεφαλαίων - BLEND EUROBANK",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BMO COVERD CALL CANADIAN BA",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BMO COVERED CALL CANADIAN BA",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BMO EUROPE HIGH DIV COV",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BMO EUROPE HIGH DIVIDENT COV",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BNP INSTICASH EUR CLASSIC",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BNP INSTICASH FUND - EUR - MONEY MARKET",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BNP INSTICASH FUND EUR MONEY MARKET",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BNP PARIBAS DISRUPTIVE TECHNOLOGY - CLASSIC C",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BNP PARIBAS FLEXI I US MORTGAGR(HDG)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BNP PARIBAS INSTICASH",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BNP PARIBAS INSTICASH - USD MONEY MARKET",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BNP PARIBAS INSTICASH EUR",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BNP PARIBAS INSTICASH EUR-C",
  "Μερίδια Αμοιβαίων Κεφαλαίων - BNPP INSTKASH T1 ACC",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BNPP-INSTICASH PRIVILEGE ACC USD",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - BNPP-INTICASH PRIVILEGE ACC USD",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - CALYPSO",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - CAPITAL HOLDING DISOVERY FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - CASH",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - CILCK ΣΥΝΘΕΤΟ",
  "Μερίδια αμοιβαίων κεφαλαίων - CIT80%PROTDYNAMA L GBP",
  "Μερίδια αμοιβαίων κεφαλαίων - CIT80%PROTDYNAMAL",
  "Μερίδια αμοιβαίων κεφαλαίων - CITI BANK",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - COHEN & STEERS LIMITED DURATION PREF",
  "Μερίδια αμοιβαίων κεφαλαίων - CPB Ελληνικό Μετοχικό",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - DWS TOP DIVIDENDE",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EATON VANCE RISK MANAGED DIV",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EATON VANCE TAX - MANAGED",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EATON VANCE TAX- MANAGED",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EFG ABSOLUTE",
  "Μερίδια αμοιβαίων κεφαλαίων - EFG EQTY GLOBAL",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EFG EUROLIFE PROFIT LOCK",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EFG LF BALANCED BLEND GLOBAL",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EFG LF FOF EQUTY - BLEND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EFG LF FOF-GLOBAL",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EFG LF SP-A WEATHER",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ENTITLEMENTDEC08 CMA GLOB HDG",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ENTITLEMENTDEC09 CMA GLOB HDG",
  "Μερίδια Αμοιβαίων Κεφαλαίων - EQUITY A ACC SCHRODER JAPANESE",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ERB GF GREEK EQUITIES MTX ESV",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ETFS-ETC-SH JPY LG USD",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EUR GF GREEK EQUITIES",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EUR INTERAMERICAN",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EUR000103902",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EUR000105699",
  "Μερίδια Αμοιβαίων Κεφαλαίων - Eurobank",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EUROBANK (LF) ABSOLUTE RETURN FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EUROBANK (LF) FUND OF FUNDS - GLOBAL LOW",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EUROBANK (LF) INCOME PLUS FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EUROBANK (LF) MONEY MARKET FUND-RESERVE",
  "Μερίδια αμοιβαίων κεφαλαίων - Eurobank (με σύζυγο και τέκνα)",
  "Μερίδια αμοιβαίων κεφαλαίων - Eurobank A/K Double Click",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EUROBANK GF EQUITIES METOXIKO ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EUROBANK GF GREEK EQUITIES ΜΕΤΟΧΙΚΟ ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EUROBANK GLOBAL BOND",
  "Μερίδια αμοιβαίων κεφαλαίων - Eurobank Global Bond (Ομολογιακό)",
  "Μερίδια αμοιβαίων κεφαλαίων - Eurobank Greek Top 20",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EUROBANK REZERVE",
  "Μερίδια αμοιβαίων κεφαλαίων - EUROBANK WEATHER",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - EUROBANK ΜΕΤΟΧΙΚΟ ΑΝΑΠΤΥΣΟΜ.",
  "Μερίδια αμοιβαίων κεφαλαίων - EUROBANK ΜΤΧ - ΑΝΑΠΤΥΣΟΜ.",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - FIDELITY SELECT PHARMACEUTICAL",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - FIDELITY SELECTS PHARMACEUTICAL",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - FIL UK PENSION",
  "Μερίδια αμοιβαίων κεφαλαίων - FIMCO UNCONSTR BOND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - FINEX EUROPE",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - FIRST EAGLE AMUNDI INTL FD EUR LU 2416",
  "Μερίδια αμοιβαίων κεφαλαίων - FLEXI PLUS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - FRANK TEMP EUR GROWTH A",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - FRANKL TEMP GBL TOT RET A",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - FRANKLIN MUT BEACON A-ACC",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - FRANKLIN NEXTSTEP CONSERVATIVE FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - FRANKLIN TARGET ICOME 2024 FUND (I- DIS)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - FRANKLIN TEMPLETON FRONTIER MARKETS (I)",
  "Μερίδια Αμοιβαίων Κεφαλαίων - FTIF FRANKLIN EUROPEAN",
  "Μερίδια Αμοιβαίων Κεφαλαίων - FTIF FRANKLIN MUTUAL",
  "Μερίδια Αμοιβαίων Κεφαλαίων - FTIF TEMPLETON GLOBAL",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - FUND OF FUNDS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - FUND OF FUNDS GLOBAL HIGH",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - FUND OF FUNDS GLOBAL LOW",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - FUND OF FUNDS GLOBAL MEDIUM",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - FUND OF FUNDSBALANCE BLEND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - GLOBAL EQUITY",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - GLOBAL X LITHIUM ETF",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - GLOBAL X ROBOTICS & ARTIFICI",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - GS EURO LIQUID RESERVE FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - GS-EURO LIQUID RESERVS A ACC",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - HGIF EURO RESERVE EUR000107631",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - HGIF GLB HIGH INC US",
  "Μερίδια αμοιβαίων κεφαλαίων - HSBC",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - HSBC SELECT BALANCE",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - HSBC US GOV MNY MKT CL D",
  "Μερίδια αμοιβαίων κεφαλαίων - HSBC WORLD SELECTION",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - INCOME PLUS EURO FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ING PATRIMONIAL",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - INTERAMERICAN ΑΝΑΠΤΥΣΣΟΜΕΝΩΝ ΕΤΑΙΡΙΩΝ ΜΕΤΟΧΙΚΟ ΕΣΩΤΕΡΙΚΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - INTERAMERICAN ΔΥΝΑΜΙΚΟ ΜΕΤΟΧΙΚΟ ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - Interamerican ελληνικό",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - INTERNATIONAL - ΕΛΛΗΝΙΚΟ ΜΕΤΟΧΙΚΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - INTERNATIONAL ΕΛΛΗΝΙΚΟ ΜΕΤΟΧΙΚΟ",
  "Μερίδια αμοιβαίων κεφαλαίων - Inv Pan Euro Eq",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - INVESCO - PAN EUROPEAN STRUCTURED EQUITY FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - INVESCO ACTIVE MULTI-SECTOR CREDIT(DIS-I)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - INVESCO BALANCED RISK ALLOCATION - A FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - INVESCO PAN EU H/INC E",
  "Μερίδια Αμοιβαίων Κεφαλαίων - INVESCO PAN EUROP",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - INVESCO PAN EUROPEAN STR EQ FA",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - INVESCO S&P 500 LAW VOLALITI",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - INVESCO S&P 500 LOW VOL PORTFOLIO",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - INVESCO-GREATER CHINA EQUITY FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - INVESCO-PAN EUROPEAN HIGH INCOME E ACC EUR LU0243957742",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ISHARES EURO TOTAL MARKET VALUE LARGE",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ISHARES EUROSTOXX SEL DVD 30",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - J P MORGAN SHORT TERM CASH",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JHON HANCOCK T/A DVD INCOME",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JOHN HANCOCK T/A DVD INCOME Άθροισμα",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JOHN HANCOOCK T/A DVD INCOME",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JP MORGAN - AGGREGATE BOHD FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JP MORGAN - GLOBAL BOND OPPOR. FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JP MORGAN -GLOBAL BOHD OPPOR. FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JP MORGAN EUROPE EQ A USD",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JP MORGAN SHORT TERM CASH",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JP NATUR RESOURC",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JPM EURO MONEY MARKET",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JPM EURO MONEY MARKET-EUR",
  "Μερίδια Αμοιβαίων Κεφαλαίων - JPM EUROPE EQUITY PLUS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JPM F HIGH US STEEP A EUR",
  "Μερίδια Αμοιβαίων Κεφαλαίων - JPM HIGH BRIDGE",
  "Μερίδια Αμοιβαίων Κεφαλαίων - JPM HIGH BRIDGE US",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JPM HIGHBR US STEEP A USD",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JPM INCOME OPP EUR",
  "Μερίδια Αμοιβαίων Κεφαλαίων - JPM INCOME OPPURTUNITY",
  "Μερίδια Αμοιβαίων Κεφαλαίων - JPM SYSTEMATIC ALPHA",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JPM-GLOBAL BALANCED A ACC EUR-LU0070212591",
  "Μερίδια αμοιβαίων κεφαλαίων - JPMF UK Equity",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JPMORGAN FUNDS - AFRICA EQUITY FUND(I)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JPMORGAN GLOBAL INCOME FUND(C-DIS)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JPMORGAN GLOBAL STRATEGIC BOND FUND(C)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JPMORGAN INCOME FUND (I-DIS-HDG)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - JPMORGAN SYS ALPHA A EUR",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - LEVERAGED COPITAL HOLDING",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - LF FOF GLOBAL MEDIUM",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - LF INCOME PLUS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - LF MM FUND RESERVE",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - LORD ABBETT SHORT LIGUID FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - LORD ABBETT SHORT TERM DUR INCOME",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - LU0121216955 NN (L) PATRIMONIAL",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - M & G OPTIMAL INCOME FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - M & G-GLOBAL FLOATING RATE HIGH YIELD FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - M&G LUX OPTIMAL INCOME FUND (I-DIS)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - MELIFE ΜΕΤΟΧ ΔΕΙΚΤΗ ΥΨΗΛΗΣ ΚΕΦΑΛΑΙΟΠΟΙΗΣΗΣ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - METLIFE - ALICO ΜΕΤΟΧΙΚΟ ΔΕΙΚΤΗ ΥΨΗΛΗΣ ΚΕΦΑΛΑΙΟΠΟΙΗΣΗΣ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - METLIFE - ΜΕΤΟΧΙΚΟ ΕΣΩΤ.ΜΙΚΡΗΣ ΜΕΣΑΙΑΣ ΚΕΦΑΛΑΙΟΠΟΙΗΣΗΣ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - METLIFE ΜΕΤΟΧ.ΕΣΩΤ. ΜΙΚΡΗΣ ΜΕΣΑΙΑΣ ΚΕΦΑΛΑΙΟΠΟΙΗΣΗΣ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - MONEY MARKET",
  "Μερίδια αμοιβαίων κεφαλαίων - MORGAN STANLEY",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - MORGAN STANLEY - GLOBAL BRANDS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - MORGAN STANLEY - GLOBAL FIXED INCOME",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - MORGAN STANLEY - GLOBAL FIXED INCOME OPPOR. FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - MORGAN STANLEY - GLOBAL OPPORTUNITY FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - MORGAN STANLEY - US ADVANTAGE FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - MORGAN STANLEY ASIAN PROPERTY FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - MORGAN STANLEY EURO CORPORATE LU 8863",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - MORGAN STANLEY- GLOBAL FIXED INCOME OPPOR. FUHD",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - MORGAN STANLEY- US ADVANTAGE FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - MS CLOBAL BRANDS (6932)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - MS DIV ALPHA PL RC400EURO LU 3608",
  "Μερίδια Αμοιβαίων Κεφαλαίων - MS GLOBAL",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - MS GLOBAL FIXED INCOME OPP EUR LU 3511",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - MSIM GLOBAL BALAN RISK CN-A LU 0694238501",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - MU 5,5 01/02/2025",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - MUTUAL FUNDS - CASH EUR - AE",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - NN (L) EURO FIXED INCOME ICA",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - NN (L) US ENHANCED CORE CONCETRADED EQUITY",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - NN (L) US HIGH DIVIDEND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - NN-BANKING & INSURANCE FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - NN(L)PATRIM BLCD X CAP",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PARVEST BOND EURO",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PARVEST BOND EURO CORPORATE",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PARVEST BOND USD - CC",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PARVEST BOND WORLD EME C",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PARVEST BOND WORLD HIGH YIELD",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PARVEST EQUITY BRAZIL",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PARVEST EQUITY EUROPE EMERGING",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PARVEST EQUITY RUSSIA CC EU",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PARVEST EQUITY TURKEY",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PARVEST EQUITY WORLD EMERGING",
  "Μερίδια Αμοιβαίων Κεφαλαίων - PARVEST V350CC ACC",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PARVEST- MONEY MARKET EURO",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PARVEST-MONEY MARKET CC ACC EUR LU083138064",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PHOENIX HELLENIC EQUITY",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PHOENIX ΕΛΛΗΝΙΚΟ ΜΕΤΟΧΙΚΟ",
  "Μερίδια Αμοιβαίων Κεφαλαίων - PICTE SHORT TERM MONEY",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PICTET - HIGH DIVIDEND SELECTION -R- DM",
  "Μερίδια αμοιβαίων κεφαλαίων - PICTET DIGIT COMM",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PICTET GLOBAL EMERGING DEBT(DIS- HDG-I)",
  "Μερίδια αμοιβαίων κεφαλαίων - Pictet High Dividend Selection Fund",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PICTET SOVEREIGN",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PICTET SOVEREIGN SHORT TERM MONEY MARKET",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PICTET- SHORT TERN EM.CORPORATE BONDS FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PICTET-GLOBAL EMERGING DEBT(HDG-DIS)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PICTET-JAPANESE EQUITY OPPORTUNITIES (I)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PICTET-MULTI ASSET GLOBAL",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PICTET-NUTRITION",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PIMC GLB BOND EURH",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PIMC INC E INC EURH",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PIMC TTL RETURN EURH",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PIMCINC E INC EURH",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PIMCO GLOBAL INVESTEMENT",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PIMCO INCOME FUND (HDG-DIS)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PIMCO INCOME FUND(DIS-HDG-I)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PIMCO TOTAL RET BOND CI E EH A",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PIMCO- GLOBAL INCOME FUND (USD)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PIMCO-GLOBAL INCOME FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PIMCO-GLOBAL INVESTMENT",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PIMCO-GLOBAL INVESTMENT GRADE FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PIMCO-INCOME FUNDS E ACC EUR(H)-IE00B84J9L26",
  "Μερίδια αμοιβαίων κεφαλαίων - PINCO UNCONSTR BOND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PIONEER ABS RET BD A CAP",
  "Μερίδια αμοιβαίων κεφαλαίων - Pioneer Funds US Research",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PIONEER- EURO STRATEGIC BOND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PIONEER- EURO STRATEGIC BOND FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PIONEER-EURO CORPORATE SHORT- TERM-A",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - PIONEER-EUROPEAN TARGET INCOME",
  "Μερίδια Αμοιβαίων Κεφαλαίων - PIONNER FUNDS EURO",
  "Μερίδια αμοιβαίων κεφαλαίων - PNR European Trg",
  "Μερίδια αμοιβαίων κεφαλαίων - PNR Global Equity",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - POWERSHARES S&P 500 LOW VOL PORTFOLIO",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - RED ARC 80% PROTECTED DYNAMIC ALLOCATION FUND-A",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - RIOCAN REAL ESTATE INVESTMENT",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - SCHRODER ASIAN OPPORTUNITIES",
  "Μερίδια Αμοιβαίων Κεφαλαίων - SCHRODER EMERGING",
  "Μερίδια Αμοιβαίων Κεφαλαίων - SCHRODER GLOBAL",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - SCHRODER INTERNATIONAL SELECTION FUND - UK EQUITY - A",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - SCHRODER ISF",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - SCHRODER ISF- ITALIAN EQUITY -A",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - SCHRODER ISF-BRIC- A",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - SCHRODER-QEP GLOBAL ACTIVE VALUE A ACC EUR(H)- LU0305899550",
  "Μερίδια αμοιβαίων κεφαλαίων - SISE BRIC FUND",
  "Μερίδια αμοιβαίων κεφαλαίων - SISE EURO CORPORATE",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - SISF EMERGING MKT A CAP",
  "Μερίδια αμοιβαίων κεφαλαίων - SISF European Dividend Maximiser",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - SISF GBLCORPORATE BOND A",
  "Μερίδια αμοιβαίων κεφαλαίων - SISF Italian Equity",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - SISF JAP EQ A HEDGE CAP EUR",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - SPECIAL PURPOSE",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - SPROTT PHYSICAL TRUST UNITS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - TD (27/12/16-27/03/17) 0.6500% 90D",
  "Μερίδια αμοιβαίων κεφαλαίων - Templeton Global Bond",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - TEMPLETON GLOBAL TOTAL RETURN W MDIS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - TRITON GLOBAL BALANCED",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - TRITON ΕΙΣΟΔ ΟΜΟΛ ΑΝΑΠ ΧΩΡΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - UBS LUX MONEY MARKET FUND",
  "Μερίδια Αμοιβαίων Κεφαλαίων - UBS YIELD B ACC EUR",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - UNIT LINK INVEST 3",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - USB MONEY MARKET EURO B",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - USD BGF-GLOBAL ALLOCATION FD- A2USD",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - USD BGF-GLOBAL ALLOCATION FDA2USD",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - VANGUARD HIGE DND YIELD ETF",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - VANGUARD LONG- TERM BOND ETF",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - VANGUARD TOTAL INTL BOND ETF",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - VOYA GLOBAL EQUITY DIVIDEND",
  "Μερίδια αμοιβαίων κεφαλαίων - Weather Eurobank",
  "Μερίδια αμοιβαίων κεφαλαίων - WIN WIN ΕΞΩΤ. Eurobank",
  "Μερίδια αμοιβαίων κεφαλαίων - WIN- WIN Eurobank (κοινά με σύζυγο)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - WIN-WIN EUROBANK",
  "Μερίδια Αμοιβαίων Κεφαλαίων - WISDOM TREE JAPAN",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - WISDOMTREE INT DIV GROWTH FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - WISDOMTREE JAPAN HDG EQ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - WISDOMTREE JAPAN HEDGED EQ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - WORLD SELECTION 1 US",
  "Μερίδια αμοιβαίων κεφαλαίων - WORLD SELECTION 2",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - WORLD SELECTION 2USD",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - WORLD SELECTION 3 EU",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - WORLD SELECTION EUR000109716",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - WSMF WORLD SELECTION 1AC EURH",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - WSMF WORLD SELECTION 2 A USD - USD000103930",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - WSMF WORLD SELECTION 2AC EURH-EUR000103901",
  "Μερίδια αμοιβαίων κεφαλαίων - Α.Κ. ΔΙΕΘΝΕΣ ΕΤΑΙΡΙΩΝ ΠΕΙΡΑΙΩΣ",
  "Μερίδια αμοιβαίων κεφαλαίων - Α/Κ EUROBANK GREEK EQUITIES ΜΕΤΟΧΕΣ ΕΣΩΤ.",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - Α/Κ EUROBANK GREEK EQUITIES ΜΕΤΟΧΕΣ ΕΣΩΤΕΡΙΚΟΥ",
  "Μερίδια Αμοιβαίων Κεφαλαίων - Α/Κ PARVERST MONEY MARKET",
  "Μερίδια Αμοιβαίων Κεφαλαίων - Α/Κ PIONEER ABSOLUTE RETURN",
  "Μερίδια Αμοιβαίων Κεφαλαίων - Α/Κ PIONEER EURO QUALITY",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - Α/Κ ΜΕΤΟΧΙΚΟ ΕΣΩΤΕΡΙΚΟΥ",
  "Μερίδια Αμοιβαίων Κεφαλαίων - Α/Κ Πειραιώς Μετοχικό Εσωτερικού",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΑLICO ΚΡΑΤ. ΟΜ. ΕΞΩΤ.",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΑLLIANZ A/K",
  "Μερίδια αμοιβαίων κεφαλαίων - ΑΕΔΑΚ ALPHA",
  "Μερίδια αμοιβαίων κεφαλαίων - ΑΛΦΑ BLUE CHIPS ΜΕΤΟΧΙΚΑ",
  "Μερίδια Αμοιβαιών Κεφαλαίων - ΑΛΦΑ BLUE CHIPS, ΕΛΛΗΝΙΚΟ ΜΕΤΟΧ.",
  "Μερίδια αμοιβαίων κεφαλαίων - ΑΛΦΑ FUND ΜΕΤΟΧΙΚΟ",
  "Μερίδια αμοιβαίων κεφαλαίων - ΑΛΦΑ ΕΛΛΗΝΙΚΟ ΜΕΤΟΧΙΚΟ ΕΠΙΘ. ΣΤΡΑΤ.",
  "Μερίδια αμοιβαίων κεφαλαίων - ΑΛΦΑ ΕΛΛΗΝΙΚΟ ΜΙΚΤΟ",
  "Μερίδια αμοιβαίων κεφαλαίων - ΑΛΦΑ ΕΛΛΗΝΙΚΟ ΟΜΟΛ.",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΑΜΟΙΒΑΙΑ ΔΙΑΘΕΣΙΜΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΑΜΟΙΒΑΙΑ ΚΕΦΑΛΑΙΑ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΑΜΟΙΒΑΙΑ ΚΕΦΑΛΑΙΑ ALPHA EΛΛΗΝΙΚΟ ΟΜΟΛΟΓΙΑΚΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΑΜΟΙΒΑΙΑ ΜΕΤΟΧΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΑΜΟΙΒΑΙΑ ΟΜΟΛΟΓΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΑΜΟΙΒΑΙΟ ΕΞΩΤΕΡΙΚΟΥ (LF)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΑΜΟΙΒΑΙΟ ΚΕΦΑΛΑΙΟ",
  "Μερίδια αμοιβαίων κεφαλαίων - Αμοιβαίο Κεφάλαιο Eurobank LF Absolute Return",
  "Μερίδια αμοιβαίων κεφαλαίων - Αμοιβαίο Κεφάλαιο EUROBANK LF Fund of Funds Absolute Return",
  "Μερίδια αμοιβαίων κεφαλαίων - Αμοιβαίο Κεφάλαιο EUROBANK LF Fund of Funds Balance Blend",
  "Μερίδια αμοιβαίων κεφαλαίων - Αμοιβαίο Κεφάλαιο EUROBANK LF Fund of Funds Global High",
  "Μερίδια αμοιβαίων κεφαλαίων - Αμοιβαίο Κεφάλαιο Eurobank LF Fund of Funds Global Low",
  "Μερίδια αμοιβαίων κεφαλαίων - Αμοιβαίο Κεφάλαιο Fund of Funds Global Medium",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΑΜΟΙΒΑΙΟ ΚΕΦΑΛΑΙΟ ΔΙΑΧ.ΔΙΑΘΕΣΙΜΩΝ ΒΝΡ",
  "Μερίδια αμοιβαίων κεφαλαίων - Γενική Τράπεζα",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΔΗΛΟΣ B. CHIPS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΔΗΛΟΣ B.CHIPS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΔΗΛΟΣ B.CHIPS ΕΠΙΛ. ΑΞ. ΜΕΤ. ΕΣΩΤ.",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΔΗΛΟΣ B.SHIPS",
  "Μερίδια Αμοιβαιών Κεφαλαίων - ΔΗΛΟΣ BLUE CHIPS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΔΗΛΟΣ BLUE CHIPS ΕΠΙΛΕΓΜΕΝΩΝ Α",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΔΗΛΟΣ BLUE CHIPS ΕΠΙΛΕΓΜΕΝΩΝ ΑΞΙΩΝ ΜΕΤΟΧΙΚΟ ΕΣΩΤ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΔΗΛΟΣ BLUE CHIPS ΣΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΔΗΛΟΣ DELTA BONUS ΣΥΝΘΕΤΟ Α/Κ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΔΗΛΟΣ DELTA TONNS",
  "Μερίδια αμοιβαίων κεφαλαίων - ΔΗΛΟΣ SMALL CAP",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΔΗΛΟΣ SMALL CAP ΜΕΤΟΧΙΚΟ ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΔΗΛΟΣ SMALL CUP",
  "Μερίδια αμοιβαίων κεφαλαίων - ΔΗΛΟΣ SYNT. BEST RED",
  "Μερίδια αμοιβαίων κεφαλαίων - ΔΗΛΟΣ SYNT. BEST YELL",
  "Μερίδια αμοιβαίων κεφαλαίων - Δήλος SYNTHESIS BEST RED",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΔΗΛΟΣ Synthesis Best Yellow",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΔΗΛΟΣ Β.CHIPS",
  "Μερίδια αμοιβαίων κεφαλαίων - ΔΗΛΟΣ Ε.Τ.Ε.",
  "Μερίδια αμοιβαίων κεφαλαίων - ΔΗΛΟΣ ΕΞΩΤΕΡΙΚΟΥ",
  "Μερίδια αμοιβαίων κεφαλαίων - ΔΗΛΟΣ ΕΤΕ",
  "Μερίδια Αμοιβαιών Κεφαλαίων - ΔΗΛΟΣ ΜΙΚΤΟ ΑΜΟΙΒ.",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΔΗΛΟΣ ΜΙΚΤΟ ΑΜΟΙΒΑΙΟ ΚΕΦΑΛΑΙΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΔΗΛΟΣ ΜΙΚΤΟ ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΔΗΛΟΣ ΣΤΡΑΤ/ΚΩΝ ΤΟΠΟΘΕΤΗΣΕΩΝ ΜΙΚ. ΕΣΩΤΕΡΙΚΟΥ",
  "Μερίδια αμοιβαίων κεφαλαίων - ΔΙΑΧ. ΔΙΑΘΕΣΙΜΩΝ UAS",
  "Μερίδια αμοιβαίων κεφαλαίων - ΔΙΑΧ. ΔΙΑΘΕΣΙΜΩΝ ΒΝΡ",
  "Μερίδια αμοιβαίων κεφαλαίων - Ε.Τ.Ε.",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΕΘΝΙΚΗ ASSET MANAGEMENT ΔΗΛΟΣ SMALL CAP ΜΕΤΟΧΙΚΟ ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΕΘΝΙΚΗ ASSET MANAGEMENT ΔΗΛΟΣ Synthesis Best Yellow",
  "Μερίδια αμοιβαίων κεφαλαίων - ΕΘΝΙΚΗ ΔΗΛΟΣ ΜΙΚΤΟ ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - Εθνική Τράπεζα",
  "Μερίδια αμοιβαίων κεφαλαίων - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΔΗΛΟΣ BLUE CHIPS",
  "Μερίδια αμοιβαίων κεφαλαίων - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΕΛΛΑΔΟΣ ΔΗΛΟΣ ΜΙΚΤΟ ΑΜΟΙΒΑΙΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΕΘΝΚΗ ASSET MANAGEMENT - ΔΗΛΟΣ ΣΤΡΑΤ/ΚΩΝ ΤΟΠΟΘΕΤΗΣΕΩΝ ΜΙΚ. ΕΞΩΤΕΡΙΚΟΥ",
  "Μερίδια Αμοιβαιών Κεφαλαίων - ΕΛΛΗΝΙΚΟ ΜΙΚΤΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΘΣΔ ΒΓΦ-ΓΛΟΒΑΛ ΑΛΛΟΨΑΤΙΟΝ ΦΔ- Α2ΘΣΔ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΙΝΤΚΑ",
  "Μερίδια αμοιβαίων κεφαλαίων - κοινά με σύζυγο (Interamerican AWATT)",
  "Μερίδια αμοιβαίων κεφαλαίων - κοινά με σύζυγο (Interamerican ΔΥΝΑΜ)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΚΥΠΡΟΥ ΑΕΔΑΚ/ UBS MONEY MARKET FUNDS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΚΥΠΡΟΥ ΑΕΔΑΚ/J.P. MORGAN INVEST.FUNDS - INCOME OFFUN.",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΚΥΠΡΟΥ ΑΕΔΑΚ/PICTET ABSOLUTE RETURN GLOBAL",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΚΥΠΡΟΥ ΑΕΔΑΚ/PICTET EYR.4 QUALITY",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΚΥΠΡΟΥ ΑΕΔΑΚ/STABILITY BNPL1 ABSOLUTE RETURNS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΜΕΡΙΔΙΑ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΜΕΤΟΧΕΣ ΕΥΡΩΠΗ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΜΕΤΟΧΙΚΟ ΕΣΩΤ.(ΜΙΚΡΗΣ ΜΕΣΑΙΑΣ ΚΕΦΑΛΑΙΟΠΟΙΗΣΗΣ)- Α",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΜΕΤΡΗΤΑ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΜΙΚΤΑ ΑΜΟΙΒΑΙΑ ΚΕΦΑΛΑΙΑ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΜΚΤ - ΕΛΛΗΝΙΚΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΜΤΧ. ΑΝΑΠΤΥΣΣΟΜΕΝΩΝ EUROBANK",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΝΝ (L) EURO HIGH DIVIDEND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΝΝ (L) GLOBAL EQUITY OPPORTUNITIES ICA",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΟΜΟΛΟΓΑ ΥΨΗΛΗΣ ΑΠΟΔΟΣΗΣ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΟΣΕΚΑ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΠΕΙΡΑΙΩΣ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΠΕΙΡΑΙΩΣ – ΜΕΤΟΧΙΚΟ ΕΣΩΤΕΡΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΠΕΙΡΑΙΩΣ Α/Κ ΔΥΝΑΜΙΚΩΝ ΕΠΙΧ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΠΕΙΡΑΙΩΣ Α/Κ ΔΥΝΑΜΙΚΩΝ ΕΠΙΧΕΙΡΗΣΕΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΠΕΙΡΑΙΩΣ Α/Κ ΜΕΤΟΧΙΚΟ ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΠΕΙΡΑΙΩΣ Α/Κ ΟΜΟΛΟΓΩΝ ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΠΕΙΡΑΙΩΣ ΔΙΕΘΝΕΣ FUNDS OF FUNDS ΜΙΚΤΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΠΕΙΡΑΙΩΣ ΔΥΝΑΜΙΚΩΝ ΕΠΙΧΕΙΡΗΣΕΩΝ",
  "Μερίδια Αμοιβαίων Κεφαλαίων - ΠΕΙΡΑΙΩΣ ΜΕΤ. ΕΣΩΤ.",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΠΕΙΡΑΙΩΣ ΜΕΤΟΧΙΚΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΠΕΙΡΑΙΩΣ ΜΕΤΟΧΙΚΟ ΕΣΩΤ.",
  "Μερίδια αμοιβαίων κεφαλαίων - Πειραιώς Μετοχικό Εσωτερικού",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΠΕΙΡΑΙΩΣ- ΔΙΑΧΕΙΡΙΣΗΣ ΔΙΑΘΕΣΙΜΩΝ ΕΣΩΤΕΡΙΚΟΥ- GRF000108008",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΠΕΙΡΑΙΩΣ-ΜΕΤΟΧΙΚΟ ΕΣΩΤΕΡΙΚΟΥ- GRF000113008",
  "Μερίδια αμοιβαίων κεφαλαίων - Πίστεως",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ - PARVEST MULTI STRAG.",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ BGF EUROSHORT DURATION BOND FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ BNP PARIBAS INSTICASH EUR.",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ BNP PARIBAS INSTICASH EYR CLASSIC T1",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ BNPL1 V350",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ BNPL1 V350 PICTET GLOBAL EMERGING CURRENCIES",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ BNPPL1 ABSOLUTE RETURN",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ BNPPL1 ABSOLUTE RETURN STABILITY",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ BNPPL1 OPPORTUNITIES EURO",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ ING(L) PATRIMONIAL BALANCED",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ INVESCO BALANCED - RISK ALLOCATION FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ JP MORGAN - SYSTEMATIC ALPHA FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ JP MORGAN INVESTEMENT FUNDS HIGHBRIDGE",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ JP MORGAN INVESTEMENT FUNDS INCOME OPPORTUNITIES",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ PARVEST MONEYMARKET EURO",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ PARVEST V350",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ PICTET ABSOLUTE RETRUN GLOBAL DIVERSIFIED",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ PICTET SHORT TERM MONEY",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ PICTET SHORT TERM MONEY MARKET",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ PICTET USD LIQUIDITY",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ PIONEER ABSOLUTE RETURN BOND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ UBS (LUX) MONEY MARKET FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ YIELD EYR UBS (LUX), STRATEGY FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ ΚΥΠΡΟΥ EYRO EQUITY PREMIUM",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ ΚΥΠΡΟΥ EYRO QUALITY PREMIUM",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡ.ΠΕΙΡΑΙΩΣ/DIVERSIFIED PICTET ABSOLUTE RETURN GLOBAL",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ",
  "Μερίδια Αμοιβαίων Κεφαλαίων -INVESCO PAN EUROPEAN",
  "Μερίδια Αμοιβαίων Κεφαλαίων -UPS MONEY MARKET FUND",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ -ΔΗΛΟΣ DELTA BONUS",
  "Μερίδια αμοιβαίων κεφαλαίων , WIN-WIN ΕΞΩΤ. EUROBANK",
  "Μερίδια αμοιβαίων κεφαλαίων (3K Μετοχικό Εσωτερικού)",
  "Μερίδια αμοιβαίων κεφαλαίων (ALLIANZ A.A.E.)",
  "Μερίδια αμοιβαίων κεφαλαίων (ALLIANZ AAE)",
  "Μερίδια αμοιβαίων κεφαλαίων (ALLIANZ ΑΜΟΙΒΑΙΟ ΚΕΦΑΛΑΙΟ ΜΕΤΟΧΩΝ ΕΣΩΤΕΡΙΚΟΥ)",
  "Μερίδια αμοιβαίων κεφαλαίων (Allianz)",
  "Μερίδια αμοιβαίων κεφαλαίων (Alpha Bank - Κοινός GLOBAL ALLOCATION) - Συνδικαιούχος με συγγενής",
  "Μερίδια αμοιβαίων κεφαλαίων (Alpha Bank)",
  "Μερίδια αμοιβαίων κεφαλαίων (Alpha Blue CHPS ΜΕΤΟΧΙΚΟ)",
  "Μερίδια αμοιβαίων κεφαλαίων (Alpha Trust Hellenic Equity Fund)",
  "Μερίδια Αμοιβαίων Κεφαλαίων (ALPHA TRUST NEW STRATEGY Μετ. εσωτ.)",
  "Μερίδια αμοιβαίων κεφαλαίων (Alphabank)",
  "Μερίδια αμοιβαίων κεφαλαίων (alphatrust)",
  "Μερίδια Αμοιβαίων Κεφαλαίων (AMUNDI FUNDS)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (BGF Euromarkets)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (BGF UK GBP)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (BGF World Gold)",
  "Μερίδια αμοιβαίων κεφαλαίων (BGF-Fixed INC Global OP-A2)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (Black Rock Fund Global Allocation Fund)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (Black Rock Global Equity Fund)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (Black Rock Global Fund World Health Fund)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (Black Rock Global Funds Euro Small-mid Cap",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (Black Rock Global Real Estate Fund)",
  "Μερίδια αμοιβαίων κεφαλαίων (Blackrock China)",
  "Μερίδια αμοιβαίων κεφαλαίων (BLACKROCK GLOB)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (Blackrock Global Funds Emerging Europe)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (Blackrock Global Funds United Kingdom Fund)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (Blackrock Global Funds World Energy Funds)",
  "Μερίδια αμοιβαίων κεφαλαίων (BLACKROCK GLOBAL)",
  "Μερίδια αμοιβαίων κεφαλαίων (BLACKROCK WORLD)",
  "Μερίδια αμοιβαίων κεφαλαίων (Blend Eurobank)",
  "Μερίδια αμοιβαίων κεφαλαίων (BNP Insticash EUR Classic)",
  "Μερίδια αμοιβαίων κεφαλαίων (BNP Parvest Bond USD-CC)",
  "Μερίδια αμοιβαίων κεφαλαίων (Capital Holding Discovery CFUND)",
  "Μερίδια αμοιβαίων κεφαλαίων (Citi Bank)",
  "Μερίδια αμοιβαίων κεφαλαίων (City Bank AE)",
  "Μερίδια αμοιβαίων κεφαλαίων (CITY BANK)",
  "Μερίδια αμοιβαίων κεφαλαίων (Coutts - Discretionary Account)",
  "Μερίδια αμοιβαίων κεφαλαίων (CPB Ελληνικό Μετοχικό)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (Credit Suisse Equity Fund)",
  "Μερίδια αμοιβαίων κεφαλαίων (Eurobank (LF) Absolute Return Fund)",
  "Μερίδια αμοιβαίων κεφαλαίων (Eurobank (LF) Absolute Return Funds)",
  "Μερίδια αμοιβαίων κεφαλαίων (Eurobank (LF) Fund of Funds - Bric)",
  "Μερίδια αμοιβαίων κεφαλαίων (Eurobank (LF) Fund of Funds (Bric))",
  "Μερίδια αμοιβαίων κεφαλαίων (Eurobank (LF) Money Market - Cash Fund)",
  "Μερίδια αμοιβαίων κεφαλαίων (Eurobank (LF) Special Purpose - All Weather Plus)",
  "Μερίδια αμοιβαίων κεφαλαίων (Eurobank (LF))",
  "Μερίδια αμοιβαίων κεφαλαίων (EUROBANK (LF))",
  "Μερίδια αμοιβαίων κεφαλαίων (Eurobank (LFCOF))",
  "Μερίδια αμοιβαίων κεφαλαίων (Eurobank )",
  "Μερίδια αμοιβαίων κεφαλαίων (Eurobank Click σύνθετο)",
  "Μερίδια αμοιβαίων κεφαλαίων (Eurobank EFG)",
  "Μερίδια αμοιβαίων κεφαλαίων (Eurobank Global Bond)",
  "Μερίδια αμοιβαίων κεφαλαίων (Eurobank LF Money Market - Cash Fund)",
  "Μερίδια αμοιβαίων κεφαλαίων (Eurobank Weather)",
  "Μερίδια αμοιβαίων κεφαλαίων (Eurobank) - Δεν έχει συμπληρωθεί",
  "Μερίδια αμοιβαίων κεφαλαίων (eurolife - Profit Lock)",
  "Μερίδια αμοιβαίων κεφαλαίων (Eurolife- Profit Lock)",
  "Μερίδια αμοιβαίων κεφαλαίων (EUROXX)",
  "Μερίδια αμοιβαίων κεφαλαίων (FIL UK PENSION PLAN)",
  "Μερίδια αμοιβαίων κεφαλαίων (FLEXI PLUS)",
  "Μερίδια Αμοιβαίων Κεφαλαιών (FTIF - FRANKLIN GLOBAL FUNDAMENTAL STRATEGIES A ACC)",
  "Μερίδια αμοιβαίων κεφαλαίων (FTIF TEMPLETON)",
  "Μερίδια αμοιβαίων κεφαλαίων (Greek top20 (τραπεζοασφαλιστικό))",
  "Μερίδια αμοιβαίων κεφαλαίων (GS Global Strategic Macro Bond)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (GSF Global Allocation)",
  "Μερίδια αμοιβαίων κεφαλαίων (HSBC World Section)",
  "Μερίδια αμοιβαίων κεφαλαίων (ING Μετοχικό Εξωτερικού)",
  "Μερίδια αμοιβαίων κεφαλαίων (ING Μετοχικό Εσωτερικού)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (INTERAMERICAN- ΑΜΟΙΒΑΙΑ, ΔΥΝΑΜΙΚΟ ΜΕΤΟΧΙΚΟ ΕΣΩΤΕΡΙΚΟΥ)",
  "Μερίδια αμοιβαίων κεφαλαίων (INTERAMERICAN)",
  "Μερίδια αμοιβαίων κεφαλαίων (Interamerican)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (Invesco Balanced Risk Allocation Fund)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (Invesco European Growth)",
  "Μερίδια αμοιβαίων κεφαλαίων (Invesco Global Absolute Return Fund)",
  "Μερίδια αμοιβαίων κεφαλαίων (INVESCO PAN)",
  "Μερίδια αμοιβαίων κεφαλαίων (Invescoeuro cort Bond-e)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (JP Morgan Fund German Equity)",
  "Μερίδια αμοιβαίων κεφαλαίων (JP MORGAN)",
  "Μερίδια αμοιβαίων κεφαλαίων (JPM China)",
  "Μερίδια αμοιβαίων κεφαλαίων (JPM EM)",
  "Μερίδια αμοιβαίων κεφαλαίων (JPM Emerging Markts)",
  "Μερίδια Αμοιβαίων Κεφαλαιών (JPM GLOBAL BALANCED A ACC EUR)",
  "Μερίδια αμοιβαίων κεφαλαίων (JPM Income)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (JPMF UK EQUITY)",
  "Μερίδια αμοιβαίων κεφαλαίων (Leveraged Capital Holding)",
  "Μερίδια αμοιβαίων κεφαλαίων (MS GLobal)",
  "Μερίδια αμοιβαίων κεφαλαίων (Parvest Enhanced Cash-6M-CC)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (Pectet High Dividend Selection Fund)",
  "Μερίδια αμοιβαίων κεφαλαίων (PF Russian EQ)",
  "Μερίδια αμοιβαίων κεφαλαίων (Pictet Eur Short Term High Yield)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (PICTET US EQUITY)",
  "Μερίδια αμοιβαίων κεφαλαίων (Pictet- Agriculture-USD)",
  "Μερίδια αμοιβαίων κεφαλαίων (PIMCO GIS)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (Pioneer Funds US Research)",
  "Μερίδια αμοιβαίων κεφαλαίων (Schroder ISF-Asian Opportunities- AIAC)",
  "Μερίδια αμοιβαίων κεφαλαίων (Schroder ISF-Euro High Yield)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (SISF European Dividend Maximiser)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (Templeton Global Bond)",
  "Μερίδια αμοιβαίων κεφαλαίων (Templeton global)",
  "Μερίδια αμοιβαίων κεφαλαίων (UBS (LUX) MONEY MARKET FUND)",
  "Μερίδια Αμοιβαίων Κεφαλαίων (UNIT LINK INVEST 3)",
  "Μερίδια αμοιβαίων κεφαλαίων (WIN - WIN εξωτ. Eurobank)",
  "Μερίδια αμοιβαίων κεφαλαίων (WIN-WIN EUROBANK)",
  "Μερίδια αμοιβαίων κεφαλαίων (ΑΚ ΙΝG μετοχικό εσωτερικού)",
  "Μερίδια αμοιβαίων κεφαλαίων (Αμοιβαία κεφάλαια UBS διαχ. διαθεσίμων.)",
  "Μερίδια αμοιβαίων κεφαλαίων (Αμοιβαίο FOF Best YH)",
  "Μερίδια αμοιβαίων κεφαλαίων (Αμοιβαίο κεφάλαιο διαχ. διαθεσίμων BNP)",
  "Μερίδια αμοιβαίων κεφαλαίων (Αμοιναιο Δηλος BC)",
  "Μερίδια Αμοιβαίων Κεφαλαίων (ΑΤΕ Αμοιβαία)",
  "Μερίδια αμοιβαίων κεφαλαίων (ΔΗΛΟΣ Blue chips)",
  "Μερίδια αμοιβαίων κεφαλαίων (δήλος Blue-Chips)",
  "Μερίδια αμοιβαίων κεφαλαίων (ΔΗΛΟΣ CLUB CHIPS)",
  "Μερίδια αμοιβαίων κεφαλαίων (Δήλος Delta Bonus)",
  "Μερίδια αμοιβαίων κεφαλαίων (Δήλος Small CAP)",
  "Μερίδια αμοιβαίων κεφαλαίων (Δήλος Small CUP)",
  "Μερίδια αμοιβαίων κεφαλαίων (ΔΗΛΟΣ ΕΣΩΤΕΡΙΚΟΥ)",
  "Μερίδια αμοιβαίων κεφαλαίων (Διεθνικά ΑΕ)",
  "Μερίδια αμοιβαίων κεφαλαίων (Διεθνική ΑΕ)",
  "Μερίδια αμοιβαίων κεφαλαίων (Εθνική Δήλος Μικτό Εσωτερικού)",
  "Μερίδια Αμοιβαίων Κεφαλαίων (Εθνική Τράπεζα της Ελλάδος)",
  "Μερίδια αμοιβαίων κεφαλαίων (Εθνική τράπεζα)",
  "Μερίδια αμοιβαίων κεφαλαίων (ΕΦΑΠΑΞ ΕΘΝΙΚΗΣ)",
  "Μερίδια αμοιβαίων κεφαλαίων (κοινά με σύζυγο και τέκνο) - ΔΗΛΟΣ BLUE CHIPS",
  "Μερίδια αμοιβαίων κεφαλαίων (κοινά με σύζυγο) - ALPHA ΕΛΛΗΝΙΚΟ ΜΙΚΤΟ",
  "Μερίδια αμοιβαίων κεφαλαίων (κοινά με σύζυγο) - ALPHA ΣΥΝΘΕΤΟ ΑΜΟΙΒΑΙΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - BNP INSTICSH PUND - USD PRIV",
  "Μερίδια αμοιβαίων κεφαλαίων (κοινά με σύζυγο) - Interamerican Αμοιβαίο Δυναμικό Μετοχών Εσωτ.",
  "Μερίδια αμοιβαίων κεφαλαίων (κοινά με σύζυγο) - INTERAMERICAN Δυναμικό Μετοχικό Εσωτερικού",
  "Μερίδια αμοιβαίων κεφαλαίων (κοινά με σύζυγο) - INTERAMERICAN Μετοχικό Αναπτυσσόμενων Εταιρειών",
  "Μερίδια αμοιβαίων κεφαλαίων (κοινά με σύζυγο) - International Ελληνικό Μετοχικό",
  "Μερίδια αμοιβαίων κεφαλαίων (κοινά με σύζυγο) - Αμοιβαίο Κεφάλαιο EUROBANK LF Money Market Reserve",
  "Μερίδια αμοιβαίων κεφαλαίων (κοινά με σύζυγο) - Κεφάλαιο Plus + ΑΝΟΔΟΣ XVII, ISIN. NBCB14100101",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ (ΚΟΙΝΑ ΜΕ ΤΗΝ ΣΥΖΥΓΟ) - ΕΘΝΙΚΗ ASSET MANAGEMENT",
  "Μερίδια αμοιβαίων κεφαλαίων (κοινά με τρίτο πρόσωπο) - Αμοιβαίο Κεφάλαιο Eurobank LF Money Market Reserve",
  "Μερίδια Αμοιβαίων Κεφαλαίων (Με σύζυγο) - - ALPHA FUND BRIC",
  "Μερίδια Αμοιβαίων Κεφαλαίων (Με σύζυγο) - ALPHA BLUE CHIPS",
  "Μερίδια Αμοιβαίων Κεφαλαίων (με σύζυγο) - BNP PARIBAS INSTICASH EUR",
  "Μερίδια αμοιβαίων κεφαλαίων (με σύζυγο) - INV GR CHINA EQ",
  "Μερίδια Αμοιβαίων Κεφαλαίων (Με σύζυγο) - INVESCO PAN EUROP",
  "Μερίδια Αμοιβαίων Κεφαλαίων (Με σύζυγο) - PIONNER FUNDS EURO",
  "Μερίδια αμοιβαίων κεφαλαίων (με σύζυγο) - PNR European TRG EQ",
  "Μερίδια Αμοιβαίων Κεφαλαίων (Με σύζυγο) - SISE BRIC FUND",
  "Μερίδια αμοιβαίων κεφαλαίων (με σύζυγο) - Templeton Asian Growth",
  "Μερίδια αμοιβαίων κεφαλαίων (με σύζυγο) - Templeton Frontier Market",
  "Μερίδια αμοιβαίων κεφαλαίων (με σύζυγο) (Discretionary Asset Management (Μ.Κ))",
  "Μερίδια αμοιβαίων κεφαλαίων (με σύζυγο) (Discretionary Asset Management (Χ.Κ))",
  "Μερίδια αμοιβαίων κεφαλαίων (μερίδια Ελληνικό μετοχής)",
  "Μερίδια αμοιβαίων κεφαλαίων (μερίδια σε επενδυτικό)",
  "Μερίδια αμοιβαίων κεφαλαίων (Πειραιώς Διεθνές Funds of Funds μικτό)",
  "Μερίδια αμοιβαίων κεφαλαίων (ΠΕΙΡΑΙΩΣ ΔΥΝ. ΕΠΙΧ. ΜΕΤΟΧΙΚΟ ΕΣΩΤΕΡΙΚΟΥ)",
  "Μερίδια αμοιβαίων κεφαλαίων (ΠΕΙΡΑΙΩΣ ΔΥΝ. ΕΠΙΧ. ΜΕΤΟΧΙΚΟΥ ΕΣΩΤΕΡΙΚΟΥ)",
  "Μερίδια αμοιβαίων κεφαλαίων (ΠΕΙΡΑΙΩΣ ΔΥΝ. ΕΠΙΧ. ΜΕΤΟΧΙΚΟΥ ΚΕΦΑΛΑΙΟΥ)",
  "Μερίδια αμοιβαίων κεφαλαίων (Πειραιώς Δυναμικών Επιχειρήσεων)",
  "Μερίδια αμοιβαίων κεφαλαίων (ΠΕΙΡΑΙΩΣ ΜΕΤΟΧΙΚΟ ΕΣΩΤΕΡΙΚΟΥ)",
  "Μερίδια αμοιβαίων κεφαλαίων (Πειραιώς μετοχικό εσωτερικού)",
  "Μερίδια αμοιβαίων κεφαλαίων (Πειραιώς μετοχικό)",
  "Μερίδια Αμοιβαίων Κεφαλαιών (Πειραιώς-Μετοχικό Εσωτερικού)",
  "Μερίδια αμοιβαίων κεφαλαίων (Πειραιώς)",
  "Μερίδια αμοιβαίων κεφαλαίων (Πειραιώς) (από συγχώνευση)",
  "Μερίδια αμοιβαίων κεφαλαίων CITIBANK",
  "Μερίδια αμοιβαίων κεφαλαίων MARFIN",
  "Μερίδια αμοιβαίων κεφαλαίων MILLENNIUM",
  "Μερίδια αμοιβαίων κεφαλαίων από κοινού με σύζυγο - ACT ING(L) TECHNIX-SHORT TERM 3-C",
  "Μερίδια αμοιβαίων κεφαλαίων απο κοινού με σύζυγο - ΑΛΦΑ ΕΛΛΗΝΙΚΟ ΜΙΚΤΟ",
  "Μερίδια αμοιβαίων κεφαλαίων απο κοινού με σύζυγο - ΑΛΦΑ ΣΥΝΘΕΤΟ ΑΜΟΙΒΑΙΟ",
  "Μερίδια αμοιβαίων κεφαλαίων απο κοινού με σύζυγο - ΔΗΛΟΣ BLUE CHIPS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ ΑΠΟ ΚΟΙΝΟΥ ΜΕ ΣΥΖΥΓΟ (Templeton Asian Growth)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ ΑΠΟ ΚΟΙΝΟΥ ΜΕ ΣΥΖΥΓΟ (Templeton Frontier Market)",
  "Μερίδια αμοιβαίων κεφαλαίων κινός με σύζυγο (Interamerican ΑΝΑΠΤ)",
  "Μερίδια αμοιβαίων κεφαλαίων κοινά με σύζυγο (Amundi FD BD Global Aggregate LU 0906524193)",
  "Μερίδια αμοιβαίων κεφαλαίων κοινά με σύζυγο (Amundi FD money markeet)",
  "Μερίδια αμοιβαίων κεφαλαίων κοινά με σύζυγο (Entitlement DEC08 CMA GLOB HDG)",
  "Μερίδια αμοιβαίων κεφαλαίων κοινά με σύζυγο (Entitlement DEC09 CMA GLOB HDG)",
  "Μερίδια αμοιβαίων κεφαλαίων κοινά με σύζυγο (First Eagle Amundi INTL FD EUR LU0433182416)",
  "Μερίδια αμοιβαίων κεφαλαίων κοινά με σύζυγο (Interamerican ΑΝΑΠΤ)",
  "Μερίδια αμοιβαίων κεφαλαίων κοινά με σύζυγο (Interamerican ΔΥΝΑΜ)",
  "Μερίδια αμοιβαίων κεφαλαίων κοινά με σύζυγο (Invesco PAN European STR EQ FA LU0119750205)",
  "Μερίδια αμοιβαίων κεφαλαίων κοινά με σύζυγο (Ishares MSCI JAPAN ETF US4642868487)",
  "Μερίδια αμοιβαίων κεφαλαίων κοινά με σύζυγο (Morgan Stanley Euro corporate LU0518378863)",
  "Μερίδια αμοιβαίων κεφαλαίων κοινά με σύζυγο (MS DIV ALPHA PL RC400)",
  "Μερίδια αμοιβαίων κεφαλαίων κοινά με σύζυγο (MS GLobal Fixed Income OPP EUR LU0712123511)",
  "Μερίδια αμοιβαίων κεφαλαίων κοινά με σύζυγο (Mutual Funds Amundi -Cash EUR- AE)",
  "Μερίδια αμοιβαίων κεφαλαίων κοινά με σύζυγο (Pimco Total RET Bond CI E EH A)",
  "Μερίδια αμοιβαίων κεφαλαίων κοινά με σύζυγο (Κρατικά Ομόλογα European INV BAN)",
  "Μερίδια αμοιβαίων κεφαλαίων κοινά με σύζυγο (ΠΕΙΡΑΙΩΣ ΔΥΝ. ΕΠΙΧ. ΜΕΤΟΧΙΚΟ ΕΣΩΤΕΡΙΚΟΥ)",
  "Μερίδια αμοιβαίων κεφαλαίων κοινά με σύζυγο (ΠΕΙΡΑΙΩΣ ΜΕΤΟΧΙΚΟ ΕΣΩΤΕΡΙΚΟΥ)",
  "Μερίδια αμοιβαίων κεφαλαίων κοινός με σύζυγο (Interamerican ΔΥΝΑΜ)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ ΜΕ ΚΟΡΗ - ΔΗΛΟΣ BLUE CHIPS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ ΜΕ ΜΗΤΕΡΑ - ALPHA BLUE CHIPS",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ ΜΕ ΜΗΤΕΡΑ - ALPHA ΜΙΚΤΟ ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ ΜΕ ΜΗΤΕΡΑ - ΕΘΝΙΚΗ ASSET MAN., ΔΗΛΟΣ BLUE CHIPS ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ ΜΕ ΜΗΤΕΡΑ - ΕΘΝΙΚΗ ASSET MAN., ΔΗΛΟΣ ΜΙΚΤΟ ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ ΜΕ ΣΥΖΥΓΟ - ALPHA BEST ΑΜΟΙΒΑΙΟ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ ΜΕ ΣΥΖΥΓΟ - ALPHA TRUST",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ ΜΕ ΣΥΖΥΓΟ - ALPHA ΜΙΚΤΟ ΕΣΩΤΕΡΙΚΟΥ",
  "Μερίδια Αμοιβαίων Κεφαλαίων με σύζυγο - BFG A/K GLOBAL ALLOCATION",
  "Μερίδια Αμοιβαίων Κεφαλαίων με σύζυγο - BFG A/K GLOBAL ALLOCATION (HSBC)",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ με σύζυγο - Interamerican Δυναμικό Μετ. Εσωτερ.",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ με σύζυγο - Interamerican Μετ. Αναπτ. Εταιριών",
  "Μερίδια Αμοιβαίων κεφαλαίων με σύζυγο και τέκνο ((JPM GLOBAL BALANCED A ACC EUR)",
  "Μερίδια Αμοιβαίων κεφαλαίων με σύζυγο και τέκνο (FTIF - FRANKLIN GLOBAL FUNDAMENTAL STRATEGIES A ACC)",
  "Μερίδια Αμοιβαίων κεφαλαίων με σύζυγο και τέκνο (Πειραιώς-Μετοχικό Εσωτερικού)",
  "Μερίδια αμοιβαίων κεφαλαίων- MILLENIUM BLUE CHIPS",
  "Μερίδια αμοιβαίων κεφαλαίων- MILLENIUM FYND OF FUNDS",
  "Μερίδια αμοιβαίων κεφαλαίων- MILLENIUM MID CAP",
  "Μερίδια Αμοιβαίων Κεφαλαίων-ΔΗΛΟΣ BLUE CHIPS",
  "Μερίδια αμοιβαίων κεφαλαίων-ΕΛ.ΠΕ",
  "Μερίδια Αμοιβαίων Κεφαλαίων, WIN-WIN EUROBANK",
  "Μερίδια αμοιβαίων κεφαλίων - ALCO ΜΕΤ. ΕΣ.",
  "Μερίδια Αμοιβαίων Κεφαλών - Αμοιβαία Alpha Bank",
  "Μερίδια ημεδαπών μη εισηγμένων εταιριών - Η Αυγή Α.Ε.",
  "Μερίδια Τράπεζα Ηπείρου",
  "ΜΕΤΟΧΕΣ - AEGEAN",
  "ΜΕΤΟΧΕΣ - AEROPORTS DE PARIS",
  "ΜΕΤΟΧΕΣ - AKRITAS AE.",
  "ΜΕΤΟΧΕΣ - ALLERGAN",
  "ΜΕΤΟΧΕΣ - ALPHA",
  "Μετοχές - Alpha Bank",
  "ΜΕΤΟΧΕΣ - ALPHA BANK (KO)",
  "ΜΕΤΟΧΕΣ - ALPHA BANK (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ALPHA BANK ADR",
  "ΜΕΤΟΧΕΣ - ALPHA BANK AE",
  "ΜΕΤΟΧΕΣ - ALPHA WARRANT",
  "ΜΕΤΟΧΕΣ - ALPHA ΒΑΝΚ ΑΕ",
  "ΜΕΤΟΧΕΣ - ALPHA ΤΡΑΠΕΖΑ",
  "ΜΕΤΟΧΕΣ - ALPHA ΤΡΑΠΕΖΑ Α.Ε",
  "ΜΕΤΟΧΕΣ - ALPHA ΤΡΑΠΕΖΑ Α.Ε.",
  "ΜΕΤΟΧΕΣ - ALPHA ΤΡΑΠΕΖΑ Α.Ε. - Κ.Ο.",
  "ΜΕΤΟΧΕΣ - ALPHA ΤΡΑΠΕΖΑ Α.Ε. - Κ.Ο. WARRANT",
  "ΜΕΤΟΧΕΣ - ALPHA ΤΡΑΠΕΖΑ Α.Ε. (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ALPHA ΤΡΑΠΕΖΑ Α.Ε. (ΤΠΔ)",
  "ΜΕΤΟΧΕΣ - ALPHA ΤΡΑΠΕΖΑ Α.Ε.- Κ.Ο.",
  "ΜΕΤΟΧΕΣ - ALPHA ΤΡΑΠΕΖΑ ΑΕ",
  "ΜΕΤΟΧΕΣ - ALPHA ΤΡΑΠΕΖΑ ΑΕ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ALPHA ΤΡΠΑΕΖΑ ΑΕ (ΤΠΔ)",
  "ΜΕΤΟΧΕΣ - ALPHATRUST",
  "ΜΕΤΟΧΕΣ - ALPHAΤΡΑΠΕΖΑ ΕΛΛΑΔΟΣ",
  "ΜΕΤΟΧΕΣ - ALTEC ΑΒΕ",
  "ΜΕΤΟΧΕΣ - ALTEC ΣΥΜΜΕΤΟΧΩΝ ΑΒΕΕ",
  "ΜΕΤΟΧΕΣ - ALTRIA",
  "ΜΕΤΟΧΕΣ - ALTRIA GROUP",
  "ΜΕΤΟΧΕΣ - AMUNDI FUNDS",
  "ΜΕΤΟΧΕΣ - ANEK AE",
  "ΜΕΤΟΧΕΣ - ANEK LINES A.E.",
  "ΜΕΤΟΧΕΣ - ANEN LINES",
  "ΜΕΤΟΧΕΣ - APPLE",
  "ΜΕΤΟΧΕΣ - APPLE COMPUTER INC",
  "ΜΕΤΟΧΕΣ - APPLE INC",
  "ΜΕΤΟΧΕΣ - ARNI PALACE AE",
  "Μετοχές - ATE Bank",
  "ΜΕΤΟΧΕΣ - ATTICA BANK A.T.E.",
  "ΜΕΤΟΧΕΣ - ATTICA Α.Ε. ΣΥΜΜΕΤΟΧΩΝ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ATTIKAT ATE (KO)",
  "ΜΕΤΟΧΕΣ - AUTO HELLAS A.E.",
  "ΜΕΤΟΧΕΣ - AUTO HELLAS AE",
  "ΜΕΤΟΧΕΣ - AXON",
  "ΜΕΤΟΧΕΣ - AYTO HELLAS AE",
  "ΜΕΤΟΧΕΣ - BANCO SATANDER SA",
  "ΜΕΤΟΧΕΣ - BMO COVERD CALL CANADIAN BA",
  "ΜΕΤΟΧΕΣ - BMO EUROPE HIGH DIV COV",
  "ΜΕΤΟΧΕΣ - BOSTON SCIENTIFIC CORP",
  "ΜΕΤΟΧΕΣ - BRIQ PROPERIES AEEAP(KO)",
  "ΜΕΤΟΧΕΣ - CISCO SYSTEMS",
  "ΜΕΤΟΧΕΣ - COCA COLA HBC AG",
  "ΜΕΤΟΧΕΣ - COCA COLA HELLENIC BOTTLING",
  "ΜΕΤΟΧΕΣ - COHEN AND STEERS SELECT PREFER",
  "ΜΕΤΟΧΕΣ - CONNECTION A.E.B.E.E. ΑΥΛΟ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - CONNECTION AEB",
  "ΜΕΤΟΧΕΣ - CREDIT AGRICOLE",
  "ΜΕΤΟΧΕΣ - DEUTSCHE TELEKOM DTE GY",
  "ΜΕΤΟΧΕΣ - DOW CHEMICAL",
  "ΜΕΤΟΧΕΣ - EATON VANCE TAX MANAGED",
  "ΜΕΤΟΧΕΣ - EBAY INC",
  "ΜΕΤΟΧΕΣ - EFG EUROBANK ERGASIAS",
  "ΜΕΤΟΧΕΣ - ENDO INTERNATIONAL",
  "ΜΕΤΟΧΕΣ - ENDO INTERNATIONAL PLC",
  "ΜΕΤΟΧΕΣ - ETE",
  "ΜΕΤΟΧΕΣ - ETE AE",
  "Μετοχές - Eurobank",
  "ΜΕΤΟΧΕΣ - EUROBANK ERGASIAS",
  "ΜΕΤΟΧΕΣ - EUROBANK ERGASIAS A.E",
  "ΜΕΤΟΧΕΣ - EUROMEDICA AE",
  "ΜΕΤΟΧΕΣ - F.G.EUROPE AE",
  "ΜΕΤΟΧΕΣ - FACEBOOK",
  "ΜΕΤΟΧΕΣ - FACEBOOK INC",
  "ΜΕΤΟΧΕΣ - FIRST EAGLE AMUNDI INTL FD EUR LU0433182416",
  "ΜΕΤΟΧΕΣ - FIRST EAGLE AMUNDINTL FD EUR LU0433182416",
  "ΜΕΤΟΧΕΣ - FORD MOTOR CO",
  "ΜΕΤΟΧΕΣ - FORD MOTOR COMPANY",
  "ΜΕΤΟΧΕΣ - FORTHNET AE",
  "ΜΕΤΟΧΕΣ - FORTHNET ΑΕ",
  "ΜΕΤΟΧΕΣ - FOURLIS AE ΣΥΜΜΕΤΟΧΩΝ",
  "ΜΕΤΟΧΕΣ - FRIGOGLASS ABE",
  "ΜΕΤΟΧΕΣ - FRIGOGLASS ΑΒΕΕ",
  "ΜΕΤΟΧΕΣ - FTIF TEMPLETON FRONTIER MARKETS FUND",
  "ΜΕΤΟΧΕΣ - FTIF-TEMPLETON EMERGING MARKEYS FUND BX",
  "ΜΕΤΟΧΕΣ - GAMCO GLOBAL GOLD NATURE",
  "ΜΕΤΟΧΕΣ - GENERAL ELECTRIC CO",
  "ΜΕΤΟΧΕΣ - GK RIGHTS LTD",
  "ΜΕΤΟΧΕΣ - GLOBAL X FTSE GREECE 20 E",
  "ΜΕΤΟΧΕΣ - GOLDMAN SACHS BRICS PORTFOLIO EA",
  "ΜΕΤΟΧΕΣ - GRIVALIA PROPERTIES",
  "ΜΕΤΟΧΕΣ - GRIVALIA PROPERTIES A.E.E.A.Π.",
  "ΜΕΤΟΧΕΣ - HARMAN INTERNATIONAL INDUSTRIES",
  "ΜΕΤΟΧΕΣ - HELESI PLC",
  "ΜΕΤΟΧΕΣ - HELLENIC TELECOM ORGANISATION OTE AE",
  "ΜΕΤΟΧΕΣ - HELLENIC TELECOM. ORGANISATION",
  "ΜΕΤΟΧΕΣ - HSBC HOLDINGS PLC",
  "ΜΕΤΟΧΕΣ - HSBCHOLDINGSPLC",
  "ΜΕΤΟΧΕΣ - HSBSHOLDINGSPLC",
  "ΜΕΤΟΧΕΣ - ING GROEP",
  "ΜΕΤΟΧΕΣ - INTERSAT",
  "ΜΕΤΟΧΕΣ - INTRACOM HOLDINGS",
  "ΜΕΤΟΧΕΣ - INTRAKOM",
  "ΜΕΤΟΧΕΣ - INTRAKOM ΑΕ",
  "ΜΕΤΟΧΕΣ - INTRALOT",
  "ΜΕΤΟΧΕΣ - INTRALOT Α.Ε.",
  "ΜΕΤΟΧΕΣ - INVESCO PERPETUAL",
  "ΜΕΤΟΧΕΣ - INVESCO S& P SMALLCAP LOW VOL",
  "ΜΕΤΟΧΕΣ - ISHARES EDGE MSCI MIN VOL EM",
  "ΜΕΤΟΧΕΣ - ISHARES GLOBAL INFRASTRUCTUR",
  "ΜΕΤΟΧΕΣ - ISHARES MSCI JAPAN ETF US",
  "ΜΕΤΟΧΕΣ - ISHARES SILVER BARCLAYS AGGREGATE",
  "ΜΕΤΟΧΕΣ - ISHARES STOXX 600 HEALTH CARE",
  "ΜΕΤΟΧΕΣ - J P MORGAN CHASE & CO",
  "ΜΕΤΟΧΕΣ - JET BLUE AIRWAYS",
  "ΜΕΤΟΧΕΣ - JET BLUE AIWAYS",
  "ΜΕΤΟΧΕΣ - JOHN HANCOCK T/A DVD INCOME Άθροισμα",
  "ΜΕΤΟΧΕΣ - JP MORGAN CHASE & CO",
  "ΜΕΤΟΧΕΣ - KRETA FARMA ABEE",
  "ΜΕΤΟΧΕΣ - LAVIPHARM (KΟ)",
  "ΜΕΤΟΧΕΣ - LAVIPHARM A.E.",
  "ΜΕΤΟΧΕΣ - LAVIPHARM ABE",
  "ΜΕΤΟΧΕΣ - MAIN STREET CAPITAL CORP",
  "ΜΕΤΟΧΕΣ - MARFIN INVEST",
  "ΜΕΤΟΧΕΣ - MARFIN INVESTMENT GROUP",
  "ΜΕΤΟΧΕΣ - MARFIN POPULAR BANK PUBLIC (KO)",
  "ΜΕΤΟΧΕΣ - MASTERCARD INCORPORATED",
  "ΜΕΤΟΧΕΣ - MHXK",
  "ΜΕΤΟΧΕΣ - MICROLAND COMPUTERS AEBE",
  "ΜΕΤΟΧΕΣ - MICROSOFT CORP",
  "ΜΕΤΟΧΕΣ - MICROSOFT CORPORATION",
  "ΜΕΤΟΧΕΣ - MODA BAGNO A.E",
  "ΜΕΤΟΧΕΣ - MORGAN STANLEY GLOBAL OPPORTUNITY AH",
  "ΜΕΤΟΧΕΣ - MOTOR OIL",
  "ΜΕΤΟΧΕΣ - MS ADVANTAGE FUND (HG) LU0266117927",
  "ΜΕΤΟΧΕΣ - MS ADVANTAGE FUND HG LU0266117927",
  "ΜΕΤΟΧΕΣ - MS GLOBAL BRANDS HG LU0335216932",
  "ΜΕΤΟΧΕΣ - NATIONAL BANK OF GREECE",
  "ΜΕΤΟΧΕΣ - NATIONAL HEALTH INVESTORS",
  "ΜΕΤΟΧΕΣ - NATIONAL HEALTH INVESTORS INC",
  "ΜΕΤΟΧΕΣ - NN L-BANKING & INSUR - XC EU LU0332192458",
  "ΜΕΤΟΧΕΣ - NNL-BANKING & INSUR -XC EU LU03322192458",
  "ΜΕΤΟΧΕΣ - ORACLE CORPORATION",
  "ΜΕΤΟΧΕΣ - OTE",
  "ΜΕΤΟΧΕΣ - OTE (KO)",
  "ΜΕΤΟΧΕΣ - PAYPAL HOLDINGS",
  "ΜΕΤΟΧΕΣ - PHILIP MORRIS INTERNATIONAL",
  "ΜΕΤΟΧΕΣ - PICTET - WATER-R",
  "ΜΕΤΟΧΕΣ - PIRAEUS BANK SA",
  "ΜΕΤΟΧΕΣ - PIRAIVS",
  "ΜΕΤΟΧΕΣ - PPC S.A. (CR) ΔΕΗ AE",
  "ΜΕΤΟΧΕΣ - PROCTER AND GAMBLE CO",
  "ΜΕΤΟΧΕΣ - QUALITY AND RELIABILITY",
  "ΜΕΤΟΧΕΣ - QUALITY AND RELIABILITY GRS396003006",
  "ΜΕΤΟΧΕΣ - QUEST ΣΥΜΜΕΤΟΧΩΝ ΑΕ",
  "ΜΕΤΟΧΕΣ - SEADRILL LTD",
  "ΜΕΤΟΧΕΣ - SELONDA AQUACULTURE S.A",
  "ΜΕΤΟΧΕΣ - SEX FORM A.E",
  "ΜΕΤΟΧΕΣ - SOCIETE GENERALE",
  "ΜΕΤΟΧΕΣ - SONY CORP",
  "ΜΕΤΟΧΕΣ - SPDR GOLD TRUST",
  "ΜΕΤΟΧΕΣ - SPIDER ΜΕΤΑΛ/ΧΑΝΙΑ Ν. ΠΕΤΣΟΣ",
  "ΜΕΤΟΧΕΣ - T BANK ΑΝΩΝΥΜΗ",
  "ΜΕΤΟΧΕΣ - TAX, TAM. ATE",
  "ΜΕΤΟΧΕΣ - TAΧΥΔΡΟΜΙΚΟ ΤΑΜΙΕΥΤΗΡΙΟ",
  "ΜΕΤΟΧΕΣ - TBANK",
  "ΜΕΤΟΧΕΣ - TBANK ΑΝΩΝΥΜΗ ΤΡΑΠΕΖΙΚΗ ΕΤΑΙΡΕΙΑ ΚΟ",
  "ΜΕΤΟΧΕΣ - TEVA PHARMACEUTICAL",
  "ΜΕΤΟΧΕΣ - TOTAL SA",
  "ΜΕΤΟΧΕΣ - TRAPEZA EUROBANK ERGASIAS (KO)",
  "ΜΕΤΟΧΕΣ - TRASTOR A.E.E.A.Π.",
  "ΜΕΤΟΧΕΣ - TSAKOS ENERGY",
  "ΜΕΤΟΧΕΣ - TSAKOS ENERGY NAVIG USD1",
  "ΜΕΤΟΧΕΣ - TSAKOS ENERGY NAVING USD1",
  "ΜΕΤΟΧΕΣ - TSAKOS NAVIGATION USD1",
  "ΜΕΤΟΧΕΣ - TURKIYE VAKIFLAR BANKASI T-D",
  "ΜΕΤΟΧΕΣ - TWENTY-FIRST CENTRY FOX",
  "ΜΕΤΟΧΕΣ - TWITTER INC",
  "ΜΕΤΟΧΕΣ - UNIBIOS",
  "ΜΕΤΟΧΕΣ - VANGUARD HIGH DVD YIELD ETF",
  "ΜΕΤΟΧΕΣ - VEOLIA ENVIRONMENT",
  "ΜΕΤΟΧΕΣ - VIOHALCO SA",
  "ΜΕΤΟΧΕΣ - VMWARE INC-CLASS A",
  "ΜΕΤΟΧΕΣ - WALT DISNEY",
  "ΜΕΤΟΧΕΣ - WALT DISNEY CO",
  "ΜΕΤΟΧΕΣ - WARRANT ALPHA BANK",
  "ΜΕΤΟΧΕΣ - WARRANT ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ",
  "ΜΕΤΟΧΕΣ - WARRANT ΕΘΝΙΚΗΣ ΤΡΑΠΕΖΑΣ ΑΕ",
  "ΜΕΤΟΧΕΣ - WARRANTS ISSUED F/O NBG",
  "ΜΕΤΟΧΕΣ - WARRANTS ISSUED F/O PEIRAEUS",
  "ΜΕΤΟΧΕΣ - XATZK XATZHIVANNOY A",
  "ΜΕΤΟΧΕΣ - YAMANA GOLD USD",
  "ΜΕΤΟΧΕΣ - ΑΓΡΟΖΩΗ (ΑΒΕΕ)",
  "ΜΕΤΟΧΕΣ - ΑΓΡΟΤΙΚΗ ΤΡΑΠΕΖΑ",
  "ΜΕΤΟΧΕΣ - ΑΓΡΟΤΙΚΗ ΤΡΑΠΕΖΑ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΑΔΜΗΕ",
  "ΜΕΤΟΧΕΣ - ΑΔΜΗΣ",
  "ΜΕΤΟΧΕΣ - ΑΔΡΑΣΤΕΙΑ ΕΚΔΟΣΕΙΣ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΑΕΓΕΚ",
  "ΜΕΤΟΧΕΣ - ΑΕΓΕΚ ΑΕ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΑΕΓΕΚ ΑΕ [ΚΟ] ΑΥΛΟ",
  "ΜΕΤΟΧΕΣ - ΑΕΓΕΚ-ΑΕΓΕΚ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΑΕΓΕΡΚ Α.Ε.-ΚΟ",
  "Μετοχές - ΑΕΡΟΠΟΡΙΑ ΑΙΓΑΙΟΥ",
  "ΜΕΤΟΧΕΣ - ΑΕΡΟΠΟΡΙΑ ΑΙΓΑΙΟΥ Α.Α.Ε",
  "ΜΕΤΟΧΕΣ - ΑΕΡΟΠΟΡΙΑ ΑΙΓΑΙΟΥ Α.Ε. (AEGEAN)",
  "ΜΕΤΟΧΕΣ - ΑΕΡΟΠΟΡΙΑ ΑΙΓΑΙΟΥ ΑΑΕ",
  "ΜΕΤΟΧΕΣ - ΑΕΡΟΠΟΡΙΑ ΑΙΓΑΙΟΥ ΑΑΕ(ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΑΕΡΟΠΟΡΙΑ ΑΙΓΑΙΟΥ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΑΕΡΟΠΟΡΙΑ ΑΙΓΑΙΟΥ ΑΕ(AEGEAN)",
  "ΜΕΤΟΧΕΣ - ΑΙΟΛΙΚΗ Α.Ε.Ε.Χ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΑΙΟΛΙΚΗ Α.Ε.Ε.Χ(KO)",
  "ΜΕΤΟΧΕΣ - ΑΙΟΛΚ",
  "ΜΕΤΟΧΕΣ - ΑΚΡΙΤ",
  "ΜΕΤΟΧΕΣ - ΑΚΡΙΤΑΣ",
  "ΜΕΤΟΧΕΣ - ΑΚΡΙΤΑΣ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΑΚΤΗ ΖΕΥΣ Α.Ε. ΤΟΥΡΙΣΤΙΚΑΙ ΚΑΙ ΞΕΝΟΔΟΧΕΙΑΚΑΙ ΕΠΙΧΕΙΡΗΣΕΙΣ",
  "ΜΕΤΟΧΕΣ - ΑΛΚΟ",
  "ΜΕΤΟΧΕΣ - ΑΛΚΟ ΕΛΛΑΣ ΑΒΕΕ",
  "ΜΕΤΟΧΕΣ - ΑΛΟΥΜΥΛ",
  "ΜΕΤΟΧΕΣ - ΑΛΟΥΜΥΛ ΜΥΛΩΝΑΣ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΑΛΤΕΚ",
  "ΜΕΤΟΧΕΣ - ΑΛΦΑ",
  "ΜΕΤΟΧΕΣ - ΑΛΦΑ ΤΡΑΠΕΖΑ",
  "ΜΕΤΟΧΕΣ - ΑΛΦΑ ΤΡΑΠΕΖΑ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΑΛΦΑΤΠ",
  "ΜΕΤΟΧΕΣ - ΑΝΕΚ ( ΚΟ )",
  "ΜΕΤΟΧΕΣ - ΑΝΕΚ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΑΝΕΚ ΑΝΕ",
  "ΜΕΤΟΧΕΣ - ΑΝΩΝ. ΝΑΥΤΙΛ. ΕΤΑΙΡΙΑ ΚΡΗΤΗΣ",
  "ΜΕΤΟΧΕΣ - ΑΝΩΝΥΜΕΣ ΜΕΤΟΧΕΣ",
  "ΜΕΤΟΧΕΣ - ΑΝΩΝΥΜΗ ΕΤΑΙΡΕΙΑ ΑΔΜΗΕ",
  "ΜΕΤΟΧΕΣ - ΑΝΩΝΥΜΗ ΝΑΥΤΙΛΙΑΚΗ ΕΤΑΙΡΕΙΑ ΘΑΣΟΥ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΑΝΩΝΥΝΕΣ",
  "ΜΕΤΟΧΕΣ - ΑΡΑΙΓ",
  "ΜΕΤΟΧΕΣ - ΑΣΤΗΡ",
  "ΜΕΤΟΧΕΣ - ΑΣΤΗΡ ΠΑΛΑΣ ΒΟΥΛΙΑΓΜΕΝΗΣ",
  "ΜΕΤΟΧΕΣ - ΑΣΤΗΡ ΠΑΛΑΣ ΒΟΥΛΙΑΓΜΕΝΗΣ ΑΞΕ",
  "ΜΕΤΟΧΕΣ - ΑΣΤΗΡ ΠΑΛΛΑΣ ΑΞΕ",
  "ΜΕΤΟΧΕΣ - ΑΤΕ",
  "ΜΕΤΟΧΕΣ - ΑΤΛΑΝΤΙΚ ΣΟΥΠΕΡ ΜΑΡΚΕΤ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΑΤΤICA Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΑΤΤΕ-ΑΙΝΟΣ",
  "ΜΕΤΟΧΕΣ - ΑΤΤΙ-ΚΑΤ Α.Τ.Ε.",
  "ΜΕΤΟΧΕΣ - ΑΤΤΙ-ΚΑΤ ΑΤΕ",
  "ΜΕΤΟΧΕΣ - ΑΤΤΙ-ΚΑΤ ΑΤΕ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΑΤΤΙΚ-ΑΤΤΙ-ΚΑΤ Α.Τ.Ε.",
  "ΜΕΤΟΧΕΣ - ΑΤΤΙΚΑ",
  "ΜΕΤΟΧΕΣ - ΑΤΤΙΚΑ-ATTICA AE ΣΥΜΜΕΤΟΧΩΝ",
  "ΜΕΤΟΧΕΣ - ΑΤΤΙΚΕΣ ΕΚΔΟΣΕΙΣ",
  "ΜΕΤΟΧΕΣ - ΑΥΓΗ ΑΕ ΕΚΔΟΤΙΚΟΣ- ΔΗΜΟΣ/ΚΟΣ ΟΡΓΑΝΙΣΜΟΣ",
  "ΜΕΤΟΧΕΣ - ΑΥΓΗ ΕΚΔΟΤΙΚΟΣ ΚΑΙ ΔΗΜΟΣΙΟΓΡΑΦΙΚΟΣ ΟΡΓΑΝΙΣΜΟΣ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΑΦΟΙ ΚΟΡΔΕΛΟΓΛΟΥ ΑΕΒΕ",
  "ΜΕΤΟΧΕΣ - ΑΦΟΙ Χ.ΚΟΡΔΕΛΛΟΥ Α.ΕΒΕ Κ.Ο",
  "ΜΕΤΟΧΕΣ - ΑΧΑΙΚΗ ΤΡΑΠΕΑΖΑ",
  "ΜΕΤΟΧΕΣ - ΑΧΑΙΚΗ ΤΡΑΠΕΖΑ",
  "ΜΕΤΟΧΕΣ - ΒΑΛΚΑΝ ΑΚΙΝΗΤΑ",
  "ΜΕΤΟΧΕΣ - ΒΑΡΒΑΡΕΣΟΣ Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΒΑΡΝΗ",
  "ΜΕΤΟΧΕΣ - ΒΙΟ",
  "ΜΕΤΟΧΕΣ - ΒΙΟΤΕΡ ΑΕ-ΚΟ",
  "ΜΕΤΟΧΕΣ - ΒΙΟΤΕΡ(ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΒΙΣ Α.Ε",
  "ΜΕΤΟΧΕΣ - ΒΩΒΟΣ",
  "ΜΕΤΟΧΕΣ - Γ. ΛΕΒΕΝΤΑΚΗΣ ΤΕΧ ΑΒΕΕ(ΚΑ)",
  "ΜΕΤΟΧΕΣ - Γ.Ε.ΔΗΜΗΤΡΙΟΥ ΑΕΕ",
  "ΜΕΤΟΧΕΣ - ΓΕΚ ΤΕΡΝΑ",
  "ΜΕΤΟΧΕΣ - ΓΕΚ ΤΕΡΝΑ ΑΕ ΣΥΜΜΕΤ.",
  "ΜΕΤΟΧΕΣ - ΓΕΚ ΤΕΡΝΑ ΑΕ ΣΥΜΜΕΤΟΧΩΝ",
  "ΜΕΤΟΧΕΣ - ΓΕΚΕ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΓΕΚΤΕΡΝΑ",
  "ΜΕΤΟΧΕΣ - ΓΕΝΙΚΗ ΕΜΠΟΡΙΟΥ & ΒΙΟΜΗΧΑΝΙΑΣ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΓΙΟΥΡΟΜΠΡΟΚΕΡΣ ΜΕΣΙΤΕΣ",
  "ΜΕΤΟΧΕΣ - Δ.Ε.Η",
  "ΜΕΤΟΧΕΣ - ΔΑΙΟΣ ΠΛΑΣΤΙΚΑ ΑΒΕΕ",
  "Μετοχές - ΔΕΗ",
  "ΜΕΤΟΧΕΣ - ΔΗΛΟΣ SMALL CAP ΜΕΤΟΧΙΚΟ ΕΞΩΤΕΡΙΚΟΥ",
  "ΜΕΤΟΧΕΣ - ΔΗΜΟΣΙΑ ΕΠΙΧΕΙΡΗΣΗ ΗΛΕΚΤΡΙΣΜΟΥ",
  "ΜΕΤΟΧΕΣ - ΔΙΑΣ ΙΧΘΥΟΚΑΛΛΙΕΡΓΕΙΕΣ ΑΒΕΕ",
  "ΜΕΤΟΧΕΣ - ΔΙΑΦΟΡΟΙ ΤΙΤΛΟΙ",
  "ΜΕΤΟΧΕΣ - ΔΙΕΚΑΤ ΑΕ (ΚΟ) ΑΥΛΟ",
  "ΜΕΤΟΧΕΣ - ΔΟΜΙΚΗ ΚΡΗΤΗΣ",
  "ΜΕΤΟΧΕΣ - ΔΟΥΡΟ",
  "ΜΕΤΟΧΕΣ - ΔΟΥΡΟΣ Α.Ε",
  "ΜΕΤΟΧΕΣ - Ε.Τ.Ε WARRANTS",
  "ΜΕΤΟΧΕΣ - Ε.Τ.Ε. WARRANTS",
  "ΜΕΤΟΧΕΣ - Ε.Τ.Ε. ΤΠΔ",
  "ΜΕΤΟΧΕΣ - Ε.Τ.Ε.WARRANTS",
  "ΜΕΤΟΧΕΣ - Ε.Υ.Δ.Α.Π. Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΕΒΡΟΦ",
  "Μετοχές - ΕΘΝΙΚΗ",
  "ΜΕΤΟΧΕΣ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ",
  "ΜΕΤΟΧΕΣ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ (CO)",
  "ΜΕΤΟΧΕΣ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΕΛΛΑΔΟΣ",
  "ΜΕΤΟΧΕΣ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΕΛΛΑΔΟΣ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΕΛΛΑΔΟΣ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΕ ΕΛΛΑΔΟΣ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ",
  "ΜΕΤΟΧΕΣ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ Α.Ε",
  "ΜΕΤΟΧΕΣ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ ΑΕ (ΤΠΔ)",
  "ΜΕΤΟΧΕΣ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ ΚΟ",
  "ΜΕΤΟΧΕΣ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΠ",
  "ΜΕΤΟΧΕΣ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ.",
  "ΜΕΤΟΧΕΣ - ΕΘΝΙΚΗ ΧΡΗΜΑΤΙΣΤΗΡΙΑΚΗ",
  "ΜΕΤΟΧΕΣ - ΕΙΚΟΝΑ & ΗΧΟΣ",
  "ΜΕΤΟΧΕΣ - ΕΚΤΕΡ ΑΕ (ΚΟ) ΑΥΛΟ",
  "ΜΕΤΟΧΕΣ - ΕΛ.ΠΕ.",
  "ΜΕΤΟΧΕΣ - ΕΛΒΕ ΕΝΔΥΜΑΤΩΝ Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΕΛΛ",
  "ΜΕΤΟΧΕΣ - ΕΛΛ. ΙΧΘ/ΓΕΙΕΣ ΑΒΕΕ",
  "ΜΕΤΟΧΕΣ - ΕΛΛ. ΠΕΤΡΕΛΑΙΑ",
  "ΜΕΤΟΧΕΣ - ΕΛΛ. ΧΡΗΜΑΤΙΣΤΗΡΙΑ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΕΛΛ.ΧΡΗΜΑΤ",
  "ΜΕΤΟΧΕΣ - ΕΛΛΑΚΤΩΡ",
  "ΜΕΤΟΧΕΣ - ΕΛΛΑΚΤΩΡ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΕΛΛΑΚΤΩΡ ΑΣ",
  "ΜΕΤΟΧΕΣ - ΕΛΛΗΝΙΚΑ ΠΕΡΕΛΑΙΑ Α.Ε. ΚΟ",
  "ΜΕΤΟΧΕΣ - ΕΛΛΗΝΙΚΑ ΠΕΤΡΑΕΛΑΙΑ ΑΕ",
  "Μετοχές - ΕΛΛΗΝΙΚΑ ΠΕΤΡΕΛΑΙΑ",
  "ΜΕΤΟΧΕΣ - ΕΛΛΗΝΙΚΑ ΠΕΤΡΕΛΑΙΑ Α.Ε. ΚΟ",
  "ΜΕΤΟΧΕΣ - ΕΛΛΗΝΙΚΑ ΠΕΤΡΕΛΑΙΑ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΕΛΛΗΝΙΚΑ ΠΕΤΡΕΛΑΙΑ ΑΕ -ΚΟ",
  "ΜΕΤΟΧΕΣ - ΕΛΛΗΝΙΚΑ ΧΡΗΜ/ΡΙΑ",
  "ΜΕΤΟΧΕΣ - ΕΛΛΗΝΙΚΑ ΧΡΗΜ/ΡΙΑ- ΧΡΗΜ.ΑΘΗΝΩΝ",
  "ΜΕΤΟΧΕΣ - ΕΛΛΗΝΙΚΑ ΧΡΗΜΑΤΙΣΤΗΡΙΑ",
  "ΜΕΤΟΧΕΣ - ΕΛΛΗΝΙΚΑ ΧΡΗΜΑΤΙΣΤΗΡΙΑ- ΧΡΗΜΑΤΙ",
  "ΜΕΤΟΧΕΣ - ΕΛΛΗΝΙΚΗ ΒΙΟΜΗΧΑΝΙΑ ΖΑΧΑΡΗΣ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΕΛΛΗΝΙΚΗ ΠΕΤΡΕΛΑΙΑ",
  "ΜΕΤΟΧΕΣ - ΕΛΠΕ",
  "Μετοχές - ΕΜΠΕΔΟΣ",
  "ΜΕΤΟΧΕΣ - ΕΜΠΟΡΙΚΟΣ ΔΕΣΜΟΣ",
  "ΜΕΤΟΧΕΣ - ΕΝΚΛΩ",
  "ΜΕΤΟΧΕΣ - ΕΝΩΜΕΝΗ ΚΛΩΣΤΟΥΦΑΝΤΟ",
  "ΜΕΤΟΧΕΣ - ΕΝΩΜΕΝΗ ΚΛΩΣΤΟΥΦΑΝΤΟΥΡΓΙ Α Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΕΝΩΜΕΝΗ ΚΛΩΣΤΟΥΦΑΝΤΟΥΡΓΙ Α ΑΕ",
  "ΜΕΤΟΧΕΣ - ΕΠΕΝΔΥΤΙΚΟ ΧΑΡΤΟΦΥΛΑΚΙΟ",
  "ΜΕΤΟΧΕΣ - ΕΤΑΙΡΕΙΑ ΥΔΡΕΥΣΕΩΣ",
  "ΜΕΤΟΧΕΣ - ΕΤΑΙΡΕΙΑ ΥΔΡΕΥΣΕΩΣ & ΑΠΟΧ.",
  "Μετοχές - ΕΤΕ",
  "ΜΕΤΟΧΕΣ - ΕΤΕ AE ΤΠΔ",
  "ΜΕΤΟΧΕΣ - ΕΤΕ WARRANTS",
  "ΜΕΤΟΧΕΣ - ΕΤΕ WARRANTS.",
  "Μετοχές - ΕΤΕΤΠ",
  "ΜΕΤΟΧΕΣ - ΕΤΕΤΠ WARRANTS(KEM)",
  "ΜΕΤΟΧΕΣ - ΕΤΕΤΠ- ΕΤΕ.WARRANTS",
  "ΜΕΤΟΧΕΣ - ΕΥΔΑΠ",
  "ΜΕΤΟΧΕΣ - ΕΥΠΙΚ ΕΥΡΩΠΑΙΚΗ ΠΙΣΤΗ ΑΕΓΑ",
  "ΜΕΤΟΧΕΣ - ΕΥΡΩΒ",
  "ΜΕΤΟΧΕΣ - ΕΥΡΩΒ ΤΡΑΠΕΖΑ EUROBANK ER",
  "ΜΕΤΟΧΕΣ - ΕΥΡΩΠΑΙΚΗ ΠΙΣΤΗ",
  "ΜΕΤΟΧΕΣ - ΕΥΡΩΣΥΜΒΟΥΛΟΙ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΕΥΡΩΣΥΜΜΕΤΟΧΕΣ ΚΕΦ. & ΕΠΕΝΔ.",
  "ΜΕΤΟΧΕΣ - ΕΦΤΖΙ",
  "ΜΕΤΟΧΕΣ - ΕΧΑΕ",
  "ΜΕΤΟΧΕΣ - Η ΑΥΓΗ",
  "ΜΕΤΟΧΕΣ - Η ΑΥΓΗ Α.Ε",
  "ΜΕΤΟΧΕΣ - Η ΑΥΓΗ Α.Ε.",
  "ΜΕΤΟΧΕΣ - Η ΝΑΥΤΕΜΠΟΡΙΚΗ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΘΕΜΕΛΙΟΔΟΜΗ",
  "ΜΕΤΟΧΕΣ - Ι.ΜΠΟΥΤΑΡΗΣ & ΥΙΟΣ HOLDING A.",
  "ΜΕΤΟΧΕΣ - ΙΑΣΩ Α.Ε",
  "ΜΕΤΟΧΕΣ - ΙΑΣΩ Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΙΑΣΩ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΙΑΤΡΙΚΟ ΑΘΗΝΩΝ ΕΑΕ",
  "ΜΕΤΟΧΕΣ - ΙΑΤΡΙΚΟ ΚΕΝΤΡΟ ΑΘΗΝΩΝ ΑΥΛΟ",
  "ΜΕΤΟΧΕΣ - ΙΚΤΙΝΟΣ ΕΛΛΑΣ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΙΝΛΟΤ",
  "ΜΕΤΟΧΕΣ - ΙΝΤΕΑΛ ΑΒΕΕΔΕΣ",
  "ΜΕΤΟΧΕΣ - ΙΝΤΕΚ",
  "ΜΕΤΟΧΕΣ - ΙΝΤΕΤ",
  "ΜΕΤΟΧΕΣ - ΙΝΤΚΑ",
  "ΜΕΤΟΧΕΣ - ΙΝΤΡΑΚΑΤ",
  "ΜΕΤΟΧΕΣ - ΙΝΤΡΑΚΟΜ",
  "ΜΕΤΟΧΕΣ - ΙΝΤΡΑΚΟΜ Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΙΝΤΡΑΚΟΜ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΙΝΤΡΑΚΟΜ ΑΕ (ΚΟ) ΑΥΛΟ",
  "ΜΕΤΟΧΕΣ - ΙΝΤΡΑΚΟΜ ΑΕ [ΚΟ] ΑΥΛΟ",
  "ΜΕΤΟΧΕΣ - ΙΝΤΡΑΛΟΤ Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΙΝΤΡΑΛΟΤ Α.Ε. (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΙΝΦΟΡΜ ΛΥΚΟΣ Α",
  "ΜΕΤΟΧΕΣ - ΙΧΘ/ΦΕΙΑ ΣΕΛΟΝΤΑ ΑΕΓΕ",
  "ΜΕΤΟΧΕΣ - ΚΑΘΗΜΕΡΙΝΗ",
  "ΜΕΤΟΧΕΣ - ΚΑΘΗΜΕΡΙΝΗ Α.Ε",
  "ΜΕΤΟΧΕΣ - ΚΑΡΑΜΟΛΕΓΚΟΣ Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΚΑΡΑΤΖΗΣ ΑΕ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΚΕΚΡΩΨ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΚΕΜ ΓΡΗΓΟΡΙΑΔΗΣ ΓΕΩΡΓΙΟΣ",
  "ΜΕΤΟΧΕΣ - ΚΕΡΑΜΕΙΑ ΑΛΛΑΤΙΝΗ Α.Ε",
  "ΜΕΤΟΧΕΣ - ΚΕΡΑΝΗΣ",
  "ΜΕΤΟΧΕΣ - ΚΕΡΑΝΗΣ ΣΥΜΜΕΤΟΧΩΝ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΚΛΩΝΑΤΕΞ",
  "ΜΕΤΟΧΕΣ - ΚΛΩΝΑΤΕΧ ΑΒΕΕ-ΠΟ",
  "ΜΕΤΟΧΕΣ - ΚΛΩΝΠ",
  "ΜΕΤΟΧΕΣ - ΚΟ",
  "ΜΕΤΟΧΕΣ - ΚΟΙΝ ΟΝΟΜ ΜΕΤΟΧΕΣ",
  "ΜΕΤΟΧΕΣ - ΚΟΙΝ. ΟΝ.Μ.",
  "ΜΕΤΟΧΕΣ - ΚΟΙΝ.ΟΝΟΜ.ΜΕΤΟΧΗ Σ",
  "ΜΕΤΟΧΕΣ - ΚΟΙΝΕΣ ΟΝΟΜ ΜΕΤΟΧΕΣ",
  "ΜΕΤΟΧΕΣ - ΚΟΙΝΕΣ ΟΝΟΜΑΣΤΙΚΕΣ CITY NEWS ΑΕ",
  "ΜΕΤΟΧΕΣ - ΚΟΙΝΕΣ ΟΝΟΜΑΣΤΙΚΕΣ ΜΕΤΟΧΕΣ Η ΑΥΓΗ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΚΟΡ-ΦΙΛ ΑΕΒΕ",
  "Μετοχές - ΚΟΡΡΕΣ",
  "ΜΕΤΟΧΕΣ - ΚΟΡΡΕΣ Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΚΟΥΜΠΑΣ ΣΥΜΜΕΤΟΧΩΝ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΚΡΕΤΑ ΦΑΡΜ ΑΒΕΕ",
  "ΜΕΤΟΧΕΣ - ΚΥΛ/ΜΥΛΟΙ Κ. ΣΑΡΑΝΤΟΠ. (ΚΟ) ΑΥΛΟ",
  "ΜΕΤΟΧΕΣ - ΚΥΠΡ",
  "Μετοχές - ΚΥΠΡΟΥ",
  "ΜΕΤΟΧΕΣ - ΚΥΡΜ",
  "Μετοχές - ΛΑΒ1",
  "ΜΕΤΟΧΕΣ - ΛΑΒΙ",
  "ΜΕΤΟΧΕΣ - ΛΑΜΔΑ",
  "ΜΕΤΟΧΕΣ - ΛΑΜΨΑ",
  "ΜΕΤΟΧΕΣ - ΛΑΝΑΚΑΜ Κ Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΛΟΓΟΣ",
  "ΜΕΤΟΧΕΣ - Μ. Α.Ε. GRS087003000",
  "ΜΕΤΟΧΕΣ - Μ.Α.ΚΑΡΑΤΖΗ Α.Ε",
  "ΜΕΤΟΧΕΣ - ΜΑΡΜΑΡΑ ΚΑΒΑΛΑΣ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΜΕΓΑΡΟ ΦΥΤΑΚΗ Α.Ε. ΤΟΥΡΙΣΤΙΚΕΣ ΞΕΝΟΔΟΧΕΙΑΚΕΣ ΕΠΙΧΕΙΡΗΣΕΙΣ",
  "ΜΕΤΟΧΕΣ - ΜΕΓΑΡΟ ΦΥΤΑΚΗ Α.Ε. ΤΟΥΡΙΣΤΙΚΕΣ ΞΕΝΟΔΟΧΕΙΑΚΕΣ ΕΠΙΧΕΙΡΗΣΕΙΣ ΚΡΗΤΗΣ",
  "Μετοχές - ΜΕΤΚΑ",
  "ΜΕΤΟΧΕΣ - ΜΕΤΚΑ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΜΕΤΚΑ ΒΙΟΜΗΧ- ΚΑΤΑΣΚ/ΚΗ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΜΕΤΟΧΕΣ",
  "ΜΕΤΟΧΕΣ - ΜΕΤΟΧΕΣ HELLENIC SEAWAYS",
  "ΜΕΤΟΧΕΣ - ΜΕΤΟΧΕΣ NEL Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΜΕΤΟΧΕΣ ΕΘΝΙΚΗΣ ΤΡΑΠ",
  "ΜΕΤΟΧΕΣ - ΜΕΤΟΧΕΣ ΕΣΩΤΕΡΙΚΟΥ",
  "ΜΕΤΟΧΕΣ - ΜΕΤΟΧΕΣ ΕΤΑΙΡΕΙΑΣ ''ΨΥΓΕΙΑ ΑΛΠΕΙΣ''",
  "ΜΕΤΟΧΕΣ - ΜΕΤΟΧΕΣ ΕΤΑΙΡΕΙΑΣ 'ΨΥΓΕΙΑ ΑΛΠΕΙΣ'",
  "ΜΕΤΟΧΕΣ - ΜΕΤΟΧΕΣ ΕΤΕ",
  "ΜΕΤΟΧΕΣ - ΜΕΤΟΧΕΣ ΤΑΧΥΔΡΟΜΙΚΟΥ ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΜΕΤΟΧΕΣ - ΜΗΧΑΝΙΚΗ (ΚΟ) ΑΕ",
  "ΜΕΤΟΧΕΣ - ΜΗΧΑΝΙΚΗ Α.Ε. - ΠΟ",
  "ΜΕΤΟΧΕΣ - ΜΗΧΑΝΙΚΗ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΜΗΧΑΝΙΚΗ ΑΕ [ΚΟ] ΑΥΛΟ",
  "ΜΕΤΟΧΕΣ - ΜΗΧΚ",
  "ΜΕΤΟΧΕΣ - ΜΗΧΠ",
  "ΜΕΤΟΧΕΣ - ΜΙΓ",
  "ΜΕΤΟΧΕΣ - ΜΙΝ",
  "ΜΕΤΟΧΕΣ - ΜΙΝΕΡΒΑ Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΜΙΝΟΑ-ΜΙΝΩΙΚΕΣ ΓΡΑΜΜΕΣ ΑΝΕ",
  "ΜΕΤΟΧΕΣ - ΜΙΝΩΙΚΕΣ ΓΡΑΜΜΕΣ ΑΝΕ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΜΟΤΟ",
  "ΜΕΤΟΧΕΣ - ΜΟΤΟΡ ΟΙΛ",
  "ΜΕΤΟΧΕΣ - ΜΟΥΖΑΚΗΣ ΑΕΒΕΜ",
  "ΜΕΤΟΧΕΣ - ΜΟΥΖΚ",
  "ΜΕΤΟΧΕΣ - ΜΠΑΜΠΗΣ ΒΩΒΟΣ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΜΠΗΤΡΟΣ ΣΥΜΜΕΤΟΧΙΚΗ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΜΠΗΤΡΟΣ(ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΜΠΟΥΤΑΡΗΣ (ΚΑ)",
  "ΜΕΤΟΧΕΣ - ΜΠΟΥΤΑΡΗΣ & ΥΙΟΣ Α.Ε.-ΚΑ",
  "ΜΕΤΟΧΕΣ - ΜΠΟΥΤΑΡΗΣ Κ.Α.",
  "ΜΕΤΟΧΕΣ - ΜΥΤΙΛ",
  "Μετοχές - ΜΥΤΙΛΗΝΑΙΟΣ",
  "ΜΕΤΟΧΕΣ - ΜΥΤΙΛΗΝΑΙΟΣ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΜΥΤΙΛΗΝΑΙΟΣ Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΜΥΤΙΛΗΝΑΙΟΣ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΜΥΤΙΛΗΝΑΙΟΣ ΑΕ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΜΥΤΙΛΗΝΑΙΟΣ ΑΕ [ΚΟ] ΑΥΛΟ",
  "ΜΕΤΟΧΕΣ - ΜΥΤΙΛΛΗΝΑΙΟΣ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΜΥΤΙΛΟΙ",
  "ΜΕΤΟΧΕΣ - Ν.ΒΕΡΒΕΡΗΣ-MODA BAGNO",
  "ΜΕΤΟΧΕΣ - Ν.Ε.Λ. ΑΕ",
  "ΜΕΤΟΧΕΣ - ΝΑΚΑΣ",
  "ΜΕΤΟΧΕΣ - ΝΑΥΠ",
  "ΜΕΤΟΧΕΣ - ΝΑΥΠ ΚΛΩΣΤΟΥΦΑΝΤ.ΝΑΥΠ ΑΚΤΟΥ ΑΒΕΕ",
  "ΜΕΤΟΧΕΣ - ΝΑΥΤ",
  "ΜΕΤΟΧΕΣ - ΝΑΥΤ. ΕΤ. ΛΕΣΒΟΥ",
  "ΜΕΤΟΧΕΣ - ΝΑΥΤΕΜΠΟΡΙΚΗ",
  "ΜΕΤΟΧΕΣ - ΝΑΥΤΙΛ. ΕΤ. ΛΕΣΒΟΥ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΝΑΥΤΙΛΙΑΚΗ ΕΤΑΙΡΕΙΑ ΛΕΣΒΟΥ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΝΕΛ",
  "ΜΕΤΟΧΕΣ - ΝΕΛ Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΝΕΛ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΝΕΩΡΙΟΝ Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΝΗΡΕΥΣ",
  "ΜΕΤΟΧΕΣ - ΝΗΡΕΥΣ ΑΕ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΝΙΔΑ ΑΕ ΤΟΥΡΙΣΤΙΚΑΙ ΚΑΙ ΞΕΝΟΔΟΧΕΙΑΚΑΙ ΕΠΙΧΕΙΡΗΣΕΙΣ",
  "ΜΕΤΟΧΕΣ - Ο.Τ.Ε",
  "ΜΕΤΟΧΕΣ - Ο.Τ.Ε.",
  "ΜΕΤΟΧΕΣ - ΟΛΠ",
  "ΜΕΤΟΧΕΣ - ΟΛΥΜΠ",
  "ΜΕΤΟΧΕΣ - ΟΛΥΜΠ ΤΕΧΝΙΚΗ ΟΛΥΜΠΙΑΚΗ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΟΛΥΜΠΙΑΚΗ",
  "ΜΕΤΟΧΕΣ - ΟΜΙΛΟΣ ΙΝΤΕΑΛ ΑΒΕΕ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΟΜΙΛΟΣ ΙΝΤΕΑΛ ΑΒΕΕ [ΚΟ]",
  "ΜΕΤΟΧΕΣ - ΟΠΑΠ",
  "ΜΕΤΟΧΕΣ - ΟΠΑΠ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΟΠΑΠ Α.Ε -ΚΟ",
  "ΜΕΤΟΧΕΣ - ΟΠΑΠ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΟΠΑΠ ΑΕ ΚΑ",
  "ΜΕΤΟΧΕΣ - ΟΡΓ. ΤΗΛ. ΕΛΛ. Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΟΡΓ/ΣΜΟΣ ΠΡΟΓ/ΚΩΝ ΑΓ/ΩΝ ΠΟΔ/ΟΥ",
  "ΜΕΤΟΧΕΣ - ΟΡΓΑΝ.ΤΗΛ/ΝΙΩΝ ΕΛΛ(ΚΟ) ΑΥΛΟ",
  "ΜΕΤΟΧΕΣ - ΟΡΓΑΝΙΣΜΟΣ ΛΙΜΕΝΟΣ ΠΕΙΡΑΙΩΣ",
  "ΜΕΤΟΧΕΣ - ΟΡΓΑΝΙΣΜΟΣ ΤΗΛ/ΩΝ ΕΛΛ",
  "ΜΕΤΟΧΕΣ - ΟΡΓΑΝΙΣΜΟΣ ΤΗΛΕΠΙΚ. (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΟΡΓΑΝΙΣΜΟΣ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ ΕΛΛΑΔΟΣ",
  "ΜΕΤΟΧΕΣ - ΟΤΕ",
  "ΜΕΤΟΧΕΣ - ΟΤΕ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΟΤΕ Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΟΤΕ-ΟΤΕ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΠΑΠ",
  "ΜΕΤΟΧΕΣ - ΠΑΠΟΥΤΣΑΝΗΣ ΚΑΤΑΝ ΑΓΑΘΩΝ [ΚΟ]",
  "ΜΕΤΟΧΕΣ - ΠΕΙΡΑΙΩΣ",
  "ΜΕΤΟΧΕΣ - ΠΕΙΡΑΙΩΣ ΤΡΑΠΕΖΑ",
  "ΜΕΤΟΧΕΣ - ΠΕΙΡΤΠ",
  "ΜΕΤΟΧΕΣ - ΠΕΡΣΕΥΣ ΑΒΕΕ",
  "ΜΕΤΟΧΕΣ - ΠΕΤΡΟΠΟΥΛΟΣ",
  "ΜΕΤΟΧΕΣ - ΠΗΓΑΣ",
  "ΜΕΤΟΧΕΣ - ΠΗΓΑΣΟΣ",
  "ΜΕΤΟΧΕΣ - ΠΗΓΑΣΟΣ ΕΚΔΟΤΙΚΗ",
  "ΜΕΤΟΧΕΣ - ΠΗΓΑΣΟΣ ΕΚΔΟΤΙΚΗ Α. Ε",
  "ΜΕΤΟΧΕΣ - ΠΗΓΑΣΟΣ ΕΚΔΟΤΙΚΗ Α.Ε",
  "ΜΕΤΟΧΕΣ - ΠΗΓΑΣΟΣ ΕΚΔΟΤΙΚΗ Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΠΗΓΑΣΟΣ ΕΚΔΟΤΙΚΗ Α.Ε. - ΚΟ",
  "ΜΕΤΟΧΕΣ - ΠΗΓΑΣΟΣ ΕΚΔΟΤΙΚΗ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΠΛΑΙΣ",
  "ΜΕΤΟΧΕΣ - ΠΛΑΙΣΙΟ COMPUT",
  "ΜΕΤΟΧΕΣ - ΠΟΣΕΙΔΩΝ Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΠΟΣΕΙΔΩΝ Α.Ε. ΞΕΝΟΔΟΧΕΙΑΚΩΝ, ΤΟΥΡΙΣΤΙΚΩΝ ΚΑΙ ΝΑΥΤΙΛΙΑΚΩΝ ΕΠΙΧΕΙΡΗΣΕΩΝ",
  "ΜΕΤΟΧΕΣ - ΠΡΔ",
  "ΜΕΤΟΧΕΣ - ΠΡΟΪΟΝΤΑ Χ.Α.",
  "ΜΕΤΟΧΕΣ - ΠΡΟΙΟΝΤΑ ΧΑ",
  "ΜΕΤΟΧΕΣ - ΡΑΔΑΜΑΝΘΥΣ Α.Ε. ΞΕΝΟΔΟΧΕΙΑΚΩΝ, ΤΟΥΡΙΣΤΙΚΩΝ ΚΑΙ ΝΑΥΤΙΛΙΑΚΩΝ ΕΠΙΧΕΙΡΗΣΕΩΝ",
  "ΜΕΤΟΧΕΣ - ΣΕΛΜΑΝ (ΚΟ) ΑΥΛΟ",
  "ΜΕΤΟΧΕΣ - ΣΕΛΟ",
  "ΜΕΤΟΧΕΣ - ΣΠΙΝΤΕΡ",
  "ΜΕΤΟΧΕΣ - ΣΥΝΕΤΑΙΡΙΣΤΙΚΕΣ ΜΕΡΙΔΕΣ",
  "ΜΕΤΟΧΕΣ - ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ",
  "ΜΕΤΟΧΕΣ - ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΕΒΡΟΥ",
  "ΜΕΤΟΧΕΣ - ΣΥΝΕΤΑΙΡΙΣΤΙΚΗ ΤΡΑΠΕΖΑ ΚΑΡΔΙΤΣΑΣ",
  "ΜΕΤΟΧΕΣ - ΣΩΛΗΝΟΥΡΓΕΙΑ ΚΟΡΙΝΘΟΥ",
  "ΜΕΤΟΧΕΣ - ΤΑΜΙΕΥΤΗΡΙΟ",
  "ΜΕΤΟΧΕΣ - ΤΑΧ.ΤΑΜΙΕΥΤΗΡΙΟ (ΚΟ)",
  "Μετοχές - ΤΑΧΥΔΡΟΜΙΚΟ ΤΑΜΙΕΥΤΗΡΙΟ",
  "ΜΕΤΟΧΕΣ - Ταχυδρομικό Ταμιευτήριο Α.Τ.Ε",
  "ΜΕΤΟΧΕΣ - ΤΑΧΥΔΡΟΜΙΚΟ ΤΑΜΙΕΥΤΗΡΙΟ Α.Τ.Ε.",
  "ΜΕΤΟΧΕΣ - ΤΑΧΥΔΡΟΜΙΚΟ ΤΑΜΙΕΥΤΗΡΙΟ ΕΛΛΑΔΟΣ",
  "ΜΕΤΟΧΕΣ - ΤΑΧΥΔΡΟΜΙΚΟ ΤΑΜΙΕΥΤΗΡΙΟ ΕΛΛΑΔΟΣ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΤΒΑΝΚ",
  "ΜΕΤΟΧΕΣ - ΤΕΓΟ",
  "ΜΕΤΟΧΕΣ - ΤΕΚΔΟ",
  "ΜΕΤΟΧΕΣ - ΤΕΡΝΑ ΕΝΕΡΓΕΙΑ",
  "ΜΕΤΟΧΕΣ - ΤΕΡΝΑ ΕΝΕΡΓΕΙΑΚΗ",
  "ΜΕΤΟΧΕΣ - ΤΕΧΝΙΚΗ ΟΛΥΜΠΙΑΚΗ Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΤΕΧΝΙΚΗ ΟΛΥΜΠΙΑΚΗ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΤΖΚΑ",
  "ΜΕΤΟΧΕΣ - ΤΗΛΕΤΥΠΟΣ ΑΕ (ΚΟ)",
  "Μετοχές - ΤΙΤΑΝ",
  "ΜΕΤΟΧΕΣ - ΤΙΤΑΝ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΤΙΤΚ",
  "ΜΕΤΟΧΕΣ - ΤΡΑΠΕΖΑ EUROBANK",
  "ΜΕΤΟΧΕΣ - ΤΡΑΠΕΖΑ EUROBANK ERGAS",
  "Μετοχές - Τράπεζα Ελλάδος",
  "ΜΕΤΟΧΕΣ - ΤΡΑΠΕΖΑ ΚΥΠΡΟΥ",
  "ΜΕΤΟΧΕΣ - ΤΡΑΠΕΖΑ ΚΥΠΡΟΥ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ",
  "ΜΕΤΟΧΕΣ - ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ Α.Ε",
  "ΜΕΤΟΧΕΣ - ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ Α.Ε.",
  "ΜΕΤΟΧΕΣ - ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ Α.Ε. (ΚΟ)",
  "ΜΕΤΟΧΕΣ - ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ",
  "ΜΕΤΟΧΕΣ - ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ ΑΕ",
  "ΜΕΤΟΧΕΣ - ΤΡΑΠΕΖΙΚΟΙ ΤΙΤΛΟΙ (ΑΝΑΛΥΣΗ ΠΙΟ ΚΑΤΩ)",
  "ΜΕΤΟΧΕΣ - ΤΤ",
  "ΜΕΤΟΧΕΣ - ΥΙΟΙ",
  "ΜΕΤΟΧΕΣ - ΥΙΟΙ Β.ΥΨΗΛΑΝΤΗ Α.Ε.Β.Ε",
  "ΜΕΤΟΧΕΣ - ΥΙΟΙ ΧΑΤΖΗΚΑΡΑΝΙΩΤΗ",
  "ΜΕΤΟΧΕΣ - ΥΙΟΙ ΧΑΤΖΗΚΡΑΝΙΟΤΗ (ΚΟ)",
  "ΜΕΤΟΧΕΣ - Φ.ΝΑΚΑΣ ΑΒΕΕΤΕ ΚΟ",
  "ΜΕΤΟΧΕΣ - ΦΙΕΡ",
  "ΜΕΤΟΧΕΣ - ΦΙΛΛΙΠΟΣ ΝΑΚΑΣ ΑΒΕΕΤΕ",
  "ΜΕΤΟΧΕΣ - ΦΙΛΟΞΕΝΙΑ Α.Ε. ΤΟΥΡΙΣΤΙΚΗ, ΞΕΝΟΔΟΧΕΙΑΚΗ, ΟΙΚΟΔΟΜΙΚΗ ΚΑΙ ΝΑΥΤΙΛΙΑΚΗ ΕΤΑΙΡΕΙΑ",
  "ΜΕΤΟΧΕΣ - ΦΡΙΓΟ",
  "ΜΕΤΟΧΕΣ - ΦΡΙΓΟΓΛΑΣ",
  "ΜΕΤΟΧΕΣ - ΦΦΓΚΡΠ",
  "ΜΕΤΟΧΕΣ - ΦΦΓΚΡΤΙ",
  "ΜΕΤΟΧΕΣ - Χ.Κ. ΤΕΓΟΠΟΥΛΟΣ ΕΚΔΟΣΕΙΣ ΑΥΛΟ",
  "ΜΕΤΟΧΕΣ - ΧΑΛΥΒ",
  "ΜΕΤΟΧΕΣ - ΧΑΡΤΟΦΥΛΑΚΙΟ ΜΕΤΟΧΩΝ",
  "ΜΕΤΟΧΕΣ - ΧΑΤΖΚ",
  "ΜΕΤΟΧΕΣ - ΧΡΗΜΑΤΗΣΤΗΡΙΟ ΑΘΗΝΩΝ",
  "ΜΕΤΟΧΕΣ - ΧΡΗΜΑΤΙΚΟ ΥΠΟΛΟΙΠΟ",
  "ΜΕΤΟΧΕΣ - ΧΡΗΜΑΤΙΣΤΗΡΙΑΚΑ",
  "Μετοχές (Eurobank)",
  "Μετοχές (Εθνική Τράπεζα)",
  "Μετοχές (ΕΛΛΑΚΤΩΡ)",
  "Μετοχές (ΛΙΘΟΤΟΜΗ - ΑΝΑΠΑΣΗ ΑΕ)",
  "Μετοχές (ΜΠΟΥΤΑΡΗΣ ΚΑ)",
  "Μετοχές (ΟΠΑΠ)",
  "Μετοχές (ΟΤΕ)",
  "ΜΕΤΟΧΕΣ + EUROBANK ERGASIAS",
  "ΜΕΤΟΧΕΣ + SPRINTER ΜΕΤ/ΝΑ",
  "ΜΕΤΟΧΕΣ + ΑΛΚΟ ΕΛΑΣ ΑΒΕΕ",
  "ΜΕΤΟΧΕΣ + ΝΤΡΙΑΡΤ ΑΒΕΕ",
  "ΜΕΤΟΧΕΣ EUROBANK ERGASIAS",
  "ΜΕΤΟΧΕΣ SPRINTER ΜΕΤΑΛ/ΝΙΑ",
  "ΜΕΤΟΧΕΣ ΑΛΚΟ ΕΛΛΑ ΑΒΕΕ",
  "Μετοχές Αλλοδαπών Εισηγημένων Εταιριών - APPLE COMPUTER",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ALTRIA",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - APPLE INC",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - BOSTON SCIENTIFIC",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - CISCO SYSTEMS",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - DOW CHEMICAL",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ENERGY TRANSFER",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - FACEBOOK",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - FORD MOTOR",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - HELEST PLC",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - HSBC HOLDINGS",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - JET BLUE AIRWAYS",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - JPMORGAN CO",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - MASTERCARD",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - NAVIOS MARITIME",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - TEVA PHARMA",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - TSAKOS NAVIGATIO",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - WALT DISNEY",
  "Μετοχές αλλοδαπών εισηγμένων εταιρειών (Samsung Electronics)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών - APPLE COMPUTER",
  "Μετοχές Αλλοδαπων Εισηγμένων Εταιριών - SFS",
  "Μετοχές Αλλοδαπών Εισηγμένων Εταιριών - Τράπεζα Κύπρου μετοχές (από υποχρεωτική μετατροπή μετατρέψιμων αξιόγραφων κεφαλαίου",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών (American Tower Reit INC)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών (Apple Computer)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών (Argiculture ΕΠΕ)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών (Coca cola Company)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών (Electricite de France)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών (Exxon Mobil Corporation)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών (Facebook)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών (GSV Capital Corp)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών (I Shares Silver Trust)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών (ING Europe)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών (Samsung Electronics GDR)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών (Sanofi Synthelabo)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών (SFS)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών (Solvay SA)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών (Toyota Motor)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών (Unicredit SPA)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών (VOYA GLOBAL EQUITY DIVIDEND)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών (Α/Κ Eurobank Greek Equities Μετοχές Εσωτερικού)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών (Εθνική Τράπεζα)",
  "Μετοχές αλλοδαπών εισηγμένων εταιριών, A/K EUROBANK GREEK EQUITIES Μετοχ. Εσωτερ.",
  "Μετοχές αλλοδαπών μη εισηγμένων εταιριών - BBVA INVEST. MNG LTD",
  "Μετοχές αλλοδαπών μη εισηγμένων εταιριών - BBVA INVEST.MNG LTD",
  "Μετοχές αλλοδαπών μη εισηγμένων εταιριών - Helesi PLC",
  "Μετοχές αλλοδαπών μη εισηγμένων εταιριών - MELLON INV. S.A.",
  "Μετοχές αλλοδαπών μη εισηγμένων εταιριών - SEA AMAZON SHIPPING LIMITED (πλοιοκτήτρια εταιρία εδρεύουσα στη Μάλτα)",
  "Μετοχές αλλοδαπών μη εισηγμένων εταιριών - SUNSET GLORY",
  "Μετοχές αλλοδαπών μη εισηγμένων εταιριών - SUNSET GLORY LTD",
  "Μετοχές αλλοδαπών μη εισηγμένων εταιριών (Smartstore AE)",
  "Μετοχές αλλοδαπών μη εισηγμένων εταιριών (Sunset Glory)",
  "Μετοχές Ημεαδαπών Εισηγμένων Εταιριών (ΑΛΚΟ)",
  "Μετοχές Ημεαδαπών Εισηγμένων Εταιριών (ΒΑΡΝΗ)",
  "Μετοχές Ημεαδαπών Εισηγμένων Εταιριών (ΕΝΚΛΟ)",
  "Μετοχές Ημεαδαπών Εισηγμένων Εταιριών (ΕΥΔΑΠ)",
  "Μετοχές Ημεαδαπών Εισηγμένων Εταιριών (ΙΜΠΕΡΙΟ)",
  "Μετοχές Ημεαδαπών Εισηγμένων Εταιριών (ΜΕΤΚ)",
  "Μετοχές Ημεαδαπών Εισηγμένων Εταιριών (ΜΠΑΝΤ)",
  "Μετοχές Ημεαδαπών Εισηγμένων Εταιριών (ΝΕΛ)",
  "Μετοχές Ημεαδαπών Εισηγμένων Εταιριών (ΠΕΙΡΑΙΩΣ)",
  "Μετοχές Ημεαδαπών Εισηγμένων Εταιριών (ΣΠΙΝΤ)",
  "Μετοχές Ημεαδαπών Εισηγμένων Εταιριών (ΦΡΙΓΟ)",
  "Μετοχές ημεδαπών εισηγημένων εταιριών - Eurobank",
  "Μετοχές Ημεδαπών Εισηγημένων Εταιριών - MOTOR OIL",
  "Μετοχές ημεδαπών εισηγημένων εταιριών - ΑΕΓΕΚ",
  "Μετοχές ημεδαπών εισηγημένων εταιριών - ΑΙΟΛΙΚΗ",
  "Μετοχές ημεδαπών εισηγημένων εταιριών - ΑΙΟΛΚ",
  "Μετοχές ημεδαπών εισηγημένων εταιριών - ΒΕΤΑΝΕΤ ΑΒΕΕ",
  "Μετοχές Ημεδαπών Εισηγημένων Εταιριών - ΕΘΝΙΚΗ WARRANT",
  "Μετοχές Ημεδαπών Εισηγημένων Εταιριών - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ",
  "Μετοχές ημεδαπών εισηγημένων εταιριών - ΕΤΕ",
  "Μετοχές ημεδαπών εισηγημένων εταιριών - ΚΛΩΝΑΤΕΞ",
  "Μετοχές Ημεδαπών Εισηγημένων Εταιριών - ΜΥΤΙΛΗΝΑΙΟΣ Α.Ε.",
  "Μετοχές Ημεδαπών Εισηγημένων Εταιριών - ΟΤΕ Α.Ε.",
  "Μετοχές ημεδαπών εισηγημένων εταιριών - ΣΠΡΙ",
  "Μετοχές ημεδαπών εισηγημένων εταιριών - Τράπεζα Κύπρου",
  "Μετοχές ημεδαπών εισηγημένων εταιριών - Τράπεζα Πειραιώς",
  "Μετοχές ημεδαπών εισηγημένων εταιριών - ΦΦΓΚΡΠ",
  "Μετοχές ημεδαπών εισηγημένων εταιριών - ΦΦΦΚΡΠ",
  "Μετοχές ημεδαπών εισηγμάνων εταιριών - EUROMEDICA AE",
  "Μετοχές ημεδαπών εισηγμάνων εταιριών - HLEKTRONIKH AUHNVN AE",
  "Μετοχές ημεδαπών εισηγμάνων εταιριών - ΒΑΡΒΑΡΕΣΣΟΣ ΑΕ",
  "Μετοχές Ημεδαπών Εισηγμένων (ΑΕΡΟΠΟΡΙΑ ΑΙΓΑΙΟΥ)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ALPHA BANK",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ALPHA BANK",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ETE",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - EUROBANK",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - EUROBANK ERGASIAS",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - GRIVALIA PROJECT",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - J&P ABAX",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - OTE",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - OΠΑΠ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - VINARTIA",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - WARRANTS ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΑΘΗΝΑΙΚΕΣ ΣΥΜΜΕΤΟΧΕΣ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΑΛΚΟ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΑΛΤΕΚ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΑΛΦΑ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΑΤΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΒΙΟΜ/ΚΑ ΤΕΧΝΙΚΑ ΕΡΓΑ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΒΙΟΤΕΡ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ WARRANDS",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΑΕ (ΚΟ)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΕΛΒΑ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΕΛΛΗΝ. ΠΕΤΡΕΛΑΙΑ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΕΛΠΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΕΛΠΕ ΑΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΕΝ ΚΛΩ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΕΝΚΛΩ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΕΤΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΕΤΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΕΤΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΕΤΕ ΤΠ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΕΥΡΩΒ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΕΦΤΖΙ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΙΝΤΕΚ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΙΝΤΡΑΚΟΜ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΚΛΩΝΠ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΚΥΡΜ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΜΗΧΚ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΜΙΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΜΟΥΖΚ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΜΟΧΛ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΝΑΥΠ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΝΗΡΕΑΣ - ΙΧΘΥΟΚ.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΤΡΑΠΕΖΑ ΗΠΕΙΡΟΥ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ -ETE",
  "Μετοχές Ημεδαπών Εισηγμένων εταιρειών (ALTEC συμμετοχών Α.Β.Ε.Ε.)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιρειών (AXON)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ (EFG EUROBANK)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ (FORTIS S.A)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ (FRIGO GLASS)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ (ΑΓΡΟΤΙΚΗ ΤΡΑΠΕΖΑ)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ (ΑΕΡΟΠΟΡΙΑ ΑΙΓΑΙΟΥ ΑΕ)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ (ΒΙΟΧΑΛΚΟ)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ (ΙΑΣΩ Α.Ε.)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιρειών (Μηχανική ΑΕ)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ (ΝΕΩΡΣ ΝΕΩΡΙΟΝ)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ (Ο.Τ.Ε.)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ (ΟΤΟΕΛ)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ (ΠΛΑΙΣΙΟ)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιρειών (Τράπεζα Κύπρου)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ (ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ ΑΕ)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ (ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ CYCOS INFORM",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ WARRANDS ALPHA BANK",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ ΑΛΦΑ ΤΠ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ ΚΟΡΦΕΑ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ALPHA",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ALPHA BANK",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ALPHA BANK (A.M.K.)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ALPHA BANK (KO)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - Alpha Bank A.E.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ALPHA TRUST",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ALPHA ΑΕ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ALPHA ΤΡΑΠΕΖΑ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ALPHA ΤΡΑΠΕΖΑ (ΤΠΔ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Alpha Τράπεζα Α.Ε.",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ALPHA Τράπεζα Δικαιώματα",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ANEK (KO)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ATE",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ATE BANK",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ATTICA BANK",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - AVENIR A.E.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - AVERIN A.E.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - AVERIN AE",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - AΛΟΥΜΥΛ ΜΥΛΩΝΑΣ Α.Ε.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - CP | AE ΗΛΕΚΤΡ. ΥΠΟΛ.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - CPI AE H/Y",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ETE",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ETE WARRANTS",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - EUROBANK",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - EUROBANK",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - EUROBANK - ERGASIAS",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - EUROBANK ERGASIAS",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Eurobank Ergasias A.E.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Eurobank Ergasias S.A.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - Eurobank Ergasias SA",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - EUROBANK ERGASIAS ΑΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - EURODRIP",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - EUROMEDICA A.E.",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - EXAE",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - FFG EUROBANK ERGASIAS AE",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - FOLLI-FOLLIE ABETE",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - FORTHNET",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - FORTHNET AE",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - FRIGO GLASS",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - FRIGOGLASS",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - FRIGOGLASS AE",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - INT | CAN ΑΝΑΠΤ. ΕΤ. ΜΤΧΕΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - INT | CAN ΕΛΛΗΝ. ΜΙΚΤ.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - INTERSONIC S.A.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - INTERSONIK A.E.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - INTRACOM Α.Ε.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - INTRAKOM",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - INTRALOT",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - INTRALOT A.E",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - INTΡΑΚΟΜ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - IΑΣΩ A.E.",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - IΝΤΡΑΛΟΤ ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - JUMBO",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Kαθημερινή",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - KΡΙ ΚΡΙ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - LAVI FARM",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - LAVIFARM",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - M.A. ΚΑΡΑΤΖΗ Α.Ε.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - Marfin Popular Bank",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - MARFIN ΕΛΛΗΝ. ΜΕΤΟΧΙΚΟ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - MOTOR OIL",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - NUTRIART ABEE (KO)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - PROTON BANK",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - QEST ΣΥΜΜΕΤΟΧΩΝ Α.Ε.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - QUALITY MNOBELAS",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - QUEST ΣΥΜ/ΧΩΝ ΑΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - REPOS",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - SPIDER ΜΕΤΑΛΛΟΒΙΟΜΗΧΑΝΙΑ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Spider Ν. Πέτσιος Υ.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - TBANK",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - TRASTOR Α.Ε.Ε.Α.Π.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - TZKA",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - UNIVIOS (KO)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - WARRANTS ALPHA",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - WARRANTS ISSUED",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Warrants Εθνικής Τράπεζας",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Α.Τ.Ε.",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - Αγροτική Τράπεζα",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΑΓΡΟΤΙΚΗ ΤΡΑΠΕΖΑ Α.Ε. (ΚΟ)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΑΕΓΕΚ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΑΕΡΟΠΟΡΙΑ ΑΙΓΑΙΟΥ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΑΕΡΟΠΟΡΙΑ ΑΙΓΑΙΟΥ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - Αεροπορία Αιγαίου",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΑΕΡΟΠΟΡΙΑ ΑΙΓΑΙΟΥ Α.Α.Ε.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΑΕΡΟΠΟΡΙΑ ΑΙΓΑΙΟΥ ΑΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΑΕΡΟΠΟΡΙΑ ΑΙΓΑΙΟΥ ΑΑΕ (ΚΟ)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΑΕΡΟΠΟΡΙΑ ΑΙΓΑΟΥ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΑΕΤΕΚ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΑΚΡΙΤΑΣ ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΑΛΚΟ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΑΛΚΟ ΕΛΛΑΣ ΑΒΕΕ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΑΛΟΥΜΥΛ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΑΛΤΕΚ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΑΛΦΑ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΑΛΦΑ ΤΠ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΑΛΦΑ Τράπεζα Α.Ε.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΑΝΔΡΟ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΑΝΕΚ (ΚΟ)",
  "Μετοχές Ημεδαπών Εισηγμένων εταιριών - ΑΝΕΚ Α.Ε.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΑΝΕΚ ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΑΣΤΗΡ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΑΣΤΗΡ ΠΑΛΑΣ ΑΞΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΑΤΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΑΤΛΑΝΤΙΚ ΣΟΥΠΕΡ ΜΑΡΚΕΤ Α.Ε.",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΑΤΤ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΑΤΤΙ-ΚΑΤ ΑΤΕ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΑΤΤΙΚ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΑΦΟΙ Χ. ΚΟΡΔΕΛΛΟΥ ΑΕΒΕ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΒΑΛΚ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΒΑΡΒΑΡΕΣΣΟΣ Α.Ε.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΒΑΡΒΑΡΕΣΣΟΣ ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΒΙΟΜΗΧΑΝΙΚΑ ΤΕΧΝΙΚΑ ΕΡΓΑ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΒΙΟΤ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΒΙΟΧΑΛΚΟ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΒΙΟΧΚ.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Γ. ΛΕΒΕΝΤΑΚΗΣ ΤΕΧ Α.Β.Ε.Ε. (ΚΑ)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - Γ.Ε. Δημητρίου Α.Ε.Ε",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Γ.Ε. ΔΗΜΗΤΡΙΟΥ Α.Ε.Ε (πρ. ΒΕΛΛ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΓΕΚ ΤΕΡΝΑ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΓΕΚ ΤΕΡΝΑ ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΓΕΝ. ΕΜΠΟΡΙΟΥ (ΚΟ) ΑΥΛΟ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΓΕΝΙΚΗ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΓΕΝΙΚΟΥ ΕΜΠΟΡΙΟΥ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΓΚΛΟΒ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - Δ.Ε.Η.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Δ.Ε.Η.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΔΑΙΟΣ ΠΛΑΣΤΙΚΑ ΑΒΕΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΔΕΗ ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΔΙΕΚΑΤ ΑΤΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΔΙΕΚΑΤ ΑΤΕ (ΚΟ) ΑΥΛΟ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΔΙΚ/ΜΑ ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΔΟΛ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΔΟΜΙΚΗ ΚΡΗΤΗΣ ΑΕ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - Ε.Τ.Ε.",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - Ε.Τ.Ε. Α.Ε.",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - Ε.Τ.Ε. Δικαιώματα",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - Εθνιική Τράπεζα",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - Εθνιική Τράπεζα (εκποίηση)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΘΝΙΚΗ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΘΝΙΚΗ WARRANT ΕΤΕΤΠ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Εθνική Τράπεζα",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ (W)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΑΕ (ΚΟ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΕΛΛΑΔΟΣ (ΚΟ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ (Α.Μ.Κ.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΚΟΝ - Μ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΚΤΕΡ Α.Ε. (ΚΟ) ΑΥΛΟ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΚΤΕΡ ΑΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΛ. ΙΧΘ/ΓΕΙΕΣ ΑΒΕΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΛ. ΠΕ. Εξωτερικού",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΛΒΑ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΛΒΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΛΕΥΘΕΡΗ ΤΗΛΕΟΡΑΣΗ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΛΙΧΘ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΕΛΛ. ΧΡΗΜ.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΛΛ. ΧΡΗΜΑΤΙΣΤΗΡΙΑ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΛΛ. ΧΡΗΜΑΤΙΣΤΗΡΙΑ ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΛΛΑΚΤΩΡ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΛΛΑΚΤΩΡ - ΕΛΛΑΚΤΩΡ ΑΝΩΝΥΜΗ ΕΤΑΙΡΕΙΑ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΛΛΑΚΤΩΡ ΕΛΛΑΚΤΩΡ ΑΝΩΝΥΜΗ ΕΤΑΙΡΕΙΑ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΛΛΑΤΕΞ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΛΛΑΤΕΞ ΑΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΛΛΗΝΙΚΑ ΠΕΤΡΕΛΑΙΑ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΛΛΗΝΙΚΑ ΠΕΤΡΕΛΑΙΑ Α.Ε.-ΚΟ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΕΛΛΗΝΙΚΑ ΠΕΤΡΕΛΑΙΑ ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΛΛΗΝΙΚΑ ΧΡΗΜΑΤ.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Ελληνικά Χρηματιστήρια",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΛΠΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΛΠΕ ΑΕ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΕΛΠΕ ΕΛΛΗΝΙΚΑ ΠΕΤΡΕΛΑΙΑ Α.Ε.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΜΠΟΡΙΚΗ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΝΚΛΩ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΝΩΜ. ΚΛΩΣΤΟΥΦΑΝΤ.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΝΩΜΕΝΗ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΑ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΕΤΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΤΕ - ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΤΕ WARRADS",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΤΕ WARRANTS",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΤΕ ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΤΕ ΒΑΝΚ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΤΕ ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΤΕ ΤΠ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΤΕ ΤΠ ΕΤΕ WARRANTS",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΤΕΠΤ - Ε.Τ.Ε. ΑΝΩΝΥΜΗ ΕΤΑΙΡΕΙΑ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΤΕΠΤ - ΕΤΕ WARRANTS",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΕΤΕΤΜ ΕΤΜ WARRANTS",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΤΕΤΠ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΕΤΕΤΠ ΕΤΕ WARRANTS",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΥΑΑΠ ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΥΒΡΙΚ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΥΔΑΠ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΥΔΑΠ ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΥΠΙΚ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΥΡΩ Β EFG",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΥΡΩΒ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΥΡΩΠΑΪΚΗ ΠΙΣΤΗ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΥΡΩΣΥΜΒΟΥΛΟΙ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΦΤΖ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΕΧΑΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - Η ΚΑΘΗΜΕΡΙΝΗ ΑΕ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - Η ΚΑΘΗΜΕΡΙΝΗ ΑΕ ΕΚΔΟ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - Η ΚΑΘΗΜΕΡΙΝΗ Ε",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - Η ΝΑΥΤΕΜΠΟΡΙΚΗ ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΗΛΕΚΤΡΟΝΙΚΗ ΑΘΗΝΩΝ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΗΛΕΚΤΡΟΝΙΚΗ ΑΘΗΝΩΝ ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΙΑΣΩ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - Ιατρικό Αθηνών",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΙΝΛΟΤ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΙΝΤΑ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΙΝΤΕΚ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΙΝΤΕΡΤΕΚ Α.Ε.-ΚΟ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΙΝΤΚΑ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΙΝΤΡΑΚΟΜ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΙΝΤΡΑΚΟΜ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΙΝΤΡΑΚΟΜ Α.Ε. (ΚΟ) ΑΥΛΟ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΙΝΤΡΑΚΟΜ Α.Ε.(ΚΟ) ΑΥΛΟ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Ιχθ. ΔΙΑΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Ιχθ. ΣΕΠΟΝΤΑ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΙΧΘΥΟΤΡΟΦΕΙΑ ΣΕΛΟΝΤΑ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Καθημερινή",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΚΑΡΑΤΖΗ ΑΕ (ΚΟ)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΚΕΚΡΩΨ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΚΕΚΡΩΨ Α.Ε.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΚΕΡΑΝΗΣ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΚΕΡΑΝΗΣ ΣΥΜΜ. ΑΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΚΕΡΑΝΗΣ ΣΥΜΜΕΤΟΧΩΝ Α.Ε.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΚΛΩΝ. - ΚΛΩΝΑΤΕΞ ΟΜΙΛΟΣ ΕΠΙΧΕΙΡΗΣΕΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΚΛΩΝΑΤΕΞ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΚΛΩΝΑΤΕΞ ΑΒΝΤΤΕ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΚΛΩΝΑΤΕΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΚΛΩΝΠ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΚΛΩΝΠ - ΚΛΩΝΑΤΕΞ ΟΜΙΛΟΣ ΕΠΙΧΕΙΡΗΣΕΩΝ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΚΟΣΜ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΚΟΣΜΟΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΚΟΥΜΠΑΣ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΚΡΕΤΑ ΦΑΡΜ ΑΒΕΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΚΡΙ ΚΡΙ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΚΥΠΡ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΚΥΡΜ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΛΕΒΕΝΤΑΚΗΣ ΑΒΕΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΛΟΓΟΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Μ.Α. ΚΑΡΑΤΖΗ Α.Ε.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΕΤΚΑ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΕΤΚΑ (ΚΟ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΕΤΟΧΕΣ ΕΤΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΜΕΤΟΧΕΣ ΕΤΕ WARRAND",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΕΤΟΧΕΣ ΕΤΕ WARRANTS",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΗΧ Π",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΗΧ. Κ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΗΧΑΝΙΚΗ (ΚΟ)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΜΗΧΑΝΙΚΗ Α.Ε.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΜΗΧΑΝΙΚΗ ΑΕ(ΚΟ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΗΧΚ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΙΓ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΙΝ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΙΝΩΙΚΕΣ ΓΡΑΜΜΕΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΟΥΖ Κ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΟΥΖΚ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΟΧΛ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΟΧΛΟΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΟΧΛΟΣ Α.Ε.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΟΧΛΟΣ Α.Ε. (ΚΟ) ΑΥΛΟ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΟΧΛΟΣ ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΟΧΛΟΣ ΑΕ (ΚΟ) ΑΥΛΟ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Μπάμπης Βωβός",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΠΗΤΡΟΣ ΑΕΒΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΥΤΙΛ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΥΤΙΛΗΝΑΙΟΣ (ΚΟ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΥΤΙΛΗΝΑΙΟΣ Α.Ε.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΜΥΤΙΛΗΝΑΙΟΣ ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Νατευμπορική ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΝΑΥΠ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΝΑΥΠΙΚ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΝΑΥΤ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΝΑΥΤ. ΕΤ. ΛΕΣΒΟΥ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΝΑΥΤ. ΕΤ. ΛΕΣΒΟΥ Α.Ε. (ΚΟ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΝΕΔ ΑΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΝΕΛ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΝΕΩΡΣ ΝΕΩΡΙΟΝ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΝΗΡΕΥΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΝΟΤΟΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Ο.Τ.Ε.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Ο.Τ.Ε. Α.Ε.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΟΛΠ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Ολυμπιακή Τεχνική",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΟΜΟΛΟΓΑ ΕΥΡΩΠ. ΤΡΑΠΕΖΑΣ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΟΠΑΠ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΟΠΑΠ Α.Ε.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΟΠΑΠ ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΟΡΓΑΝΙΣΜΟΣ ΤΗΛ/Ν ΕΛΛ.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - Οργανισμός ΤΗΛ/ΩΝ ΕΛΛ.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΟΤΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΟΤΕ - ΟΤΕ ΑΕ.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΟΤΕ -ΟΤΕ ΑΕ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΟΤΕ Α.Ε.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΟΤΕ ΑΕ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΟΤΟΕΛ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΠΑΝΙΚΕΣ ΕΕΔ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΠΕΙΡ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΠΕΙΡΑΙΩΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΠΕΙΡΑΙΩΣ (ΚΟ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Πετρόπουλος",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΠΗΓΑΣΟΣ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΠΗΓΑΣΟΣ ΕΚΔΟΤΙΚΗ ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΠΛΑΘ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΠΛΑΙΣΙΟ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΠΡΟ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΣΑΙΚΑ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΣΑΙΚΛ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΣΑΝΥΟ ΕΛΛΑΣ Α.Ε.-ΚΟ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΣΑΝΥΟ ΕΛΛΑΣ ΣΥΜΜ/ΚΗ Α.Ε.Β.Ε.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΣΠΥΡΟΥ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - Σωληνουργεία Κορίνθου",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - Τ.Τ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - Τ.Τ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - Τ.Τ.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΤΑΧ. ΤΑΜΙΕΥΤΗΡΙΟ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΤΑΧ.ΤΑΜΙΕΥΤΗΡΙΟ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - Ταχυδρομικό Ταμιευτήριο",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΤΑΧΥΔΡΟΜΙΚΟ ΤΑΜΙΕΥΤΗΡΙΟ Α.Τ.Ε.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΤΑΧΥΔΡΟΜΙΚΟ ΤΑΜΙΕΥΤΗΡΙΟ ΑΤΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΤΕΓΟΠΟΥΛΟΣ ΕΚΔΟΣ.",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΤΕΧΝΙΚΗ ΟΛΥΜΠΙΑΚΗ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΤΡΑΠΕΖΑ EFG",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΤΡΑΠΕΖΑ EUROBANK",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΤΡΑΠΕΖΑ MARFIN",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΤΡΑΠΕΖΑ ΕΛΛΑΔΟΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΤΡΑΠΕΖΑ ΗΠΕΙΡΟΥ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΤΡΑΠΕΖΑ ΚΥ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Τράπεζα Κύπρου",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΤΡΑΠΕΖΑ ΚΥΠΡΟΥ (Μετατρέψιμα αξιόγραφα κεφαλαίου)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - Τράπεζα Πειραιώς (εκποίηση)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ Α.Ε. (ΚΟ)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ ΑΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΤΡΟΠΑΙΑ ΣΥΜΜΕΤΟΧΙΚΗ ΑΕΒΕ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - ΤΤ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΦΙΛΙΠΠΟΣ ΝΑΚΑΣ ΑΒΕΕΤΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Χ ΙΩΑΝΝΟΥ",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών - Χ.Κ. Τεγόπουλος",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Χ.Κ. ΤΕΓΟΠΟΥΛΟΣ ΕΚΔΟΣΕΙΣ ΑΥΛΟ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - Χ'ΙΩΑΝΝΟΥ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΧΑΛΥΒ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Χαρτοφυλάκιο Ελληνικού Χρηματιστηρίου",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - Χατζηϊωάννου Α.Ε.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΧΑΤΖΗΙΩΑΝΝΟΥ ΑΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών - ΧΑΤΖΚ Χατζηϊωάννου Α.Ε.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών ( ΜΥΤΗΛΙΝΑΙΟΣ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (AEGEAN (KO))",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ALAPIS (Εκτός διαπραγμάτευσης))",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ALAPIS)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Alfa Bank)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Alpha AE)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Alpha Bank (Warrants))",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ALPHA BANK AE)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Alpha Bank Finance)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Alpha Bank K.O. - WARRANT)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Alpha Bank K.O.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Alpha Bank ΑΕ)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (Alpha Bank)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (ALPHA FINANCE)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ALPHA TΠ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Alpha Βank)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Alpha ΤΠ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Alpha Τράπεζα Α.Ε.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Alpha Τράπεζα)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (Altec ΑΒΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ATE)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ATEBANK (KO))",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Attica Bank)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (AVENIR AE)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (CAN ANAMYS)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (CAN Ελληνικό ΜΙΚΤΟ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Capital Χρηματιστηριακή ΑΕΠΕΥ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (COCA COLA HBC AE)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (CONE CONNECTION)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Connection AEBEE ΑΥΛΟ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (CONNECTION AEBEE ΑΥΛΟ (ΚΟ))",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (CPI AE)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (CREDIT AGRICOLE LIFE)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (E.T.E. Warrants)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (EFG Eurobank Ergasias AE)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (EFG Eurobank)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ETE WARRANTS)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Eurobank Ergasias)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Eurobank Propertis)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (Eurobank)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Euromedica A.E.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Eurotrip ABEΓΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (EUROXX)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (EVBPIK)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Eθνική Τράπεζα)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Eλλην. Χρηματ.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (FG Europe A.E.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (FG Europe A.E.Β.Ε.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Forthnet AE)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (FORTHNET)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (FORTIS SA)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (FRIGO GLASS)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (INFORM)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (INTERINVEAT - ΔΙΕΘ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (INTERINVEST - ΔΙΕΘ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (INTERSAT)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (INTERSONIC SA)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (INTPAKOM HOLD)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (INTRACOM)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (INTRAKOM)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (Intralot Α.Ε.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (IΑΣΩ Α.Ε.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (JUMBO)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (KΛΩΝΑΤΕΞ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (MARFIN INVESTM)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (MARFIN INVESTM)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (MODA BAGNO AE)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Moda Bagno)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Mηχανική ΑΕ (ΚΟ))",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (NEL A.E.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (NEL AE)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (OTE (KO))",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (OTE AE)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (OTE)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (OTOEΛ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (PROTON ΤΡΑΠΕΖΑ Α.Ε.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (QUALITY MNOBELAS)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Quality Mnorelas)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Quest AE)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (RIDENCO)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (T BANK)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (T.Γ.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (TBANK ATE)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (TZKA)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (UΝΙΒΙΟΣ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (WARRANT Alpha)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (WARRANT Εθνική)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (WARRANTS)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΓΡΟΤΙΚΗ ΤΡΑΠΕΖΑ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΕΓΕΚ Α.Ε. - Κ.Ο.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΕΓΕΚ Α.Ε. (ΚΟ) ΑΥΛΟ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΕΓΕΚ Α.Ε.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΕΓΕΚ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΕΡΟΠΟΡΙΑ ΑΙΓΑΙ)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (Αεροπορία Αιγαίου)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Αιολική ΑΕΕΧ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΙΟΛΙΚΗ)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (ΑΙΟΝΙΚ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΚΡΗΤΑΣ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ακρίτας ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΚΡΙΤΑΣ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΛΑΠΙΣ ΕΠΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΛΚΟ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΛΜΥ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΛΟΥΜΥΛ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΛΤΕΚ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΛΦΑ ΤΠ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΛΦΑ ΤΡΑΠΕΖΑ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΛΦΑ ΤΡΑΠΕΖΑ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΛΦΑ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΝΕΚ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΝΩΝ. ΝΑΥΤΙΛ. ΕΤΑΙΡΕΙΑ ΚΡΗΤΗΣ Α.Ε.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΣΤΗΡ Παλάς ΑΞΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Αστήρ Παλάς Βουλιαγμένης)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Αστήρ Παλλάς Βουλιαγμένης ΑΞΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΣΤΗΡ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΤΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΤΕΡΜΩΝ Α.Ε.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ατλαντικ Σουπερ Μαρκετ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΤΤΙ-ΚΑΤ Α.Τ.Ε.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΤΤΙ-ΚΑΤ ΑΤΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Αφοι Κορδέλλου ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΦΟΙ Χ. ΚΟΡΔΕΛΟΥ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΑΦΟΙ Χ.Κορδέλλου ΑΕΒΕ)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (ΑΧΟΝ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΒΑΡΝΗ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΒΕΤΑΝΕΤ ΑΒΕΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΒΙΟΜ. ΕΣΩΡΟΥΧΑ SEX FORM AE)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Βιομ. εσωρούχων sex form)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΒΙΟΜΗΧΑΝΙΚΑ ΤΕΧΝΙΚΑ ΕΡΓΑ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΒΙΟΧΑΛΚΟ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΒΙΟΧΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΒΙΣ αε)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Γ. Λεβεντάκης ΑΕΒΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΓΕΚ ΤΕΡΝΑ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΓΕΚ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΓΕΚΕ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Γεν. Εμπορίου)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΓΕΝΕΚΤΕΡΝΑ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΓΕΝΙΚΗ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΔΑΙΟΣ ΠΛΑΣΤΙΚΑ ΑΒΕΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΔΑΝΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΔΕΗ)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (ΔΙΑΣ Ιχθυοκαλλιέργειες)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΔΙΕΚΑΤ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΔΙΕΚΑΤ ΑΤΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΔΙΕΚΑΤ ΑΤΕ)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (Δικαι/τα Ευρωσυμβούλιο)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (Δικαιώμα Ευρωσυμβούλιο)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΔΙΟΝΙΚ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΔΟΜΙΚΗ ΚΡΗΤΗΣ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΔΟΥΡΟ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΔΟΥΡΟΣ ΒΙΟΜ. ΕΤ. ΕΝΔΥ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Δούρος βιομ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ε.Τ.Ε. - WARRANTS)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ε.Τ.Ε.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ε.Τ.Ε)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΕΕΚ (Coca Cola, ΗΒΗ))",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΕΕΚ (CocaCola, ΗΒΗ))",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Εθνική Warrants)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Εθνική Τράπεζα (Warrants))",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Εθνική Τράπεζα Α.Ε.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Εθνική Τράπεζα Ελλάδος (κ.ο.))",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Εθνική Τράπεζα Ελλάδος (κ.ο.))",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Εθνική Τράπεζα της Ελλάδος)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Εθνική Τράπεζα ΤΠ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Εθνική Τράπεζα)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Εθνική)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΙΚΟΝΑ ΗΧΩΣ ΒΟΓΙΑΤΖ.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Εικόνα και Ήχος)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΚΤΕΡ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΛ.ΠΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΛΑΚΤΩΡ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΛΒΑ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΛΒΑΛ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΛΒΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ελεύθερη Τηλεόραση ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΛΙΧΘ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ελλ. Ιχθ/γειες ΑΒΕΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ελλ. Χρηματιστήρια ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΛΛΑΚΤΩΡ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΛΛΑΚΤΩΡ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ελλην. Χρηματ.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ελληνικά πετρέλαια Α.Ε.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ελληνικά πετρέλαια)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ελληνικά Χρημ/ρια)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (Ελληνική Βιομηχανία Ζάχαρης Α.Ε.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ελληνική Τεχνοδομική Άνεμος ΑΕ (ΚΟ))",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΛΠΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Εμπορικός Δεσμός)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΝΚΛΟ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΝΚΛΩ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΤΕ WARANTS)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΤΕ Warrants)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (ΕΤΕ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΤΕ διακιώματα)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΤΕ ΤΠ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΤΕ Τράπεζα)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΤΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΤΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΤΕΠ - ΕΤΕ WAD)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΥΒΡΙΚ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΥΔΑΠ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΥΔΑΠ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΥΡΩΒ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΥΡΩΣΥΜ. ΚΕΦ. Κ ΕΠΙΣΚ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΥΡΩΣΥΜ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΥΡΩΣΥΜ/ΧΕΣ)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (Ευρωσύμβουλοι Α.Ε.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΕΧΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Η Καθημερινή ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Η Ναυτεμπορική ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΙΑΣΩ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΙΑΣΩ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΙΚΤΙΝΟΣ ΕΛΛΑΣ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΙΜΠΕΡΙΟ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΙΝΤΕΡΤΕΚ ΑΕ-ΚΟ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΙΝΤΕΡΤΕΚ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΙΝΤΕΤ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΙΝΤΚΑ)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (ΙΝΤΡΑ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΙΝΤΡΑΚΑΤ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΙΝΤΡΑΚΟΜ Α.Ε. Συμμετοχών (κ.ο.))",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΙΝΤΡΑΚΟΜ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΙΝΤΡΑΚΟΜ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΙΝΤΡΑΛΟΤ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΙΝΤΡΑΛΟΤ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ιχθυοτροφεία ΣΕΛΟΝΤΑ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Καθημερινή ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Καθημερινή)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΚΑΡΑΤΖΗ ΑΕ (ΚΟ))",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Κεραμ. Αλλατίνη)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΚΕΡΑΜΕΙΑ ΑΛΛΑΤΙΝΗ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΚΛΩΝΑΤΕΞ ΑΒΝΤΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΚΛΩΝΑΤΕΞ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (κοινές με σύζυγο) - Eurobank",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (κοινές με σύζυγο) - INTERAMERICAN (ΑΝΑΠΤΥΣΣΟΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ ΜΕΤΟΧΙΚΟ ΕΣΩΤΕΡΙΚΟΥ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (κοινές με σύζυγο) - INTERAMERICAN (ΔΥΝΑΜΙΚΟ ΜΕΤΟΧΙΚΟ ΕΣΩΤΕΡΙΚΟΥ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΚΡΕΤΑ ΦΑΡΜ ΑΒΕΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΚΥΠΡ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΚΥΡΜ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΛΑΛΑΚΑΜ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΛΑΜΨΑ (κ.ο.))",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΛΑΝΑΚΑΜ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Μ.Α. Καρατζή ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Μ.Ι. ΜΑΙΛΛΗΣ ΑΕΒΕ (ΚΟ))",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΜΕΤΚ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΜΕΤΚΑ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΜΕΤΚΑ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΜΗΧ Κ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΜΗΧ Π)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (ΜΗΧΑΝΙΚΗ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΜΗΧΑΝΙΚΗ Π.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΜΙΓ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΜΛΑΝΤ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΜΟΥΖΑΚΗΣ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΜΟΧΛ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Μοχλός ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Μοχλός ΔΕ)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (ΜΠΗΤΡΟΣ - Κοινές)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΜΠΗΤΡΟΣ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΜΠΟΥΤΑΡΗΣ & ΥΙΟΣ HOLD)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΜΥΤΙΛΗΝΑΙΟΣ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΜΥΤΙΛΗΝΑΙΟΣ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ν. ΒΑΡΒΕΡΗΣ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΝEΛ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΝΑΥΤ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ναυτιλιακή εταιρία Λέσβου)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΝΕΛ Α.Ε.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΝΕΛ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΝΕΩΡΣ ΝΕΩΡΙΟΝ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΝΗΡΕΑΣ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ο ΤΟΕΛ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΟΛΑΠ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΟΛΥΜΠ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ολυμπιακή Τεχνική)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΟΠΑΠ (ΚΟ))",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (ΟΠΑΠ Α.Ε.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΟΠΑΠ)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (Οργανισμός Τηλεπικοινωνιών)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΟΤΕ (ΚΟ))",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (ΟΤΕ Α.Ε.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΟΤΕ ΑΕ ΚΟ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΟΤΕ ΑΕ)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (ΟΤΕ ΚΟ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΟΤΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΟΤΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Πειρ.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΠΕΙΡ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΠΕΙΡΑΙΩΣ ΤΟΑΠ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΠΕΙΡΑΙΩΣ ΤΡΑΠΕΖΑ (ΚΟ))",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Πειραιώς Τράπεζα)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Πειραιώς)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΠΕΡΣΕΥΣ ΑΒΕΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Περσεύς)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΠΗΓΑΣΟΣ ΕΚΔΟΤΙΚΗ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Πήγασος Εκδοτική)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΠΛΑΘ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΠΛΑΙΣ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΠΛΑΙΣΙΟ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΠΟΥΛΙΑΔΗΣ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΠΡΔ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΠΡΟΦΙΛ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΣΛΙΝΙΕΡ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΣΛΙΝΤΕΡ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΣΠΙΝΤ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΣΠΡΙ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΣΩΛΗΝΟΥΡΓΕΙΑ ΚΟΡΙΝΘΟΥ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Σωληνουργία Κορίνθου)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Τ.Τ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ταχ. Ταμιευτήριο)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ταχυ. Ταμιευτήριο)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ταχυδρομικό Ταμ.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ταχυδρομικό Ταμιευτήριο ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Ταχυδρομικό Ταμιευτήριο)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΤΕΓΟ)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (ΤΕΡΝΑ ΕΝΕΡΓΕΙΑ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΤΖΙΡΑΚΙΑΝ ΠΡΟΦΙΛ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΤΖΚΑ)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (Τηλέτυπος)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (ΤΙΤΑΝ Α.Ε.)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Τρ. Πειραιώς)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Τραπ. Πειραιώς)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΤΡΑΠΕΖΑ EUROBANK ERGASIAS A.E.)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (Τράπεζα Eurobank)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΤΡΑΠΕΖΑ ΕΛΛΑΔΟΣ ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Τράπεζα Ελλάδος)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Τράπεζα Κύπρου ΑΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Τράπεζα Κύπρου)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Τράπεζα Πειραιώς (ΚΟ))",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Τράπεζα Πειραιώς ΑΕ)",
  "Μετοχές Ημεδαπών Εισηγμένων Εταιριών (Τράπεζα Πειραιώς)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Τρόπαια Συν/κη ΑΕΒΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Τροπέα Συμμετοχική)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΥΙΟΙ Χ'ΚΡΑΝΙΩΤΗ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Φ. ΝΑΚΑΣ ΑΒΕΕΤΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Φ. Νάκκας ΑΒΕΕΤΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Φίλιππος Νάκας ΑΒΕΕΤΕ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΦΡΙΓΟ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΦΦΓΚΡΤΙ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (Χ. Κ. Τεγόπουλος)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών (ΧΑΤΖΚ)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών | EUROBANK",
  "Μετοχές ημεδαπών εισηγμένων εταιριών | OΠΑΠ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών | ΑΛΑΠΙΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών | ΝΗΡΕΥΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών | ΟΠΑΠ (Κ.Ο)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών | ΟΤΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών | ΟΤΕ (Κ.Ο)",
  "Μετοχές ημεδαπών εισηγμένων εταιριών |COCA COLA HBCAG",
  "Μετοχές ημεδαπών εισηγμένων εταιριών ALPHA BAN",
  "Μετοχές ημεδαπών εισηγμένων εταιριών E.T.E.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών EFG EUROBANK ΕΡΓΑΣΙΑΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών EUROBANK",
  "Μετοχές ημεδαπών εισηγμένων εταιριών INTERSAT",
  "Μετοχές ημεδαπών εισηγμένων εταιριών OTE",
  "Μετοχές ημεδαπών εισηγμένων εταιριών ΓΕΚ. ΤΕΡΝΑ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών ΔΕΗ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ Α.Ε.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών ΕΤΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών ΕΥΡΩΣΥΜ/ΧΕΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών ΟΤΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών ΤΡ. ΠΕΙΡΑΙΩΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών ΤΡΑΠΕΖΑ ΕΛΛΑΔΟΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών ΥΙΟΙ ΧΑΤΖΗΚ/ΤΗ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών- AEGEAN AIRLINES",
  "Μετοχές ημεδαπών εισηγμένων εταιριών- EUROBANK GLOBAL BOND",
  "Μετοχές ημεδαπών εισηγμένων εταιριών- ΙΝΤΡΑΚΟΜ ΚΑΤΑΣΚΕΥΕΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-EUROBANK",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-INFORM",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-WARRAS ETE",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΑΕΓΕΚ Α.Ε. (ΚΟ) ΑΥΛΟ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΑΚΡΙΤΑΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΑΛΚΟ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΑΣΤΗΡ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΑΣΤΗΡ ΠΑΛΛΑΣ ΒΟΥΛΙΑΓΜΕΝΗΣ ΑΞΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΑΤΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΓΕΚ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΔΑΝΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΔΕΗ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-Ε.Τ.Ε.",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΑΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΕΛΒΑΛ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΕΛΠΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΕΤΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΕΤΕ NARRANTS",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΕΤΕ WARRANTS",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΟΛΥΜΠ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΟΠΑΠ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΟΤΕ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΠΕΙΡΑΙΩΣ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΠΕΙΡΑΙΩΣ ΤΡΑΠ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΡINTENKO",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΡΙΝΤΕΝΚΟ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-ΤΒΑΝΚ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών-Τραπ. Πειραιώς",
  "Μετοχές ημεδαπών εισηγμένων εταιριών, Eurobank",
  "Μετοχές ημεδαπών εισηγμένων εταιριών, Intralot",
  "Μετοχές ημεδαπών εισηγμένων εταιριών, OTE",
  "Μετοχές ημεδαπών εισηγμένων εταιριών, Αεροπορία Αιγαίου",
  "Μετοχές ημεδαπών εισηγμένων εταιριών, Άλφα τράπεζα",
  "Μετοχές ημεδαπών εισηγμένων εταιριών, Εθνική τράπεζα",
  "Μετοχές ημεδαπών εισηγμένων εταιριών, Πειραιώς τράπεζα",
  "Μετοχές ημεδαπών εισηγμένων εταιριών, Τεχνική Ολυμπιακή",
  "Μετοχές ημεδαπών εισηγμένων εταιριών, ΤΙΤΑΝ",
  "Μετοχές ημεδαπών εισηγμένων εταιριών(Alpha Bank)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΡΕΙΩΝ - COCA COLA AE",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΗΜΕΝΩΝ ΕΤΑΙΡΙΩΝ (ΜΑΡΜΑΡΑ ΚΑΒΑΛΑΣ Α.Ε.)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΑΛΟΥΜΥΛ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΕΤΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ ΑΓΡΟΖΩΗ ΑΒΕΕ",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών -",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - ANEN LINES",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - Arni Palace A.E.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ARNI PALACE Α.Ε.",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - DAPACIENZA A.E.",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - DAPIACIENZA A.E.",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - HELLENIC SEAWAYS",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - ΑΓΡΟΖΩΗ (ΑΒΕΕ)",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΑΓΡΟΖΩΗ ΑΒΕΕ",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - ΑΓΡΟΖΩΗ ΑΒΕΕ",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - Αγροτική ΑΒΕΕ",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - ΑΔΡΑΣΤΕΙΑ ΕΚΔΟΣΕΙΣ Α.Ε.",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - ΑΚΤΗ ΖΕΥΣ ΑΕ",
  "Μετοχές Ημεδαπών Μη Εισηγμένων Εταιριών - Αλεξ.Χρ. Δερμεντζόπουλος Α.Ε.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΑΛΟΥΜΥΛ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΑΛΟΥΜΥΛ",
  "Μετοχές Ημεδαπών Μη Εισηγμένων Εταιριών - ΑΛΦΑ Τράπεζα Α.Ε.",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - ΑΝΑΤΟΛΗ Α.Ε.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΑΝΕΝ LINES",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - ΑΥΓΗ, Αγορά",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - ΑΧΙΛΛΕΙΟΝ ΑΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΤΕ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΕΤΕ",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - ΚΟΨΑΧΕΙΛΗΣ - ΚΑΣΚΑΛΗΣ ΟΕ",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - ΚΟΨΑΧΕΙΛΗΣ Α.Ε.",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - Κοψαχείλης ΑΕ",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - ΚΟΨΑΧΕΙΛΗΣ Τ. - ΛΙΑΚΑΣ Θ.",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - ΚΡΗΤΙΚΗ ΕΜΠΟΡΙΚΗ",
  "Μετοχές Ημεδαπών μη Εισηγμένων Εταιριών - ΜΑΡΜΑΡΟ ΚΑΒΑΛΑΣ Α.Ε.",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - ΜΕΑΑΜΠΟΥΣ Α.Ε.",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΜΕΤΟΧΕΣ ΝΕΛ",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - ΝΙΔΑ ΑΕ",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - ΠΑΣΣΑΣ ΑΤΕΒΕ",
  "Μετοχές Ημεδαπών μη Εισηγμένων Εταιριών - ΠΗΛΕΑΣ AGRO Α.Ε.",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - ΣΥΝ. ΠΕ ΣΕΡΡΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ - ΣΥΝ. ΤΡΑΠΕΖΑ ΚΑΡΔΙΤΣΑΣ",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - ΣΥΝ/ΚΗ ΤΡΑΠΕΖΑ",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - ΣΥΝ/ΚΗ ΤΡΑΠΕΖΑ ΣΕΡΡΩΝ",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - Συνεταιριστική Τράπεζα Σερρών",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - ΤΡΑΠΕΖΑ ΗΠΕΙΡΟΥ",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών - Τράπικ",
  "Μετοχές Ημεδαπών Μη Εισηγμένων Εταιριών - ΤΡΟΠΑΙΑ ΣΥΜΜΕΤΟΧΙΚΗ ΑΕΒΕ",
  "Μετοχες Ημεδαπων Μη Εισηγμενων Εταιριων - ΥΙΟΙ Β.ΥΨΗΛΑΝΤΗ ΑΕΒΕ",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (Alpha Bank (KO))",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ANEN LINES)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ARVANCO ABEE)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (BOTOMOI AE)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (Capital Χρημ.)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (Dapiagienza OE)",
  "Μετοχές Ημεδαπών μη Εισηγμένων Εταιριών (Eurobank)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (Eθνική ΤΡ.ΕΛ. (Κ.Ο.))",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (MARFIN INV.GR. (K.O.))",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (OTE)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (PROTON - ΒΙΟΤΕΡ - ΚΕΡΑΝΗΣ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (TOP VIDEO GROUP ΡΑΠΤΗΣ ΑΕ)",
  "Μετοχές Ημεδαπών μη Εισηγμένων Εταιριών (TRASTOR ΑΕΕ ΑΠ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΑRVANCO ABEE)",
  "Μετοχές Ημεδαπών μη Εισηγμένων Εταιριών (Αγροτικής)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΑΔΡΑΣΤΕΙΑ ΕΚΔΟΣΕΙΣ ΑΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (Αδράστεια Εκδόσεις ΑΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΑΚΡΙΤΑΣ ΑΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΑΚΤΗ ΖΕΥΣ ΑΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΑΚΤΗ ΖΕΥΣ ΑΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΑΛΕΞ ΧΡ. ΔΕΡΜΕΝΤΟΠΟΥΛΟΣ ΑΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΑΝΑΤΟΛΗ ΑΕ)",
  "Μετοχές Ημεδαπών Μη Εισηγμένων Εταιριών (ΑΝΕΘ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΑΝΕΚ ΑΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΑΝΕΝ LINES)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΑΡΓΟΛΙΣ ΑΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΑΤΤΕ-ΑΙΝΟΣ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΑΤΤΙ-ΚΑΤ ΑΤΕ)",
  "Μετοχές Ημεδαπών μη Εισηγμένων Εταιριών (ΑΥΓΗ Α.Ε.)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΑΧΙΛΛΕΙΟΝ ΑΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΒΟΤΟΜΟΣ ΑΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (Εθνική Τράπεζα)",
  "Μετοχές Ημεδαπών μη Εισηγμένων Εταιριών (Εθνικής)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΕΛΒΑ)",
  "Μετοχές Ημεδαπών μη Εισηγμένων Εταιριών (Ελληνική Βιομηχανία Ζάχαρης Α.Ε.)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΕΛΠΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (Εμπορική Τράπεζα)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΘΕΜΕΛΙΟΔΟΜΗ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΚΑΘΗΜΕΡΙΝΗ ΑΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΚΥΠΡ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΛΕΒΙΔΙ ΝΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΜΕΓΑΡΟ ΦΥΤΑΚΗ ΑΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΜΕΛΑΜΠΟΥΣ ΑΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΜΗΧΚ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΜΗΧΠ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΜΥΤΙΛΗΝΑΙΟΣ ΑΕ (Κ.Ο.)ΑΥΛΟ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (Ν.ΒΑΡΒΕΡΗΣ MODA BAGNO)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΝΑΤΕΥΜΠΟΡΙΚΗ ΑΘΑΝΑΣΙΑΔΗΣ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΝΙΔΑ ΑΕ - Τουριστική και Ξενοδοχειακή επιχείρηση)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΝΟΤΟL)",
  "Μετοχές Ημεδαπών μη Εισηγμένων Εταιριών (ΟΠΑΠ Α.Ε.)",
  "Μετοχές Ημεδαπών μη Εισηγμένων Εταιριών (ΟΠΑΠ ΑΕ)",
  "Μετοχές Ημεδαπών μη Εισηγμένων Εταιριών (ΟΤΕ ΚΟ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΟΤΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΠΑΓΚΡΗΤΙΑ ΣΥΝ/ΚΗ ΤΡΑΠΕΖΑ",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (Πήγασος εκδοτική )",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΠΗΓΑΣΟΣ ΕΚΔΟΤΙΚΗ ΑΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΠΗΓΑΣΟΣ ΕΚΔΟΤΙΚΗ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΠΟΣΕΙΔΩΝ ΑΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΠΡΟΟΔΕΥΤΙΚΗ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (Συν/κη Τράπεζα Θεσ/κης)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (Συν/κη τράπεζα Σερρών)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (Συνεταιριστική Τράπεζα Σερρών)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (Συνεταιριστική Τράπεζα)",
  "Μετοχές Ημεδαπών μη Εισηγμένων Εταιριών (ΤΑΧΥΔΡΟΜΙΚΟ ΤΑΜΙΕΥΤΗΡΙΟ ΑΤΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΤΡΑΠΕΖΑ ΗΠΕΙΡΟΥ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΤΥΠΟΣ: ΑΥΓΗ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΤΥΠΟΣ: Η ΑΥΓΗ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΦΙΛΟΞΕΝΙΑ ΑΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών (ΨΥΓΕΙΑ ΑΛΠΕΙΣ ΛΑΜΠΡΟΥΛΗ ΠΑΠΑΓΙΑΝΝΗ ΑΕ)",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών | Αγορά",
  "Μετοχές ημεδαπών μη εισηγμένων εταιριών(ARVANCO ΑΒΕΕ)",
  "ΜΕΤΟΧΕΣ ΜΕ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ - ΤΡΑΠΕΖΑ ΗΠΕΙΡΟΥ",
  "ΜΕΤΟΧΕΣ ΜΗ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΕΙΩΝ- ΤΡΑΠΕΖΑ ΗΠΕΙΡΟΥ",
  "ΜΕΤΟΧΕΣ ΝΤΡΙΑΡΤ ΑΒΕΕ",
  "Μετοχές σε Ξ.Ν (Credit Agricole)",
  "Μετοχές σε Ξ.Ν. (AA US)",
  "Μετοχές σε Ξ.Ν. (AAPL US)",
  "Μετοχές σε Ξ.Ν. (ALCOA INC)",
  "Μετοχές σε Ξ.Ν. (ALLIANCEBERNSTEIN HOLDING LP)",
  "Μετοχές σε Ξ.Ν. (ALLIANZGI CONVERTIBLE & INCOME FUND)",
  "Μετοχές σε Ξ.Ν. (ALLIANZGI NF J DIVIDEND INTEREST)",
  "Μετοχές σε Ξ.Ν. (APPLE INC)",
  "Μετοχές σε Ξ.Ν. (AXP US)",
  "Μετοχές σε Ξ.Ν. (BELO CORPORATION)",
  "Μετοχές σε Ξ.Ν. (BLACK ROCK HEALTH SCIENCES TRUST)",
  "Μετοχές σε Ξ.Ν. (BLACKROCK ENHANCED EQUITY)",
  "Μετοχές σε Ξ.Ν. (BLV US)",
  "Μετοχές σε Ξ.Ν. (BND US)",
  "Μετοχές σε Ξ.Ν. (CAPITAL PRODUCT PARTNERS LP)",
  "Μετοχές σε Ξ.Ν. (COHEN & STEERS GLOBAL INCOME)",
  "Μετοχές σε Ξ.Ν. (COHEN AND STEER CLOSED END OP)",
  "Μετοχές σε Ξ.Ν. (COHEN AND STEER CLOSED END OP)",
  "Μετοχές σε Ξ.Ν. (CONOCOPHILLIPS)",
  "Μετοχές σε Ξ.Ν. (COP US)",
  "Μετοχές σε Ξ.Ν. (DYNAGAS LNG PARTNERS LP)",
  "Μετοχές σε Ξ.Ν. (EATON VANCE RISK MANAGED DIV)",
  "Μετοχές σε Ξ.Ν. (EATON VANCE TAX MANAGED GLOBAL)",
  "Μετοχές σε Ξ.Ν. (EATON VANCE TAX-MANAGED)",
  "Μετοχές σε Ξ.Ν. (EUROSEAS LIMITED)",
  "Μετοχές σε Ξ.Ν. (EUROSEAS LTD)",
  "Μετοχές σε Ξ.Ν. (EXFO INC)",
  "Μετοχές σε Ξ.Ν. (Experian PLC)",
  "Μετοχές σε Ξ.Ν. (Fedex Corp)",
  "Μετοχές σε Ξ.Ν. (FIFTH STREET FINANCE CORP)",
  "Μετοχές σε Ξ.Ν. (FORD MOTOR CO)",
  "Μετοχές σε Ξ.Ν. (FRONTIER COMMUNICATIONS CORP)",
  "Μετοχές σε Ξ.Ν. (GABELLI HEALTHCARE AND WELLNESS)",
  "Μετοχές σε Ξ.Ν. (GAMCO GLOBAL GOLD NATURE)",
  "Μετοχές σε Ξ.Ν. (GLD US)",
  "Μετοχές σε Ξ.Ν. (GLOBAL EX SUPER DIVIDEND ETF)",
  "Μετοχές σε Ξ.Ν. (INTC US)",
  "Μετοχές σε Ξ.Ν. (INTEL CORP)",
  "Μετοχές σε Ξ.Ν. (INTEL CORP)",
  "Μετοχές σε Ξ.Ν. (ISHARES AUSTRALIA)",
  "Μετοχές σε Ξ.Ν. (ISHARES DJ INTL SELECT)",
  "Μετοχές σε Ξ.Ν. (ISHARES DJ SELECT DIVIDENT INDEX)",
  "Μετοχές σε Ξ.Ν. (ISHARES DJ US BASIC)",
  "Μετοχές σε Ξ.Ν. (ISHARES MSG CANADA)",
  "Μετοχές σε Ξ.Ν. (ISHARES SILVER TRUST)",
  "Μετοχές σε Ξ.Ν. (ISHARES SILVER TRUST)",
  "Μετοχές σε Ξ.Ν. (JPM US)",
  "Μετοχές σε Ξ.Ν. (LEAPFROG ENTERPRISES)",
  "Μετοχές σε Ξ.Ν. (LEAPFROG ENTERPRISES)",
  "Μετοχές σε Ξ.Ν. (MAIN STREET CAPITAL CORP)",
  "Μετοχές σε Ξ.Ν. (MAIN STREET CAPITAL CORP)",
  "Μετοχές σε Ξ.Ν. (MCD US)",
  "Μετοχές σε Ξ.Ν. (NAVIOS MARITIME HOLDINGS)",
  "Μετοχές σε Ξ.Ν. (NAVIOS MARITIME PARTNERS LP)",
  "Μετοχές σε Ξ.Ν. (Newmont Mining Corp)",
  "Μετοχές σε Ξ.Ν. (NORDIC AMERICAN TANKERS LTD)",
  "Μετοχές σε Ξ.Ν. (OAKTREE CAPITAL GROUP LLC)",
  "Μετοχές σε Ξ.Ν. (PEV US)",
  "Μετοχές σε Ξ.Ν. (PEY US)",
  "Μετοχές σε Ξ.Ν. (Powershares high yield DVD ACHIE)",
  "Μετοχές σε Ξ.Ν. (Powershares high yield DVD ACHIE)",
  "Μετοχές σε Ξ.Ν. (RIOCAN REAL ESTATE INVESTMENT TRUST)",
  "Μετοχές σε Ξ.Ν. (RIOCF US)",
  "Μετοχές σε Ξ.Ν. (SAFE BULKERS INC)",
  "Μετοχές σε Ξ.Ν. (SDIV US)",
  "Μετοχές σε Ξ.Ν. (Seagate Technology)",
  "Μετοχές σε Ξ.Ν. (SHIP FINANCE INTL LTD)",
  "Μετοχές σε Ξ.Ν. (SLV US)",
  "Μετοχές σε Ξ.Ν. (SPDR GOLD TRUST)",
  "Μετοχές σε Ξ.Ν. (SPDR GOLD TRUST)",
  "Μετοχές σε Ξ.Ν. (STT US)",
  "Μετοχές σε Ξ.Ν. (United Technologies Corp)",
  "Μετοχές σε Ξ.Ν. (VANGUARD DIVIDEND APPRECIATION INDEX)",
  "Μετοχές σε Ξ.Ν. (VANGUARD DIVIDEND APPRECIATION INDEX)",
  "Μετοχές σε Ξ.Ν. (VANGUARD FTLS ALL WORLD)",
  "Μετοχές σε Ξ.Ν. (VANGUARD INFO TECH ETF)",
  "Μετοχές σε Ξ.Ν. (VANGUARD MATERIALS ETF)",
  "Μετοχές σε Ξ.Ν. (VANGUARD US TOTAL STOCK MARKET)",
  "Μετοχές σε Ξ.Ν. (VANGUARD VALUE ETF)",
  "Μετοχές σε Ξ.Ν. (VANGUARD VALUE ETF)",
  "Μετοχές σε Ξ.Ν. (VAW US)",
  "Μετοχές σε Ξ.Ν. (VEU US)",
  "Μετοχές σε Ξ.Ν. (VGT US)",
  "Μετοχές σε Ξ.Ν. (VIG US)",
  "Μετοχές σε Ξ.Ν. (VOYA GLOBAL EQUITY DIVIDEND)",
  "Μετοχές σε Ξ.Ν. (VTI US)",
  "Μετοχές σε Ξ.Ν. (VTV US)",
  "Μετοχές σε Ξ.Ν. (WINDSTREAM HOLDINGS INC)",
  "Μετοχές σε Ξ.Ν. (YAMANA GOLD INC)",
  "Μετοχές σε Ξ.Ν. (ΑΕΓΕΚ Α.Ε.)",
  "Μετοχές σε Ξ.Ν. (ΠΗΓΑΣΟΣ Εκδοτική)",
  "Μετοχές σε Ξ.Ν. (ΥΑΜΑΝΑ GOLD INC AUY US)",
  "Μετοχές σε Ξ.Ν.(COHEN & STEERS GLOBAL INCOME)",
  "Μετοχές σε Ξ.Ν.(OAKTREE CAPITAL GROUP LLC)",
  "Μέτοχος - Συνεταιριστική Τράπεζα Καρδίτσας",
  "Μέτοχος στην Ανώνυμη Εταιρία, 'Αυγή εκδοτικός και δημοσιογραφικός οργνισμός",
  "Ομόλογα",
  "ΟΜΟΛΟΓΑ - 10 ΕΤΕΣ ΓΕΡΜΑΝΙΚΟ ΟΜΟΛΟΓΟ",
  "ΟΜΟΛΟΓΑ - 2,8% MORGAN STANLEY 2015",
  "ΟΜΟΛΟΓΑ - 3.625% GOLDMAN SACHS GROUP 2013",
  "ΟΜΟΛΟΓΑ - ALLIANZ Α/Κ ΜΕΤΟΧΩΝ ΕΣΩΤΕΡΙΚΟΥ",
  "ΟΜΟΛΟΓΑ - ALLIANZ Α/Κ ΟΜΟΛΟΓΙΩΝ ΕΥΡΩ ΠΕΡΙΦΕΡΕΙΑΣ",
  "ΟΜΟΛΟΓΑ - AUSTRALIAN",
  "ΟΜΟΛΟΓΑ - AUSTRALIAN GOV",
  "ΟΜΟΛΟΓΑ - AUSTRALIAN GOVERNMENT",
  "ΟΜΟΛΟΓΑ - BANK NY MELLON BROKERED CD",
  "ΟΜΟΛΟΓΑ - BANK OF CYPRUS",
  "ΟΜΟΛΟΓΑ - BANQ FED CRD MUT VARIABLE 15/12/2004 PERPETUAL EUR - XS0207764712",
  "ΟΜΟΛΟΓΑ - BAYER",
  "ΟΜΟΛΟΓΑ - BGF-EMERGING MARKET BOND FUND A2 ACC",
  "ΟΜΟΛΟΓΑ - BGF-GLOBAL COMPORATE BOND A2 ACC USD",
  "ΟΜΟΛΟΓΑ - BGF-GLOBAL GOVERNMENT BOND A2 ACC USD",
  "ΟΜΟΛΟΓΑ - BGF-US DOLLAR SHORT DURATION BOND A2 ACC USD",
  "ΟΜΟΛΟΓΑ - BLACKROCK - EUR SHORT DURATIO BOND FUND (A2)",
  "ΟΜΟΛΟΓΑ - BLACKROCK CORPORATE HIGY YIE",
  "ΟΜΟΛΟΓΑ - BLACKROCK CREDIT ALLOCATION",
  "ΟΜΟΛΟΓΑ - BMW FINANCE",
  "ΟΜΟΛΟΓΑ - BNP - US MORTGAGE - CLS H EUR LU1080341495",
  "ΟΜΟΛΟΓΑ - BNPP B STRATEGY GLOBAL DYNAMIC CAP",
  "Ομόλογα - BONDS ΕΞΩΤ. ΔΗΜΟΣΙΟΥ",
  "Ομόλογα - Bonds Εξωτερικού Δημοσίου",
  "ΟΜΟΛΟΓΑ - CANADIAN GOV",
  "ΟΜΟΛΟΓΑ - CANADIAN GOVERNMENT",
  "ΟΜΟΛΟΓΑ - CITIGROUP INC",
  "ΟΜΟΛΟΓΑ - COEN & STEERS LIMITED DURATION PREF",
  "ΟΜΟΛΟΓΑ - COHEN & STEERS LIMITED DURATION PREF",
  "ΟΜΟΛΟΓΑ - COHEN AND STEERS SELECT PREFER",
  "ΟΜΟΛΟΓΑ - COLGATE - PALMOLIVE",
  "ΟΜΟΛΟΓΑ - COOPERATIEVE RABOBANK U.A.",
  "ΟΜΟΛΟΓΑ - CWTH BK AUSTRALIA",
  "ΟΜΟΛΟΓΑ - DAIMLER",
  "ΟΜΟΛΟΓΑ - DEUTSCHE TEL.INTL.",
  "ΟΜΟΛΟΓΑ - DEUTSCHE TELECOM INT.",
  "Ομόλογα - EFG HELLAS",
  "Ομόλογα - EFSF ΛΗΞΗΣ 2012-2014",
  "ΟΜΟΛΟΓΑ - EIB",
  "ΟΜΟΛΟΓΑ - EQUINOR",
  "Ομόλογα - EUROP INVEST BANK",
  "ΟΜΟΛΟΓΑ - EUROPEAN INVESTMENT BANK",
  "ΟΜΟΛΟΓΑ - EUROPEAN INVT BK 1,75% 20/5/2014- 17/6/2019 USD",
  "Ομόλογα - FIXED CAPPD RN USD CITIGROUP FUNDING INC",
  "ΟΜΟΛΟΓΑ - FIXED RATE BONDS",
  "Ομόλογα - FIXED RN XXXIV USD CITIGROUP FUNDING INC",
  "ΟΜΟΛΟΓΑ - FRN GENERAL MOTORS FINL CO 2017",
  "ΟΜΟΛΟΓΑ - FTIF-TEMPLETON GLOBAL BOND FUND AD",
  "ΟΜΟΛΟΓΑ - GENERAL MOTORS 3.1% 15/01/2019",
  "ΟΜΟΛΟΓΑ - GOLDMAN SACHS GROUP INC",
  "ΟΜΟΛΟΓΑ - GSK CAPITAL",
  "ΟΜΟΛΟΓΑ - HELLENIC PETROLEUM",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX-",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2023",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2023 EUR - GR0A28010046",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2024",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2024 EUR - GR0A28011051",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2025",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2025 EUR GR0A28012067",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2026",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2026 EUR - GR0A28013073",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2027",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2027 EUR - GR0A28014089",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2028",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2028 EUR GR0A33006534",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2029",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2029 EUR GR0A33007540",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2030",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2030 EUR GR0A33008555",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2031",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2031 EUR GR0A33009561",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2032",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2032 EUR - GR0A33010577",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2033",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2033 EUR - GR0A38005085",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2034",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2034 EUR GR0A38006091",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2035",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2035 EUR GR0A38007107",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2036",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2036 EUR - GR0A38008113",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2037",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2037 EUR GR0A38009129",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2038",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2038 EUR GR0A38010135",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2039",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2039 EUR - GR0A38011141",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2040 EUR GR0A38012156",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2041",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2041 EUR - GR0A38013162",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2042",
  "ΟΜΟΛΟΓΑ - HELLENIC REP TAX- EXEMPT STEP CPN 12/03/2012-24/02/2042 EUR GR0A38014178",
  "ΟΜΟΛΟΓΑ - HELLENIC REP VARIABLE",
  "ΟΜΟΛΟΓΑ - HELLENIC REP VARIABLE 12/03/2012- 15/10/2042 EUR - GRR000000010",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 05.12.2007 - 30.01.2037 4%",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 05.12.2017 - 30.01.2023 3.5%",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 05.12.2017 - 30.01.2028 3.75%",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 05.12.2017 - 30.01.2033 3.9%",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 05.12.2017 - 30.01.2037 4%",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 05.12.2017 - 30.01.2042 4.2.%",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 05.12.2017-30.01.2023 3.5%",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 05.12.2017-30.01.2028 3,75%",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 05.12.2017-30.01.2033 3,95%",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 05.12.2017-30.01.2037 4%",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 05.12.2017-30.01.2042 4,2%",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-15.10.2042",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-24.02.2023",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-24.02.2024",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-24.02.2025",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-24.02.2026",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-24.02.2027",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-24.02.2028",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-24.02.2029",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-24.02.2030",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-24.02.2031",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-24.02.2032",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-24.02.2033",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-24.02.2034",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-24.02.2035",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-24.02.2037",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-24.02.2038",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-24.02.2039",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-24.02.2040",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-24.02.2041",
  "ΟΜΟΛΟΓΑ - HELLENIC REPUBLIC 24.02.2012-24.02.2042",
  "Ομόλογα - HSBC",
  "ΟΜΟΛΟΓΑ - INTRALOT CAPITAL LUX 6 15/05/2021",
  "ΟΜΟΛΟΓΑ - ISHARES BC EURO AGG BOND",
  "ΟΜΟΛΟΓΑ - ISHARES EURO CORP BOND LARGE CAP",
  "ΟΜΟΛΟΓΑ - ISHARES EURO COVERED BOND UCITS",
  "ΟΜΟΛΟΓΑ - ISHARES SILVER BARCLAYS AGGREGATE",
  "ΟΜΟΛΟΓΑ - JOHNSON&JOHNSON",
  "ΟΜΟΛΟΓΑ - JP MARGAN FD AGGREGATE BOND FD LU0430493212",
  "ΟΜΟΛΟΓΑ - JP MORGAN STRUCTURED",
  "ΟΜΟΛΟΓΑ - KEF +LILLIUM ELITE XLII IN EUR",
  "ΟΜΟΛΟΓΑ - KRED WIEDERAUFBAU",
  "ΟΜΟΛΟΓΑ - M&G 7 GL FLO RATE HY-EUR AHA GB00BMP3SF82",
  "ΟΜΟΛΟΓΑ - MASTERCARD INCORPORATED",
  "ΟΜΟΛΟΓΑ - MORGAN STANLEY",
  "ΟΜΟΛΟΓΑ - MORGAN STANLEY BK CD",
  "ΟΜΟΛΟΓΑ - NESTLE FIN",
  "ΟΜΟΛΟΓΑ - NESTLE FINANCE INTL.",
  "ΟΜΟΛΟΓΑ - NOMURA BANK",
  "ΟΜΟΛΟΓΑ - NORWEGIANT T- BILLO",
  "ΟΜΟΛΟΓΑ - NOVARTIS",
  "ΟΜΟΛΟΓΑ - OMOLOGO",
  "ΟΜΟΛΟΓΑ - PACIFIC PREMIER BK CTF DEP",
  "ΟΜΟΛΟΓΑ - PARVEST EQ GERMANY CAP",
  "ΟΜΟΛΟΓΑ - PARVEST EQ WORLD EM LOW VOL CAP",
  "ΟΜΟΛΟΓΑ - PEPSICO",
  "ΟΜΟΛΟΓΑ - PICTETEUR SHORT TERM HIGH YIEL (..7873)",
  "ΟΜΟΛΟΓΑ - PIMCO - GLOBAL INVESTMENT GRADE CREDIT FUND - EH - QD",
  "ΟΜΟΛΟΓΑ - PIMCO GIS INCOME FD E EUR HA 9L26",
  "ΟΜΟΛΟΓΑ - PIMCO-INCOME FUND E ACC EUR(H)",
  "ΟΜΟΛΟΓΑ - PIMCO-INCOME FUND-EH-MD",
  "ΟΜΟΛΟΓΑ - PIMCO-INCOME FUNDS E ACC EUR(H)-IE00B84J9L26",
  "ΟΜΟΛΟΓΑ - PRAKTIKER BAU-UN DEFAULTED 10/02/2011-10/02/2016 EUR DE000A1H3JZ8",
  "ΟΜΟΛΟΓΑ - PROCTER&GAMBLE",
  "ΟΜΟΛΟΓΑ - SANOFI",
  "ΟΜΟΛΟΓΑ - SCHRODER ISF - EURO CORPORATION BOND - A1",
  "ΟΜΟΛΟΓΑ - SCHRODER ISF EURO CORPORATE BOND",
  "ΟΜΟΛΟΓΑ - SIEMENS FINANCIERINGSMAT",
  "Ομόλογα - Templeton Global Bond",
  "ΟΜΟΛΟΓΑ - UBS BK USA CTF DEP",
  "ΟΜΟΛΟΓΑ - UNITED STATES TREAS BILLS",
  "ΟΜΟΛΟΓΑ - UNITES STATES TREAS BILLS",
  "ΟΜΟΛΟΓΑ - VANGUARD TOTAL INTL BOND ETF",
  "Ομόλογα - ΑΕΠ ΕΛΛΗΝΙΚΗΣ ΔΗΜΟΚΡΑΤΙΑΣ",
  "ΟΜΟΛΟΓΑ - ΑΜΟΙΒΑΙΑ ΚΕΦΑΛΑΙΑ",
  "ΟΜΟΛΟΓΑ - ΕΓΕΔ 26 ΕΒΔ.ΑΦΟΡΟΛ.ΛΗΞ 5/5/17",
  "ΟΜΟΛΟΓΑ - ΕΓΕΔ.26 ΕΒΔ.ΑΦΟΡΟΛ. ΛΗΞ. 5/5/17",
  "Ομόλογα - ΕΙΒ",
  "Ομόλογα - ΕΛΛΗΝ. ΔΗΜΟΣΙΟΥ",
  "Ομόλογα - ΕΥΡΩΠ. ΤΡΑΠ. ΕΛΕΝΑ",
  "Ομόλογα - ΕΥΡΩΠ. ΤΡΑΠ. ΕΠΕΝΔ.",
  "ΟΜΟΛΟΓΑ - ΕΥΡΩΠΑΙΚΗ ΤΡΑΠΕΖΑ ΕΠΕΝΔΥΣΕΩΝ",
  "ΟΜΟΛΟΓΑ - ΚΕΦ +3Y OPTIMUM XVII IN EURO",
  "ΟΜΟΛΟΓΑ - ΚΕΦ 3Υ OPTIMUM XVII IN EURO",
  "ΟΜΟΛΟΓΑ - ΚΡΑΤΙΚΑ ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ - ΚΡΑΤΙΚΑ ΟΜΟΛΟΓΑ ERB HELLAS CAYMAN",
  "ΟΜΟΛΟΓΑ - ΚΡΑΤΙΚΑ ΟΜΟΛΟΓΑ EUROPEAN INV BANK",
  "ΟΜΟΛΟΓΑ - ΜΥΤΙΛΗΝΑΙΟΣ",
  "ΟΜΟΛΟΓΑ - ΟΕΔ ΛΗΞΗΣ 2023- 2042",
  "Ομόλογα - ΟΕΔ ΛΗΞΗΣ 2023-2042",
  "ΟΜΟΛΟΓΑ - ΟΜΟ ΕΙΒ 2.625",
  "ΟΜΟΛΟΓΑ - ΟΜΟΛ. ΕΛΛ/ΚΟΥ ΔΗΜΟΣΙΟΥ",
  "ΟΜΟΛΟΓΑ - ΟΜΟΛ. ΟΤΕ PLC 7/2/18",
  "ΟΜΟΛΟΓΑ - ΟΜΟΛΟΓΑ & ΟΜΟΛΟΓΙΑΚΑ Α/Κ",
  "ΟΜΟΛΟΓΑ - ΟΜΟΛΟΓΑ ΕΛΛ. ΔΗΜΟΣΙΟΥ",
  "ΟΜΟΛΟΓΑ - ΟΜΟΛΟΓΑ ΕΛΛΗΝΙΚΟΙΥ ΔΗΜΟΣΙΟΥ",
  "ΟΜΟΛΟΓΑ - ΟΜΟΛΟΓΑ ΕΛΛΗΝΙΚΟΥ ΔΗΜΟΣΙΟΥ",
  "ΟΜΟΛΟΓΑ - ΟΜΟΛΟΓΑ ΚΑΙ ΟΜΟΛΟΓΙΑΚΑ Α/Κ",
  "ΟΜΟΛΟΓΑ - ΟΜΟΛΟΓΟ ΟΤΕ",
  "ΟΜΟΛΟΓΑ - ΟΜΟΛΟΓΟ ΟΤΕ",
  "ΟΜΟΛΟΓΑ - ΟΜΟΛΟΙΓΑ ΕΛΛΗΝΙΚΟΙΥ ΔΗΜΟΣΙΟΥ",
  "ΟΜΟΛΟΓΑ - Σ. ΨΥΧΑΡΗΣ ΣΥΜΜΕΤΟΧΩΝ Α.Ε.",
  "ΟΜΟΛΟΓΑ - ΤΙΤΛΟΙ Α.Ε.Π.",
  "ΟΜΟΛΟΓΑ - ΤΙΤΛΟΙ Ο.Ε.Δ.",
  "ΟΜΟΛΟΓΑ - ΤΙΤΛΟΣ ΑΕΠ",
  "Ομόλογα (AEΠ Ελληνικής Δημοκρατίας)",
  "Ομόλογα (Alpha Bank)",
  "Ομόλογα (Australian Government)",
  "Ομόλογα (BMW 3.5)",
  "Ομόλογα (BOND ΕΞΩΤ. ΔΗΜΟΣ)",
  "Ομόλογα (Canada Government)",
  "Ομόλογα (Canadian Government)",
  "Ομόλογα (ESF Λήξης 2012 - 2014)",
  "ΟΜΟΛΟΓΑ (Eurostox BNP Paribas)",
  "Ομόλογα (Fixed RN XXXIV USD CITIGROUP FUNDING INC)",
  "ΟΜΟΛΟΓΑ (Fixedrate Note Citigroup Fung Inc)",
  "Ομόλογα (FIXWD RNXXXIV USD CITIGROUP FUNDING INC)",
  "Ομόλογα (Intralot Cap LYX 6 15/05/2021)",
  "Ομόλογα (Norwegian Government)",
  "Ομόλογα (NORWEGIAN T-BILL)",
  "Ομόλογα (OTE)",
  "Ομόλογα (ΑΕΠ Ελληνικής Δημοκρατίας)",
  "Ομόλογα (Ε.Δ.)",
  "Ομόλογα (Εθνική Τράπεζα)",
  "Ομόλογα (ΕΙΒ)",
  "Ομόλογα (Ελληνικό Δημόσιο)",
  "Ομόλογα (Ελληνικού δημοσίου)",
  "Ομόλογα (ΕΝΤΟΚΑ ΓΡΑΜ. Ε. Δ.)",
  "Ομόλογα (ΕΤΕ ΑΕ)",
  "Ομόλογα (Ευρωπαϊκή Τράπεζα Επενδύσεων)",
  "Ομόλογα (Ευρωπαϊκή Τράπεζα Επενδύσεων)",
  "Ομόλογα (Ευρωπαϊκής Τράπεζας)",
  "ΟΜΟΛΟΓΑ (ΚΟΙΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2025",
  "Ομόλογα (κοινά με σύζυγο) - ΕΤΕ ΑΕ",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2023",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2024",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2026",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2027",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2028",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2029",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2030",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2031",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2032",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2033",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2034",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2035",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2036",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2037",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2038",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2039",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2040",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2041",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΕΔ 2012 - 2042",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΜΟΛΟΓΟ BN BNP 3Y",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΜΟΛΟΓΟ EFSF",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΣΥΖΥΓΟ) - ΟΜΟΛΟΓΟ ΕΘΝΙΚΗΣ ΤΡΑΠΕΖΑΣ",
  "ΟΜΟΛΟΓΑ (ΚΟΙΝΑ ΜΕ ΤΗΝ ΣΥΖΥΓΟ",
  "Ομόλογα (με σύζυγο) (Ε.Ι.Β)",
  "Ομόλογα (Ο.Ε.Δ)",
  "Ομόλογα (ΟΕΔ Λήξης 2023 - 2042)",
  "Ομόλογα (Ομόλογα Ελληνικού Δημοσίου)",
  "Ομόλογα (τίτλοι Α.Ε.Π.)",
  "Ομόλογα (τίτλοι Ο.Ε.Δ.)",
  "Ομόλογα (Τίτλος Α.Ε.Π.)",
  "Ομόλογα (Τίτλος Ο.Ε.Δ.)",
  "Ομόλογα FED CRD MUT Variable 15/12/2004 Perpetual",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2023",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2024",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2025",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2026",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2027",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2028",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2029",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2030",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2031",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2032",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2033",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2034",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2035",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2036",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2037",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2038",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2039",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2040",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2041",
  "Ομόλογα Hellenic-Rep Tax-Exempt Step CPN 24/02/2042",
  "Ομόλογα Hellenic-Rep Variable 15/10/42",
  "Ομόλογα Praktiker BAU-UN DEFAULTED",
  "Ομόλογα απο κοινού με σύζυγο - ΟΜΟΛΟΓΟ BNPP",
  "Ομόλογα Ε.Ι.Β.",
  "Ομόλογα Εθνική τράπεζα EFSF",
  "Ομόλογα κοινά με σύζυγο (Κρατικά Ομόλογα ERB HELLASCAYMAN)",
  "Ομόλογα με σύζυγο και τέκνο (BANK FED CRD MUT Variable 15/12/2004 Perpetual",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2023)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2024)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2025)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2026)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2027)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2028)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2029)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2030)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2031)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2032)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2033)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2034)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2035)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2036)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2037)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2038)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2039)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2040)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2041)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Tax-Exempt Step CPN 24/02/2042)",
  "Ομόλογα με σύζυγο και τέκνο (Hellenic-Rep Variable 15/10/42)",
  "Ομόλογα με σύζυγο και τέκνο (Praktiker BAU-UN DEFAULTED)",
  "Ομόλογα Ο.Ε.Δ.",
  "Ομόλογα, Ομολογίες, Μερίδια αμοιβαίων κεφαλαίων",
  "ΟΜΟΛΟΓΙΕΣ - BLACK ROCK CREDIT ALLOCATION",
  "ΟΜΟΛΟΓΙΕΣ - BLACKROCK CORPORATE HIGY YIE",
  "ΟΜΟΛΟΓΙΕΣ - BLACKROCK CREDIT ALLOCATION",
  "ΟΜΟΛΟΓΙΕΣ - CHOEN & STEERS LIMITED DURATION PREF",
  "ΟΜΟΛΟΓΙΕΣ - CHOEN & STEERS SELECT PREFER",
  "ΟΜΟΛΟΓΙΕΣ - CLEARBRIDGE REAL EST",
  "ΟΜΟΛΟΓΙΕΣ - COHEN & STEERS LIMITED DURATION PREF",
  "ΟΜΟΛΟΓΙΕΣ - COHEN & STEERS SELECT PREFER",
  "ΟΜΟΛΟΓΙΕΣ - GAMCO GLOBAL GOLD NATURE",
  "Ομολογίες - Hellenic Republic",
  "ΟΜΟΛΟΓΙΕΣ - HOCHTIEF AG 2.625% 28/05/2019",
  "ΟΜΟΛΟΓΙΕΣ - INVESCO S&P SMALLCAP LOW VOL",
  "ΟΜΟΛΟΓΙΕΣ - ISHARES BARCLEYS AGGREGATE",
  "ΟΜΟΛΟΓΙΕΣ - ISHARES GLOBAL CORPORATE BOND EUR",
  "ΟΜΟΛΟΓΙΕΣ - ISHARES TIPS ETF",
  "ΟΜΟΛΟΓΙΕΣ - RIOCAN REAL ESTATE INVESTMENT TRUST CN",
  "ΟΜΟΛΟΓΙΕΣ - SPDR GOLD TRUST",
  "ΟΜΟΛΟΓΙΕΣ - VANGUARD HIGH DVD YIELD ETF",
  "ΟΜΟΛΟΓΙΕΣ - VANGUARD LONG- TERM BOND ETF",
  "ΟΜΟΛΟΓΙΕΣ - VANGUARD TOTAL INTL BOND ETF",
  "ΟΜΟΛΟΓΙΕΣ (EUROPEAN INVESTMENT BANK)",
  "ΟΜΟΛΟΓΙΕΣ (Hellenic Republic EFSF)",
  "Ομολογίες Hellenic Republic - EFSF",
  "Ομόλογο",
  "Ομόλογο (Alpha Bank)",
  "Ομόλογο Ευρωπαϊκής Τράπεζας",
  "Ουδεμία μεταβολή",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝ ΟΜΙΚΑ - ALPHA FINANCE",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝ ΟΜΙΚΑ - BLACKROCK GL FDS EUR MKTS FD A2 C",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝ ΟΜΙΚΑ - BLACKROCK GL FDW EUR MKTS FD A2 - C",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝ ΟΜΙΚΑ - F TEMPETON WORLD PERSPECTIVES A C",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝ ΟΜΙΚΑ - FRANKLIN TEMP INV WLD PERSP A- C",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝ ΟΜΙΚΑ - ING (B)COLLECT PORT CORE FUND-C",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝ ΟΜΙΚΑ - ING B COLLECT CORE FUND BALANCED-C",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝ ΟΜΙΚΑ - NN L BANK INSURANCE P H.EUR- C",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝ ΟΜΙΚΑ - NN L INDUSTRIALS P - C",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝ ΟΜΙΚΑ - NN(L) INDUSTRIALS P - C",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝ ΟΜΙΚΑ - NN(L)BANK INSURANCE P H EUR - C",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝ ΟΜΙΚΑ - PIONEER FUNDS - EURO STRATEGIC LU0190665769",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝ ΟΜΙΚΑ - ΕΘΝΙΚΗ WARRANT ΕΤΕΤΠ",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝ ΟΜΙΚΑ - ΠΑΡΑΓΩΓΑ EUROBANK",
  "ΠΕΡΙΠΤΩΣΗ - America Fd.Shs A Cap.",
  "ΠΕΡΙΠΤΩΣΗ - COMMODITIES (HEDGER) EUR LU0823449425",
  "ΠΕΡΙΠΤΩΣΗ - GR FD",
  "ΠΕΡΙΠΤΩΣΗ - ΑΤΟΜΙΚΟ ΖΩΗΣ",
  "Πιστωτικός συν/σμός νομού Τρικάλων",
  "ΠΡΟΗΓΟΥΜΕΝΗ ΧΡΗΣΗ -",
  "Συνδικαιούχος σε Ομόλογα ΑLPHA BANK η αγορά των οποίων έγινε με χρήματα των συνδικαιούχων",
  "Συνεταιριστικές μερίδες",
  "Συνεταιριστικές μερίδες (Συνεταιριστική τράπεζα Ηπείρου)",
  "Συνεταιριστική Τράπεζα Καρδίτσας",
  "ΤΡ.ΠΕΙΡΑΙΩΣ BNPL1 VΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ - 350 PICTET GLOBAL EMERGING CURRENCIES",
  "ΤΡ.ΠΕΙΡΑΙΩΣ ΟΜΟΛΟΓΟ DEUTSCHLAND REP.",
  "ΤΡ.ΠΕΙΡΑΙΩΣ ΟΜΟΛΟΓΟ EUROPEAN INVESTEMENT BANK",
  "ΤΡΑΠΕΖΑ ΗΠΕΙΡΟΥ",
  "Χρυσές λύρες Αγγλίας",
]


export const new_types = [
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΜΕΤΟΧΕΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΜΕΤΟΧΕΣ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΟΜΟΛΟΓΑ",
  "ΜΕΤΟΧΕΣ",
  "ΜΕΤΟΧΕΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΜΕΤΟΧΕΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΤΟΧΕΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΜΕΤΟΧΕΣ",
  "ΜΕΤΟΧΕΣ",
  "ΜΕΤΟΧΕΣ",
  "ΜΕΤΟΧΕΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΜΕΤΟΧΕΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΜΕΤΟΧΕΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΟΜΟΛΟΓΑ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΜΕΤΟΧΕΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΤΟΧΕΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΜΕΤΟΧΕΣ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ ",
  "ΜΕΤΟΧΕΣ",

  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΤΟΧΕΣ",
  "ΜΕΤΟΧΕΣ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΑΛΛΟΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ ΗΜΕΔΑΠΩΝ ΜΗ ΕΙΣΗΓΜΕΝΩΝ ΕΤΑΙΡΙΩΝ",
  "ΜΕΤΟΧΕΣ",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ ΣΕ Ξ.Ν.",
  "ΜΕΤΟΧΕΣ",
  "ΜΕΤΟΧΕΣ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΙΕΣ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΟΥΔΕΜΙΑ ΜΕΤΑΒΟΛΗ",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΑ ΠΡΟΪΟΝΤΑ",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΑ ΠΡΟΪΟΝΤΑ",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΑ ΠΡΟΪΟΝΤΑ",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΑ ΠΡΟΪΟΝΤΑ",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΑ ΠΡΟΪΟΝΤΑ",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΑ ΠΡΟΪΟΝΤΑ",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΑ ΠΡΟΪΟΝΤΑ",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΑ ΠΡΟΪΟΝΤΑ",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΑ ΠΡΟΪΟΝΤΑ",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΑ ΠΡΟΪΟΝΤΑ",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΑ ΠΡΟΪΟΝΤΑ",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΑ ΠΡΟΪΟΝΤΑ",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΑ ΠΡΟΪΟΝΤΑ",
  "ΠΑΡΑΓΩΓΑ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΑ ΠΡΟΪΟΝΤΑ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΟΜΟΛΟΓΑ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΜΕΡΙΔΙΑ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ",
  "ΟΜΟΛΟΓΑ",
  "ΟΜΟΛΟΓΑ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
]